var os = Object.defineProperty, is = Object.defineProperties;
var as = Object.getOwnPropertyDescriptors;
var vr = Object.getOwnPropertySymbols;
var Io = Object.prototype.hasOwnProperty, ko = Object.prototype.propertyIsEnumerable;
var No = (t, e, n) => e in t ? os(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Te = (t, e) => {
  for (var n in e || (e = {}))
    Io.call(e, n) && No(t, n, e[n]);
  if (vr)
    for (var n of vr(e))
      ko.call(e, n) && No(t, n, e[n]);
  return t;
}, qe = (t, e) => is(t, as(e));
var Ct = (t, e) => {
  var n = {};
  for (var r in t)
    Io.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && vr)
    for (var r of vr(t))
      e.indexOf(r) < 0 && ko.call(t, r) && (n[r] = t[r]);
  return n;
};
import { jsx as te, jsxs as nt, Fragment as ss } from "react/jsx-runtime";
import { useFormContext as Ai, Controller as Di } from "react-hook-form";
import { Checkbox as ls, TextField as Sn, FormGroup as us, FormLabel as cs, Grid as Wr, IconButton as fs } from "@material-ui/core";
import * as g from "react";
import he, { Children as ds, isValidElement as yr, cloneElement as br, useState as Zt, useMemo as Xn } from "react";
import { v4 as ji } from "uuid";
import * as Mr from "react-dom";
import { c as kt } from "./clsx-0d472180.js";
import { B as Mo } from "./Button-1eab0617.js";
function Zn(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(e.indexOf(o) >= 0) && (n[o] = t[o]);
  return n;
}
function Se(t, e) {
  if (t == null)
    return {};
  var n = Zn(t, e), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (o = 0; o < i.length; o++)
      r = i[o], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function Ye(t) {
  "@babel/helpers - typeof";
  return Ye = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ye(t);
}
function ps(t, e) {
  if (Ye(t) !== "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (Ye(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Vi(t) {
  var e = ps(t, "string");
  return Ye(e) === "symbol" ? e : String(e);
}
function ze(t, e, n) {
  return e = Vi(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function M() {
  return M = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, M.apply(this, arguments);
}
function hs(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      if (this instanceof r) {
        var o = [null];
        o.push.apply(o, arguments);
        var i = Function.bind.apply(e, o);
        return new i();
      }
      return e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var d = {}, $o = {
  get exports() {
    return d;
  },
  set exports(t) {
    d = t;
  }
}, Er = {}, vs = {
  get exports() {
    return Er;
  },
  set exports(t) {
    Er = t;
  }
}, re = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ao;
function gs() {
  if (Ao)
    return re;
  Ao = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, v = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, S = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, T = t ? Symbol.for("react.scope") : 60119;
  function I(y) {
    if (typeof y == "object" && y !== null) {
      var _ = y.$$typeof;
      switch (_) {
        case e:
          switch (y = y.type, y) {
            case l:
            case u:
            case r:
            case i:
            case o:
            case f:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case c:
                case v:
                case h:
                case a:
                  return y;
                default:
                  return _;
              }
          }
        case n:
          return _;
      }
    }
  }
  function k(y) {
    return I(y) === u;
  }
  return re.AsyncMode = l, re.ConcurrentMode = u, re.ContextConsumer = s, re.ContextProvider = a, re.Element = e, re.ForwardRef = c, re.Fragment = r, re.Lazy = v, re.Memo = h, re.Portal = n, re.Profiler = i, re.StrictMode = o, re.Suspense = f, re.isAsyncMode = function(y) {
    return k(y) || I(y) === l;
  }, re.isConcurrentMode = k, re.isContextConsumer = function(y) {
    return I(y) === s;
  }, re.isContextProvider = function(y) {
    return I(y) === a;
  }, re.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, re.isForwardRef = function(y) {
    return I(y) === c;
  }, re.isFragment = function(y) {
    return I(y) === r;
  }, re.isLazy = function(y) {
    return I(y) === v;
  }, re.isMemo = function(y) {
    return I(y) === h;
  }, re.isPortal = function(y) {
    return I(y) === n;
  }, re.isProfiler = function(y) {
    return I(y) === i;
  }, re.isStrictMode = function(y) {
    return I(y) === o;
  }, re.isSuspense = function(y) {
    return I(y) === f;
  }, re.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === u || y === i || y === o || y === f || y === p || typeof y == "object" && y !== null && (y.$$typeof === v || y.$$typeof === h || y.$$typeof === a || y.$$typeof === s || y.$$typeof === c || y.$$typeof === S || y.$$typeof === b || y.$$typeof === T || y.$$typeof === m);
  }, re.typeOf = I, re;
}
var ne = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Do;
function ms() {
  return Do || (Do = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, v = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, S = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, T = t ? Symbol.for("react.scope") : 60119;
    function I(P) {
      return typeof P == "string" || typeof P == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      P === r || P === u || P === i || P === o || P === f || P === p || typeof P == "object" && P !== null && (P.$$typeof === v || P.$$typeof === h || P.$$typeof === a || P.$$typeof === s || P.$$typeof === c || P.$$typeof === S || P.$$typeof === b || P.$$typeof === T || P.$$typeof === m);
    }
    function k(P) {
      if (typeof P == "object" && P !== null) {
        var me = P.$$typeof;
        switch (me) {
          case e:
            var pe = P.type;
            switch (pe) {
              case l:
              case u:
              case r:
              case i:
              case o:
              case f:
                return pe;
              default:
                var Le = pe && pe.$$typeof;
                switch (Le) {
                  case s:
                  case c:
                  case v:
                  case h:
                  case a:
                    return Le;
                  default:
                    return me;
                }
            }
          case n:
            return me;
        }
      }
    }
    var y = l, _ = u, z = s, W = a, D = e, J = c, ie = r, ce = v, C = h, Z = n, fe = i, Q = o, ee = f, ae = !1;
    function xe(P) {
      return ae || (ae = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), w(P) || k(P) === l;
    }
    function w(P) {
      return k(P) === u;
    }
    function O(P) {
      return k(P) === s;
    }
    function A(P) {
      return k(P) === a;
    }
    function U(P) {
      return typeof P == "object" && P !== null && P.$$typeof === e;
    }
    function j(P) {
      return k(P) === c;
    }
    function q(P) {
      return k(P) === r;
    }
    function V(P) {
      return k(P) === v;
    }
    function B(P) {
      return k(P) === h;
    }
    function H(P) {
      return k(P) === n;
    }
    function K(P) {
      return k(P) === i;
    }
    function L(P) {
      return k(P) === o;
    }
    function N(P) {
      return k(P) === f;
    }
    ne.AsyncMode = y, ne.ConcurrentMode = _, ne.ContextConsumer = z, ne.ContextProvider = W, ne.Element = D, ne.ForwardRef = J, ne.Fragment = ie, ne.Lazy = ce, ne.Memo = C, ne.Portal = Z, ne.Profiler = fe, ne.StrictMode = Q, ne.Suspense = ee, ne.isAsyncMode = xe, ne.isConcurrentMode = w, ne.isContextConsumer = O, ne.isContextProvider = A, ne.isElement = U, ne.isForwardRef = j, ne.isFragment = q, ne.isLazy = V, ne.isMemo = B, ne.isPortal = H, ne.isProfiler = K, ne.isStrictMode = L, ne.isSuspense = N, ne.isValidElementType = I, ne.typeOf = k;
  }()), ne;
}
var jo;
function Qn() {
  return jo || (jo = 1, function(t) {
    process.env.NODE_ENV === "production" ? t.exports = gs() : t.exports = ms();
  }(vs)), Er;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ur, Vo;
function ys() {
  if (Vo)
    return Ur;
  Vo = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(c) {
        return a[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch (c) {
      return !1;
    }
  }
  return Ur = o() ? Object.assign : function(i, a) {
    for (var s, l = r(i), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var f in s)
        e.call(s, f) && (l[f] = s[f]);
      if (t) {
        u = t(s);
        for (var p = 0; p < u.length; p++)
          n.call(s, u[p]) && (l[u[p]] = s[u[p]]);
      }
    }
    return l;
  }, Ur;
}
var Br, Lo;
function eo() {
  if (Lo)
    return Br;
  Lo = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Br = t, Br;
}
var Hr, Fo;
function Li() {
  return Fo || (Fo = 1, Hr = Function.call.bind(Object.prototype.hasOwnProperty)), Hr;
}
var qr, zo;
function bs() {
  if (zo)
    return qr;
  zo = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = eo(), n = {}, r = Li();
    t = function(i) {
      var a = "Warning: " + i;
      typeof console != "undefined" && console.error(a);
      try {
        throw new Error(a);
      } catch (s) {
      }
    };
  }
  function o(i, a, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in i)
        if (r(i, c)) {
          var f;
          try {
            if (typeof i[c] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = i[c](a, c, l, s, null, e);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && t(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var h = u ? u() : "";
            t(
              "Failed " + s + " type: " + f.message + (h != null ? h : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, qr = o, qr;
}
var Yr, Wo;
function xs() {
  if (Wo)
    return Yr;
  Wo = 1;
  var t = Qn(), e = ys(), n = eo(), r = Li(), o = bs(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console != "undefined" && console.error(l);
    try {
      throw new Error(l);
    } catch (u) {
    }
  });
  function a() {
    return null;
  }
  return Yr = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(w) {
      var O = w && (u && w[u] || w[c]);
      if (typeof O == "function")
        return O;
    }
    var p = "<<anonymous>>", h = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: T(),
      arrayOf: I,
      element: k(),
      elementType: y(),
      instanceOf: _,
      node: J(),
      objectOf: W,
      oneOf: z,
      oneOfType: D,
      shape: ce,
      exact: C
    };
    function v(w, O) {
      return w === O ? w !== 0 || 1 / w === 1 / O : w !== w && O !== O;
    }
    function m(w, O) {
      this.message = w, this.data = O && typeof O == "object" ? O : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function S(w) {
      if (process.env.NODE_ENV !== "production")
        var O = {}, A = 0;
      function U(q, V, B, H, K, L, N) {
        if (H = H || p, L = L || B, N !== n) {
          if (l) {
            var P = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw P.name = "Invariant Violation", P;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var me = H + ":" + B;
            !O[me] && // Avoid spamming the console because they are often not actionable except for lib authors
            A < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + L + "` prop on `" + H + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), O[me] = !0, A++);
          }
        }
        return V[B] == null ? q ? V[B] === null ? new m("The " + K + " `" + L + "` is marked as required " + ("in `" + H + "`, but its value is `null`.")) : new m("The " + K + " `" + L + "` is marked as required in " + ("`" + H + "`, but its value is `undefined`.")) : null : w(V, B, H, K, L);
      }
      var j = U.bind(null, !1);
      return j.isRequired = U.bind(null, !0), j;
    }
    function b(w) {
      function O(A, U, j, q, V, B) {
        var H = A[U], K = Q(H);
        if (K !== w) {
          var L = ee(H);
          return new m(
            "Invalid " + q + " `" + V + "` of type " + ("`" + L + "` supplied to `" + j + "`, expected ") + ("`" + w + "`."),
            { expectedType: w }
          );
        }
        return null;
      }
      return S(O);
    }
    function T() {
      return S(a);
    }
    function I(w) {
      function O(A, U, j, q, V) {
        if (typeof w != "function")
          return new m("Property `" + V + "` of component `" + j + "` has invalid PropType notation inside arrayOf.");
        var B = A[U];
        if (!Array.isArray(B)) {
          var H = Q(B);
          return new m("Invalid " + q + " `" + V + "` of type " + ("`" + H + "` supplied to `" + j + "`, expected an array."));
        }
        for (var K = 0; K < B.length; K++) {
          var L = w(B, K, j, q, V + "[" + K + "]", n);
          if (L instanceof Error)
            return L;
        }
        return null;
      }
      return S(O);
    }
    function k() {
      function w(O, A, U, j, q) {
        var V = O[A];
        if (!s(V)) {
          var B = Q(V);
          return new m("Invalid " + j + " `" + q + "` of type " + ("`" + B + "` supplied to `" + U + "`, expected a single ReactElement."));
        }
        return null;
      }
      return S(w);
    }
    function y() {
      function w(O, A, U, j, q) {
        var V = O[A];
        if (!t.isValidElementType(V)) {
          var B = Q(V);
          return new m("Invalid " + j + " `" + q + "` of type " + ("`" + B + "` supplied to `" + U + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return S(w);
    }
    function _(w) {
      function O(A, U, j, q, V) {
        if (!(A[U] instanceof w)) {
          var B = w.name || p, H = xe(A[U]);
          return new m("Invalid " + q + " `" + V + "` of type " + ("`" + H + "` supplied to `" + j + "`, expected ") + ("instance of `" + B + "`."));
        }
        return null;
      }
      return S(O);
    }
    function z(w) {
      if (!Array.isArray(w))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function O(A, U, j, q, V) {
        for (var B = A[U], H = 0; H < w.length; H++)
          if (v(B, w[H]))
            return null;
        var K = JSON.stringify(w, function(N, P) {
          var me = ee(P);
          return me === "symbol" ? String(P) : P;
        });
        return new m("Invalid " + q + " `" + V + "` of value `" + String(B) + "` " + ("supplied to `" + j + "`, expected one of " + K + "."));
      }
      return S(O);
    }
    function W(w) {
      function O(A, U, j, q, V) {
        if (typeof w != "function")
          return new m("Property `" + V + "` of component `" + j + "` has invalid PropType notation inside objectOf.");
        var B = A[U], H = Q(B);
        if (H !== "object")
          return new m("Invalid " + q + " `" + V + "` of type " + ("`" + H + "` supplied to `" + j + "`, expected an object."));
        for (var K in B)
          if (r(B, K)) {
            var L = w(B, K, j, q, V + "." + K, n);
            if (L instanceof Error)
              return L;
          }
        return null;
      }
      return S(O);
    }
    function D(w) {
      if (!Array.isArray(w))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var O = 0; O < w.length; O++) {
        var A = w[O];
        if (typeof A != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ae(A) + " at index " + O + "."
          ), a;
      }
      function U(j, q, V, B, H) {
        for (var K = [], L = 0; L < w.length; L++) {
          var N = w[L], P = N(j, q, V, B, H, n);
          if (P == null)
            return null;
          P.data && r(P.data, "expectedType") && K.push(P.data.expectedType);
        }
        var me = K.length > 0 ? ", expected one of type [" + K.join(", ") + "]" : "";
        return new m("Invalid " + B + " `" + H + "` supplied to " + ("`" + V + "`" + me + "."));
      }
      return S(U);
    }
    function J() {
      function w(O, A, U, j, q) {
        return Z(O[A]) ? null : new m("Invalid " + j + " `" + q + "` supplied to " + ("`" + U + "`, expected a ReactNode."));
      }
      return S(w);
    }
    function ie(w, O, A, U, j) {
      return new m(
        (w || "React class") + ": " + O + " type `" + A + "." + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + j + "`."
      );
    }
    function ce(w) {
      function O(A, U, j, q, V) {
        var B = A[U], H = Q(B);
        if (H !== "object")
          return new m("Invalid " + q + " `" + V + "` of type `" + H + "` " + ("supplied to `" + j + "`, expected `object`."));
        for (var K in w) {
          var L = w[K];
          if (typeof L != "function")
            return ie(j, q, V, K, ee(L));
          var N = L(B, K, j, q, V + "." + K, n);
          if (N)
            return N;
        }
        return null;
      }
      return S(O);
    }
    function C(w) {
      function O(A, U, j, q, V) {
        var B = A[U], H = Q(B);
        if (H !== "object")
          return new m("Invalid " + q + " `" + V + "` of type `" + H + "` " + ("supplied to `" + j + "`, expected `object`."));
        var K = e({}, A[U], w);
        for (var L in K) {
          var N = w[L];
          if (r(w, L) && typeof N != "function")
            return ie(j, q, V, L, ee(N));
          if (!N)
            return new m(
              "Invalid " + q + " `" + V + "` key `" + L + "` supplied to `" + j + "`.\nBad object: " + JSON.stringify(A[U], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(w), null, "  ")
            );
          var P = N(B, L, j, q, V + "." + L, n);
          if (P)
            return P;
        }
        return null;
      }
      return S(O);
    }
    function Z(w) {
      switch (typeof w) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !w;
        case "object":
          if (Array.isArray(w))
            return w.every(Z);
          if (w === null || s(w))
            return !0;
          var O = f(w);
          if (O) {
            var A = O.call(w), U;
            if (O !== w.entries) {
              for (; !(U = A.next()).done; )
                if (!Z(U.value))
                  return !1;
            } else
              for (; !(U = A.next()).done; ) {
                var j = U.value;
                if (j && !Z(j[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function fe(w, O) {
      return w === "symbol" ? !0 : O ? O["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && O instanceof Symbol : !1;
    }
    function Q(w) {
      var O = typeof w;
      return Array.isArray(w) ? "array" : w instanceof RegExp ? "object" : fe(O, w) ? "symbol" : O;
    }
    function ee(w) {
      if (typeof w == "undefined" || w === null)
        return "" + w;
      var O = Q(w);
      if (O === "object") {
        if (w instanceof Date)
          return "date";
        if (w instanceof RegExp)
          return "regexp";
      }
      return O;
    }
    function ae(w) {
      var O = ee(w);
      switch (O) {
        case "array":
        case "object":
          return "an " + O;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + O;
        default:
          return O;
      }
    }
    function xe(w) {
      return !w.constructor || !w.constructor.name ? p : w.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, Yr;
}
var Kr, Uo;
function Es() {
  if (Uo)
    return Kr;
  Uo = 1;
  var t = eo();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, Kr = function() {
    function r(a, s, l, u, c, f) {
      if (f !== t) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, Kr;
}
if (process.env.NODE_ENV !== "production") {
  var Ss = Qn(), ws = !0;
  $o.exports = xs()(Ss.isElement, ws);
} else
  $o.exports = Es()();
function Fi(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (n = Fi(t[e])) && (r && (r += " "), r += n);
    else
      for (e in t)
        t[e] && (r && (r += " "), r += e);
  return r;
}
function be() {
  for (var t, e, n = 0, r = ""; n < arguments.length; )
    (t = arguments[n++]) && (e = Fi(t)) && (r && (r += " "), r += e);
  return r;
}
function jt(t, e) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function() {
    return t.apply(void 0, arguments) || e.apply(void 0, arguments);
  };
}
function Gr(t) {
  return t && Ye(t) === "object" && t.constructor === Object;
}
function Mt(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    clone: !0
  }, r = n.clone ? M({}, t) : t;
  return Gr(t) && Gr(e) && Object.keys(e).forEach(function(o) {
    o !== "__proto__" && (Gr(e[o]) && o in t ? r[o] = Mt(t[o], e[o], n) : r[o] = e[o]);
  }), r;
}
function Os(t) {
  var e = t.prototype, n = e === void 0 ? {} : e;
  return !!n.isReactComponent;
}
function Rs(t, e, n, r, o) {
  var i = t[e], a = o || e;
  if (i == null)
    return null;
  var s;
  return typeof i == "function" && !Os(i) && (s = "Did you accidentally provide a plain function component instead?"), s !== void 0 ? new Error("Invalid ".concat(r, " `").concat(a, "` supplied to `").concat(n, "`. ") + "Expected an element type that can hold a ref. ".concat(s, " ") + "For more information see https://mui.com/r/caveat-with-refs-guide") : null;
}
const Ts = jt(d.elementType, Rs);
var Cs = "exact-prop: ​";
function zi(t) {
  return process.env.NODE_ENV === "production" ? t : M({}, t, ze({}, Cs, function(e) {
    var n = Object.keys(e).filter(function(r) {
      return !t.hasOwnProperty(r);
    });
    return n.length > 0 ? new Error("The following props are not supported: ".concat(n.map(function(r) {
      return "`".concat(r, "`");
    }).join(", "), ". Please remove them.")) : null;
  }));
}
function Sr(t) {
  for (var e = "https://mui.com/production-error/?code=" + t, n = 1; n < arguments.length; n += 1)
    e += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified Material-UI error #" + t + "; visit " + e + " for the full message.";
}
var wr = {}, Ps = {
  get exports() {
    return wr;
  },
  set exports(t) {
    wr = t;
  }
}, le = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bo;
function _s() {
  if (Bo)
    return le;
  Bo = 1;
  var t = 60103, e = 60106, n = 60107, r = 60108, o = 60114, i = 60109, a = 60110, s = 60112, l = 60113, u = 60120, c = 60115, f = 60116, p = 60121, h = 60122, v = 60117, m = 60129, S = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var b = Symbol.for;
    t = b("react.element"), e = b("react.portal"), n = b("react.fragment"), r = b("react.strict_mode"), o = b("react.profiler"), i = b("react.provider"), a = b("react.context"), s = b("react.forward_ref"), l = b("react.suspense"), u = b("react.suspense_list"), c = b("react.memo"), f = b("react.lazy"), p = b("react.block"), h = b("react.server.block"), v = b("react.fundamental"), m = b("react.debug_trace_mode"), S = b("react.legacy_hidden");
  }
  function T(C) {
    if (typeof C == "object" && C !== null) {
      var Z = C.$$typeof;
      switch (Z) {
        case t:
          switch (C = C.type, C) {
            case n:
            case o:
            case r:
            case l:
            case u:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case a:
                case s:
                case f:
                case c:
                case i:
                  return C;
                default:
                  return Z;
              }
          }
        case e:
          return Z;
      }
    }
  }
  var I = i, k = t, y = s, _ = n, z = f, W = c, D = e, J = o, ie = r, ce = l;
  return le.ContextConsumer = a, le.ContextProvider = I, le.Element = k, le.ForwardRef = y, le.Fragment = _, le.Lazy = z, le.Memo = W, le.Portal = D, le.Profiler = J, le.StrictMode = ie, le.Suspense = ce, le.isAsyncMode = function() {
    return !1;
  }, le.isConcurrentMode = function() {
    return !1;
  }, le.isContextConsumer = function(C) {
    return T(C) === a;
  }, le.isContextProvider = function(C) {
    return T(C) === i;
  }, le.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, le.isForwardRef = function(C) {
    return T(C) === s;
  }, le.isFragment = function(C) {
    return T(C) === n;
  }, le.isLazy = function(C) {
    return T(C) === f;
  }, le.isMemo = function(C) {
    return T(C) === c;
  }, le.isPortal = function(C) {
    return T(C) === e;
  }, le.isProfiler = function(C) {
    return T(C) === o;
  }, le.isStrictMode = function(C) {
    return T(C) === r;
  }, le.isSuspense = function(C) {
    return T(C) === l;
  }, le.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === o || C === m || C === r || C === l || C === u || C === S || typeof C == "object" && C !== null && (C.$$typeof === f || C.$$typeof === c || C.$$typeof === i || C.$$typeof === a || C.$$typeof === s || C.$$typeof === v || C.$$typeof === p || C[0] === h);
  }, le.typeOf = T, le;
}
var ue = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ho;
function Ns() {
  return Ho || (Ho = 1, process.env.NODE_ENV !== "production" && function() {
    var t = 60103, e = 60106, n = 60107, r = 60108, o = 60114, i = 60109, a = 60110, s = 60112, l = 60113, u = 60120, c = 60115, f = 60116, p = 60121, h = 60122, v = 60117, m = 60129, S = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var b = Symbol.for;
      t = b("react.element"), e = b("react.portal"), n = b("react.fragment"), r = b("react.strict_mode"), o = b("react.profiler"), i = b("react.provider"), a = b("react.context"), s = b("react.forward_ref"), l = b("react.suspense"), u = b("react.suspense_list"), c = b("react.memo"), f = b("react.lazy"), p = b("react.block"), h = b("react.server.block"), v = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), m = b("react.debug_trace_mode"), b("react.offscreen"), S = b("react.legacy_hidden");
    }
    var T = !1;
    function I(N) {
      return !!(typeof N == "string" || typeof N == "function" || N === n || N === o || N === m || N === r || N === l || N === u || N === S || T || typeof N == "object" && N !== null && (N.$$typeof === f || N.$$typeof === c || N.$$typeof === i || N.$$typeof === a || N.$$typeof === s || N.$$typeof === v || N.$$typeof === p || N[0] === h));
    }
    function k(N) {
      if (typeof N == "object" && N !== null) {
        var P = N.$$typeof;
        switch (P) {
          case t:
            var me = N.type;
            switch (me) {
              case n:
              case o:
              case r:
              case l:
              case u:
                return me;
              default:
                var pe = me && me.$$typeof;
                switch (pe) {
                  case a:
                  case s:
                  case f:
                  case c:
                  case i:
                    return pe;
                  default:
                    return P;
                }
            }
          case e:
            return P;
        }
      }
    }
    var y = a, _ = i, z = t, W = s, D = n, J = f, ie = c, ce = e, C = o, Z = r, fe = l, Q = !1, ee = !1;
    function ae(N) {
      return Q || (Q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function xe(N) {
      return ee || (ee = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function w(N) {
      return k(N) === a;
    }
    function O(N) {
      return k(N) === i;
    }
    function A(N) {
      return typeof N == "object" && N !== null && N.$$typeof === t;
    }
    function U(N) {
      return k(N) === s;
    }
    function j(N) {
      return k(N) === n;
    }
    function q(N) {
      return k(N) === f;
    }
    function V(N) {
      return k(N) === c;
    }
    function B(N) {
      return k(N) === e;
    }
    function H(N) {
      return k(N) === o;
    }
    function K(N) {
      return k(N) === r;
    }
    function L(N) {
      return k(N) === l;
    }
    ue.ContextConsumer = y, ue.ContextProvider = _, ue.Element = z, ue.ForwardRef = W, ue.Fragment = D, ue.Lazy = J, ue.Memo = ie, ue.Portal = ce, ue.Profiler = C, ue.StrictMode = Z, ue.Suspense = fe, ue.isAsyncMode = ae, ue.isConcurrentMode = xe, ue.isContextConsumer = w, ue.isContextProvider = O, ue.isElement = A, ue.isForwardRef = U, ue.isFragment = j, ue.isLazy = q, ue.isMemo = V, ue.isPortal = B, ue.isProfiler = H, ue.isStrictMode = K, ue.isSuspense = L, ue.isValidElementType = I, ue.typeOf = k;
  }()), ue;
}
(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = _s() : t.exports = Ns();
})(Ps);
var Is = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function ks(t) {
  var e = "".concat(t).match(Is), n = e && e[1];
  return n || "";
}
function Wi(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return t.displayName || t.name || ks(t) || e;
}
function qo(t, e, n) {
  var r = Wi(e);
  return t.displayName || (r !== "" ? "".concat(n, "(").concat(r, ")") : n);
}
function tr(t) {
  if (t != null) {
    if (typeof t == "string")
      return t;
    if (typeof t == "function")
      return Wi(t, "Component");
    if (Ye(t) === "object")
      switch (t.$$typeof) {
        case wr.ForwardRef:
          return qo(t, t.render, "ForwardRef");
        case wr.Memo:
          return qo(t, t.type, "memo");
        default:
          return;
      }
  }
}
function wn(t, e, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  var i = t[e], a = o || e;
  return i == null ? null : i && i.nodeType !== 1 ? new Error("Invalid ".concat(r, " `").concat(a, "` supplied to `").concat(n, "`. ") + "Expected an HTMLElement.") : null;
}
var Ms = d.oneOfType([d.func, d.object]);
const On = Ms;
function to(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return process.env.NODE_ENV !== "production" && (t < e || t > n) && console.error("Material-UI: The value provided ".concat(t, " is out of range [").concat(e, ", ").concat(n, "].")), Math.min(Math.max(e, t), n);
}
function $s(t) {
  t = t.substr(1);
  var e = new RegExp(".{1,".concat(t.length >= 6 ? 2 : 1, "}"), "g"), n = t.match(e);
  return n && n[0].length === 1 && (n = n.map(function(r) {
    return r + r;
  })), n ? "rgb".concat(n.length === 4 ? "a" : "", "(").concat(n.map(function(r, o) {
    return o < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3;
  }).join(", "), ")") : "";
}
function As(t) {
  t = mt(t);
  var e = t, n = e.values, r = n[0], o = n[1] / 100, i = n[2] / 100, a = o * Math.min(i, 1 - i), s = function(f) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (f + r / 30) % 12;
    return i - a * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  }, l = "rgb", u = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return t.type === "hsla" && (l += "a", u.push(n[3])), $r({
    type: l,
    values: u
  });
}
function mt(t) {
  if (t.type)
    return t;
  if (t.charAt(0) === "#")
    return mt($s(t));
  var e = t.indexOf("("), n = t.substring(0, e);
  if (["rgb", "rgba", "hsl", "hsla"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(t, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : Sr(3, t));
  var r = t.substring(e + 1, t.length - 1).split(",");
  return r = r.map(function(o) {
    return parseFloat(o);
  }), {
    type: n,
    values: r
  };
}
function $r(t) {
  var e = t.type, n = t.values;
  return e.indexOf("rgb") !== -1 ? n = n.map(function(r, o) {
    return o < 3 ? parseInt(r, 10) : r;
  }) : e.indexOf("hsl") !== -1 && (n[1] = "".concat(n[1], "%"), n[2] = "".concat(n[2], "%")), "".concat(e, "(").concat(n.join(", "), ")");
}
function Yo(t, e) {
  var n = Rn(t), r = Rn(e);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function Rn(t) {
  t = mt(t);
  var e = t.type === "hsl" ? mt(As(t)).values : t.values;
  return e = e.map(function(n) {
    return n /= 255, n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
  }), Number((0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2]).toFixed(3));
}
function Pt(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.15;
  return Rn(t) > 0.5 ? Or(t, e) : Rr(t, e);
}
function $e(t, e) {
  return t = mt(t), e = to(e), (t.type === "rgb" || t.type === "hsl") && (t.type += "a"), t.values[3] = e, $r(t);
}
function Or(t, e) {
  if (t = mt(t), e = to(e), t.type.indexOf("hsl") !== -1)
    t.values[2] *= 1 - e;
  else if (t.type.indexOf("rgb") !== -1)
    for (var n = 0; n < 3; n += 1)
      t.values[n] *= 1 - e;
  return $r(t);
}
function Rr(t, e) {
  if (t = mt(t), e = to(e), t.type.indexOf("hsl") !== -1)
    t.values[2] += (100 - t.values[2]) * e;
  else if (t.type.indexOf("rgb") !== -1)
    for (var n = 0; n < 3; n += 1)
      t.values[n] += (255 - t.values[n]) * e;
  return $r(t);
}
var tt = ["xs", "sm", "md", "lg", "xl"];
function Ds(t) {
  var e = t.values, n = e === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : e, r = t.unit, o = r === void 0 ? "px" : r, i = t.step, a = i === void 0 ? 5 : i, s = Se(t, ["values", "unit", "step"]);
  function l(v) {
    var m = typeof n[v] == "number" ? n[v] : v;
    return "@media (min-width:".concat(m).concat(o, ")");
  }
  function u(v) {
    var m = tt.indexOf(v) + 1, S = n[tt[m]];
    if (m === tt.length)
      return l("xs");
    var b = typeof S == "number" && m > 0 ? S : v;
    return "@media (max-width:".concat(b - a / 100).concat(o, ")");
  }
  function c(v, m) {
    var S = tt.indexOf(m);
    return S === tt.length - 1 ? l(v) : "@media (min-width:".concat(typeof n[v] == "number" ? n[v] : v).concat(o, ") and ") + "(max-width:".concat((S !== -1 && typeof n[tt[S + 1]] == "number" ? n[tt[S + 1]] : m) - a / 100).concat(o, ")");
  }
  function f(v) {
    return c(v, v);
  }
  var p = !1;
  function h(v) {
    return process.env.NODE_ENV !== "production" && (p || (p = !0, console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", "Use the `theme.breakpoints.values` instead."].join(`
`)))), n[v];
  }
  return M({
    keys: tt,
    values: n,
    up: l,
    down: u,
    between: c,
    only: f,
    width: h
  }, s);
}
function js(t, e, n) {
  var r;
  return M({
    gutters: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return console.warn(["Material-UI: theme.mixins.gutters() is deprecated.", "You can use the source of the mixin directly:", `
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
      `].join(`
`)), M({
        paddingLeft: e(2),
        paddingRight: e(2)
      }, i, ze({}, t.up("sm"), M({
        paddingLeft: e(3),
        paddingRight: e(3)
      }, i[t.up("sm")])));
    },
    toolbar: (r = {
      minHeight: 56
    }, ze(r, "".concat(t.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), ze(r, t.up("sm"), {
      minHeight: 64
    }), r)
  }, n);
}
var Vs = {
  black: "#000",
  white: "#fff"
};
const Tr = Vs;
var Ls = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#d5d5d5",
  A200: "#aaaaaa",
  A400: "#303030",
  A700: "#616161"
};
const ro = Ls;
var Fs = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
};
const Jr = Fs;
var zs = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
};
const Xr = zs;
var Ws = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
};
const Zr = Ws;
var Us = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
};
const Qr = Us;
var Bs = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
};
const en = Bs;
var Hs = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
const tn = Hs;
var Ko = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.54)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)",
    // Text hints.
    hint: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: Tr.white,
    default: ro[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, rn = {
  text: {
    primary: Tr.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    hint: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: ro[800],
    default: "#303030"
  },
  action: {
    active: Tr.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function Go(t, e, n, r) {
  var o = r.light || r, i = r.dark || r * 1.5;
  t[e] || (t.hasOwnProperty(n) ? t[e] = t[n] : e === "light" ? t.light = Rr(t.main, o) : e === "dark" && (t.dark = Or(t.main, i)));
}
function qs(t) {
  var e = t.primary, n = e === void 0 ? {
    light: Jr[300],
    main: Jr[500],
    dark: Jr[700]
  } : e, r = t.secondary, o = r === void 0 ? {
    light: Xr.A200,
    main: Xr.A400,
    dark: Xr.A700
  } : r, i = t.error, a = i === void 0 ? {
    light: Zr[300],
    main: Zr[500],
    dark: Zr[700]
  } : i, s = t.warning, l = s === void 0 ? {
    light: Qr[300],
    main: Qr[500],
    dark: Qr[700]
  } : s, u = t.info, c = u === void 0 ? {
    light: en[300],
    main: en[500],
    dark: en[700]
  } : u, f = t.success, p = f === void 0 ? {
    light: tn[300],
    main: tn[500],
    dark: tn[700]
  } : f, h = t.type, v = h === void 0 ? "light" : h, m = t.contrastThreshold, S = m === void 0 ? 3 : m, b = t.tonalOffset, T = b === void 0 ? 0.2 : b, I = Se(t, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function k(W) {
    var D = Yo(W, rn.text.primary) >= S ? rn.text.primary : Ko.text.primary;
    if (process.env.NODE_ENV !== "production") {
      var J = Yo(W, D);
      J < 3 && console.error(["Material-UI: The contrast ratio of ".concat(J, ":1 for ").concat(D, " on ").concat(W), "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return D;
  }
  var y = function(D) {
    var J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, ie = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300, ce = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 700;
    if (D = M({}, D), !D.main && D[J] && (D.main = D[J]), !D.main)
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(J, "` property.") : Sr(4, J));
    if (typeof D.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(D.main), `\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@material-ui/core/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`) : Sr(5, JSON.stringify(D.main)));
    return Go(D, "light", ie, T), Go(D, "dark", ce, T), D.contrastText || (D.contrastText = k(D.main)), D;
  }, _ = {
    dark: rn,
    light: Ko
  };
  process.env.NODE_ENV !== "production" && (_[v] || console.error("Material-UI: The palette type `".concat(v, "` is not supported.")));
  var z = Mt(M({
    // A collection of common colors.
    common: Tr,
    // The palette type, can be light or dark.
    type: v,
    // The colors used to represent primary interface elements for a user.
    primary: y(n),
    // The colors used to represent secondary interface elements for a user.
    secondary: y(o, "A400", "A200", "A700"),
    // The colors used to represent interface elements that the user should be made aware of.
    error: y(a),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: y(l),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: y(c),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: y(p),
    // The grey colors.
    grey: ro,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: S,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: k,
    // Generate a rich color object.
    augmentColor: y,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: T
  }, _[v]), I);
  return z;
}
function Ui(t) {
  return Math.round(t * 1e5) / 1e5;
}
var Jo = !1;
function Ys(t) {
  return process.env.NODE_ENV !== "production" && (Jo || (console.warn(["Material-UI: The `theme.typography.round` helper is deprecated.", "Head to https://mui.com/r/migration-v4/#theme for a migration path."].join(`
`)), Jo = !0)), Ui(t);
}
var Xo = {
  textTransform: "uppercase"
}, Zo = '"Roboto", "Helvetica", "Arial", sans-serif';
function Ks(t, e) {
  var n = typeof e == "function" ? e(t) : e, r = n.fontFamily, o = r === void 0 ? Zo : r, i = n.fontSize, a = i === void 0 ? 14 : i, s = n.fontWeightLight, l = s === void 0 ? 300 : s, u = n.fontWeightRegular, c = u === void 0 ? 400 : u, f = n.fontWeightMedium, p = f === void 0 ? 500 : f, h = n.fontWeightBold, v = h === void 0 ? 700 : h, m = n.htmlFontSize, S = m === void 0 ? 16 : m, b = n.allVariants, T = n.pxToRem, I = Se(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  process.env.NODE_ENV !== "production" && (typeof a != "number" && console.error("Material-UI: `fontSize` is required to be a number."), typeof S != "number" && console.error("Material-UI: `htmlFontSize` is required to be a number."));
  var k = a / 14, y = T || function(W) {
    return "".concat(W / S * k, "rem");
  }, _ = function(D, J, ie, ce, C) {
    return M({
      fontFamily: o,
      fontWeight: D,
      fontSize: y(J),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: ie
    }, o === Zo ? {
      letterSpacing: "".concat(Ui(ce / J), "em")
    } : {}, C, b);
  }, z = {
    h1: _(l, 96, 1.167, -1.5),
    h2: _(l, 60, 1.2, -0.5),
    h3: _(c, 48, 1.167, 0),
    h4: _(c, 34, 1.235, 0.25),
    h5: _(c, 24, 1.334, 0),
    h6: _(p, 20, 1.6, 0.15),
    subtitle1: _(c, 16, 1.75, 0.15),
    subtitle2: _(p, 14, 1.57, 0.1),
    body1: _(c, 16, 1.5, 0.15),
    body2: _(c, 14, 1.43, 0.15),
    button: _(p, 14, 1.75, 0.4, Xo),
    caption: _(c, 12, 1.66, 0.4),
    overline: _(c, 12, 2.66, 1, Xo)
  };
  return Mt(M({
    htmlFontSize: S,
    pxToRem: y,
    round: Ys,
    // TODO v5: remove
    fontFamily: o,
    fontSize: a,
    fontWeightLight: l,
    fontWeightRegular: c,
    fontWeightMedium: p,
    fontWeightBold: v
  }, z), I, {
    clone: !1
    // No need to clone deep
  });
}
var Gs = 0.2, Js = 0.14, Xs = 0.12;
function ge() {
  return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(Gs, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(Js, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(Xs, ")")].join(",");
}
var Zs = ["none", ge(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), ge(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), ge(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), ge(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), ge(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), ge(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), ge(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), ge(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), ge(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), ge(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), ge(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), ge(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), ge(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), ge(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), ge(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), ge(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), ge(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), ge(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), ge(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), ge(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), ge(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), ge(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), ge(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), ge(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const Qs = Zs;
var el = {
  borderRadius: 4
};
const tl = el;
var rl = process.env.NODE_ENV !== "production" ? d.oneOfType([d.number, d.string, d.object, d.array]) : {};
const nl = rl;
function Tn(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function ol(t) {
  if (Array.isArray(t))
    return Tn(t);
}
function il(t) {
  if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function Bi(t, e) {
  if (t) {
    if (typeof t == "string")
      return Tn(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Tn(t, e);
  }
}
function al() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hi(t) {
  return ol(t) || il(t) || Bi(t) || al();
}
function sl(t) {
  if (Array.isArray(t))
    return t;
}
function ll(t, e) {
  var n = t == null ? null : typeof Symbol != "undefined" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, u = !1;
    try {
      if (i = (n = n.call(t)).next, e === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== e); l = !0)
          ;
    } catch (c) {
      u = !0, o = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (u)
          throw o;
      }
    }
    return s;
  }
}
function ul() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nn(t, e) {
  return sl(t) || ll(t, e) || Bi(t, e) || ul();
}
var cl = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
function fl(t) {
  var e = t.spacing || 8;
  return typeof e == "number" ? function(n) {
    return process.env.NODE_ENV !== "production" && typeof n != "number" && console.error("Material-UI: Expected spacing argument to be a number, got ".concat(n, ".")), e * n;
  } : Array.isArray(e) ? function(n) {
    return process.env.NODE_ENV !== "production" && n > e.length - 1 && console.error(["Material-UI: The value provided (".concat(n, ") overflows."), "The supported values are: ".concat(JSON.stringify(e), "."), "".concat(n, " > ").concat(e.length - 1, ", you need to add the missing values.")].join(`
`)), e[n];
  } : typeof e == "function" ? e : (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `theme.spacing` value (".concat(e, ") is invalid."), "It should be a number, an array or a function."].join(`
`)), function() {
  });
}
process.env.NODE_ENV !== "production" && cl.reduce(function(t, e) {
  return t[e] = nl, t;
}, {});
var Qo;
function dl() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
  if (t.mui)
    return t;
  var e = fl({
    spacing: t
  }), n = function() {
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return process.env.NODE_ENV !== "production" && (i.length <= 4 || console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(i.length))), i.length === 0 ? e(1) : i.length === 1 ? e(i[0]) : i.map(function(s) {
      if (typeof s == "string")
        return s;
      var l = e(s);
      return typeof l == "number" ? "".concat(l, "px") : l;
    }).join(" ");
  };
  return Object.defineProperty(n, "unit", {
    get: function() {
      return process.env.NODE_ENV !== "production" && ((!Qo || process.env.NODE_ENV === "test") && console.error(["Material-UI: theme.spacing.unit usage has been deprecated.", "It will be removed in v5.", "You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.", "", "You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother."].join(`
`)), Qo = !0), t;
    }
  }), n.mui = !0, n;
}
var ei = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, ti = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function ri(t) {
  return "".concat(Math.round(t), "ms");
}
const pl = {
  easing: ei,
  duration: ti,
  create: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["all"], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.duration, o = r === void 0 ? ti.standard : r, i = n.easing, a = i === void 0 ? ei.easeInOut : i, s = n.delay, l = s === void 0 ? 0 : s, u = Se(n, ["duration", "easing", "delay"]);
    if (process.env.NODE_ENV !== "production") {
      var c = function(h) {
        return typeof h == "string";
      }, f = function(h) {
        return !isNaN(parseFloat(h));
      };
      !c(e) && !Array.isArray(e) && console.error('Material-UI: Argument "props" must be a string or Array.'), !f(o) && !c(o) && console.error('Material-UI: Argument "duration" must be a number or a string but found '.concat(o, ".")), c(a) || console.error('Material-UI: Argument "easing" must be a string.'), !f(l) && !c(l) && console.error('Material-UI: Argument "delay" must be a number or a string.'), Object.keys(u).length !== 0 && console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(u).join(","), "]."));
    }
    return (Array.isArray(e) ? e : [e]).map(function(p) {
      return "".concat(p, " ").concat(typeof o == "string" ? o : ri(o), " ").concat(a, " ").concat(typeof l == "string" ? l : ri(l));
    }).join(",");
  },
  getAutoHeightDuration: function(e) {
    if (!e)
      return 0;
    var n = e / 36;
    return Math.round((4 + 15 * Math.pow(n, 0.25) + n / 5) * 10);
  }
};
var hl = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
const vl = hl;
function gl() {
  for (var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.breakpoints, n = e === void 0 ? {} : e, r = t.mixins, o = r === void 0 ? {} : r, i = t.palette, a = i === void 0 ? {} : i, s = t.spacing, l = t.typography, u = l === void 0 ? {} : l, c = Se(t, ["breakpoints", "mixins", "palette", "spacing", "typography"]), f = qs(a), p = Ds(n), h = dl(s), v = Mt({
    breakpoints: p,
    direction: "ltr",
    mixins: js(p, h, o),
    overrides: {},
    // Inject custom styles
    palette: f,
    props: {},
    // Provide default props
    shadows: Qs,
    typography: Ks(f, u),
    spacing: h,
    shape: tl,
    transitions: pl,
    zIndex: vl
  }, c), m = arguments.length, S = new Array(m > 1 ? m - 1 : 0), b = 1; b < m; b++)
    S[b - 1] = arguments[b];
  if (v = S.reduce(function(k, y) {
    return Mt(k, y);
  }, v), process.env.NODE_ENV !== "production") {
    var T = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"], I = function k(y, _) {
      var z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, W;
      for (W in y) {
        var D = y[W];
        z === 1 ? W.indexOf("Mui") === 0 && D && k(D, W, z + 1) : T.indexOf(W) !== -1 && Object.keys(D).length > 0 && (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `".concat(_, "` component increases ") + "the CSS specificity of the `".concat(W, "` internal state."), "You can not override it like this: ", JSON.stringify(y, null, 2), "", "Instead, you need to use the $ruleName syntax:", JSON.stringify({
          root: ze({}, "&$".concat(W), D)
        }, null, 2), "", "https://mui.com/r/pseudo-classes-guide"].join(`
`)), y[W] = {});
      }
    };
    I(v.overrides);
  }
  return v;
}
var ml = typeof Symbol == "function" && Symbol.for;
const yl = ml ? Symbol.for("mui.nested") : "__THEME_NESTED__";
var bl = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function xl() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.disableGlobal, n = e === void 0 ? !1 : e, r = t.productionPrefix, o = r === void 0 ? "jss" : r, i = t.seed, a = i === void 0 ? "" : i, s = a === "" ? "" : "".concat(a, "-"), l = 0, u = function() {
    return l += 1, process.env.NODE_ENV !== "production" && l >= 1e10 && console.warn(["Material-UI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), l;
  };
  return function(c, f) {
    var p = f.options.name;
    if (p && p.indexOf("Mui") === 0 && !f.options.link && !n) {
      if (bl.indexOf(c.key) !== -1)
        return "Mui-".concat(c.key);
      var h = "".concat(s).concat(p, "-").concat(c.key);
      return !f.options.theme[yl] || a !== "" ? h : "".concat(h, "-").concat(u());
    }
    if (process.env.NODE_ENV === "production")
      return "".concat(s).concat(o).concat(u());
    var v = "".concat(c.key, "-").concat(u());
    return f.options.classNamePrefix ? "".concat(s).concat(f.options.classNamePrefix, "-").concat(v) : "".concat(s).concat(v);
  };
}
function El(t) {
  var e = t.theme, n = t.name, r = t.props;
  if (!e || !e.props || !e.props[n])
    return r;
  var o = e.props[n], i;
  for (i in o)
    r[i] === void 0 && (r[i] = o[i]);
  return r;
}
var Sl = process.env.NODE_ENV === "production";
function De(t, e) {
  if (!Sl) {
    if (t)
      return;
    var n = "Warning: " + e;
    typeof console != "undefined" && console.warn(n);
    try {
      throw Error(n);
    } catch (r) {
    }
  }
}
var ni = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
  return typeof t;
} : function(t) {
  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
}, ar = (typeof window == "undefined" ? "undefined" : ni(window)) === "object" && (typeof document == "undefined" ? "undefined" : ni(document)) === "object" && document.nodeType === 9;
function oi(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, Vi(r.key), r);
  }
}
function qi(t, e, n) {
  return e && oi(t.prototype, e), n && oi(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Cn(t, e) {
  return Cn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Cn(t, e);
}
function no(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, Cn(t, e);
}
function Pn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
var wl = {}.constructor;
function _n(t) {
  if (t == null || typeof t != "object")
    return t;
  if (Array.isArray(t))
    return t.map(_n);
  if (t.constructor !== wl)
    return t;
  var e = {};
  for (var n in t)
    e[n] = _n(t[n]);
  return e;
}
function oo(t, e, n) {
  t === void 0 && (t = "unnamed");
  var r = n.jss, o = _n(e), i = r.plugins.onCreateRule(t, o, n);
  return i || (t[0] === "@" && process.env.NODE_ENV !== "production" && De(!1, "[JSS] Unknown rule " + t), null);
}
var ii = function(e, n) {
  for (var r = "", o = 0; o < e.length && e[o] !== "!important"; o++)
    r && (r += n), r += e[o];
  return r;
}, gt = function(e) {
  if (!Array.isArray(e))
    return e;
  var n = "";
  if (Array.isArray(e[0]))
    for (var r = 0; r < e.length && e[r] !== "!important"; r++)
      n && (n += ", "), n += ii(e[r], " ");
  else
    n = ii(e, ", ");
  return e[e.length - 1] === "!important" && (n += " !important"), n;
};
function Vt(t) {
  return t && t.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function Xt(t, e) {
  for (var n = "", r = 0; r < e; r++)
    n += "  ";
  return n + t;
}
function or(t, e, n) {
  n === void 0 && (n = {});
  var r = "";
  if (!e)
    return r;
  var o = n, i = o.indent, a = i === void 0 ? 0 : i, s = e.fallbacks;
  n.format === !1 && (a = -1 / 0);
  var l = Vt(n), u = l.linebreak, c = l.space;
  if (t && a++, s)
    if (Array.isArray(s))
      for (var f = 0; f < s.length; f++) {
        var p = s[f];
        for (var h in p) {
          var v = p[h];
          v != null && (r && (r += u), r += Xt(h + ":" + c + gt(v) + ";", a));
        }
      }
    else
      for (var m in s) {
        var S = s[m];
        S != null && (r && (r += u), r += Xt(m + ":" + c + gt(S) + ";", a));
      }
  for (var b in e) {
    var T = e[b];
    T != null && b !== "fallbacks" && (r && (r += u), r += Xt(b + ":" + c + gt(T) + ";", a));
  }
  return !r && !n.allowEmpty || !t ? r : (a--, r && (r = "" + u + r + u), Xt("" + t + c + "{" + r, a) + Xt("}", a));
}
var Ol = /([[\].#*$><+~=|^:(),"'`\s])/g, ai = typeof CSS != "undefined" && CSS.escape, io = function(t) {
  return ai ? ai(t) : t.replace(Ol, "\\$1");
}, Yi = /* @__PURE__ */ function() {
  function t(n, r, o) {
    this.type = "style", this.isProcessed = !1;
    var i = o.sheet, a = o.Renderer;
    this.key = n, this.options = o, this.style = r, i ? this.renderer = i.renderer : a && (this.renderer = new a());
  }
  var e = t.prototype;
  return e.prop = function(r, o, i) {
    if (o === void 0)
      return this.style[r];
    var a = i ? i.force : !1;
    if (!a && this.style[r] === o)
      return this;
    var s = o;
    (!i || i.process !== !1) && (s = this.options.jss.plugins.onChangeValue(o, r, this));
    var l = s == null || s === !1, u = r in this.style;
    if (l && !u && !a)
      return this;
    var c = l && u;
    if (c ? delete this.style[r] : this.style[r] = s, this.renderable && this.renderer)
      return c ? this.renderer.removeProperty(this.renderable, r) : this.renderer.setProperty(this.renderable, r, s), this;
    var f = this.options.sheet;
    return f && f.attached && process.env.NODE_ENV !== "production" && De(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, t;
}(), Nn = /* @__PURE__ */ function(t) {
  no(e, t);
  function e(r, o, i) {
    var a;
    a = t.call(this, r, o, i) || this;
    var s = i.selector, l = i.scoped, u = i.sheet, c = i.generateId;
    return s ? a.selectorText = s : l !== !1 && (a.id = c(Pn(Pn(a)), u), a.selectorText = "." + io(a.id)), a;
  }
  var n = e.prototype;
  return n.applyTo = function(o) {
    var i = this.renderer;
    if (i) {
      var a = this.toJSON();
      for (var s in a)
        i.setProperty(o, s, a[s]);
    }
    return this;
  }, n.toJSON = function() {
    var o = {};
    for (var i in this.style) {
      var a = this.style[i];
      typeof a != "object" ? o[i] = a : Array.isArray(a) && (o[i] = gt(a));
    }
    return o;
  }, n.toString = function(o) {
    var i = this.options.sheet, a = i ? i.options.link : !1, s = a ? M({}, o, {
      allowEmpty: !0
    }) : o;
    return or(this.selectorText, this.style, s);
  }, qi(e, [{
    key: "selector",
    set: function(o) {
      if (o !== this.selectorText) {
        this.selectorText = o;
        var i = this.renderer, a = this.renderable;
        if (!(!a || !i)) {
          var s = i.setSelector(a, o);
          s || i.replaceRule(a, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), e;
}(Yi), Rl = {
  onCreateRule: function(e, n, r) {
    return e[0] === "@" || r.parent && r.parent.type === "keyframes" ? null : new Nn(e, n, r);
  }
}, on = {
  indent: 1,
  children: !0
}, Tl = /@([\w-]+)/, Cl = /* @__PURE__ */ function() {
  function t(n, r, o) {
    this.type = "conditional", this.isProcessed = !1, this.key = n;
    var i = n.match(Tl);
    this.at = i ? i[1] : "unknown", this.query = o.name || "@" + this.at, this.options = o, this.rules = new Ar(M({}, o, {
      parent: this
    }));
    for (var a in r)
      this.rules.add(a, r[a]);
    this.rules.process();
  }
  var e = t.prototype;
  return e.getRule = function(r) {
    return this.rules.get(r);
  }, e.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, e.addRule = function(r, o, i) {
    var a = this.rules.add(r, o, i);
    return a ? (this.options.jss.plugins.onProcessRule(a), a) : null;
  }, e.replaceRule = function(r, o, i) {
    var a = this.rules.replace(r, o, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, e.toString = function(r) {
    r === void 0 && (r = on);
    var o = Vt(r), i = o.linebreak;
    if (r.indent == null && (r.indent = on.indent), r.children == null && (r.children = on.children), r.children === !1)
      return this.query + " {}";
    var a = this.rules.toString(r);
    return a ? this.query + " {" + i + a + i + "}" : "";
  }, t;
}(), Pl = /@container|@media|@supports\s+/, _l = {
  onCreateRule: function(e, n, r) {
    return Pl.test(e) ? new Cl(e, n, r) : null;
  }
}, an = {
  indent: 1,
  children: !0
}, Nl = /@keyframes\s+([\w-]+)/, In = /* @__PURE__ */ function() {
  function t(n, r, o) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var i = n.match(Nl);
    i && i[1] ? this.name = i[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && De(!1, "[JSS] Bad keyframes name " + n)), this.key = this.type + "-" + this.name, this.options = o;
    var a = o.scoped, s = o.sheet, l = o.generateId;
    this.id = a === !1 ? this.name : io(l(this, s)), this.rules = new Ar(M({}, o, {
      parent: this
    }));
    for (var u in r)
      this.rules.add(u, r[u], M({}, o, {
        parent: this
      }));
    this.rules.process();
  }
  var e = t.prototype;
  return e.toString = function(r) {
    r === void 0 && (r = an);
    var o = Vt(r), i = o.linebreak;
    if (r.indent == null && (r.indent = an.indent), r.children == null && (r.children = an.children), r.children === !1)
      return this.at + " " + this.id + " {}";
    var a = this.rules.toString(r);
    return a && (a = "" + i + a + i), this.at + " " + this.id + " {" + a + "}";
  }, t;
}(), Il = /@keyframes\s+/, kl = /\$([\w-]+)/g, kn = function(e, n) {
  return typeof e == "string" ? e.replace(kl, function(r, o) {
    return o in n ? n[o] : (process.env.NODE_ENV !== "production" && De(!1, '[JSS] Referenced keyframes rule "' + o + '" is not defined.'), r);
  }) : e;
}, si = function(e, n, r) {
  var o = e[n], i = kn(o, r);
  i !== o && (e[n] = i);
}, Ml = {
  onCreateRule: function(e, n, r) {
    return typeof e == "string" && Il.test(e) ? new In(e, n, r) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(e, n, r) {
    return n.type !== "style" || !r || ("animation-name" in e && si(e, "animation-name", r.keyframes), "animation" in e && si(e, "animation", r.keyframes)), e;
  },
  onChangeValue: function(e, n, r) {
    var o = r.options.sheet;
    if (!o)
      return e;
    switch (n) {
      case "animation":
        return kn(e, o.keyframes);
      case "animation-name":
        return kn(e, o.keyframes);
      default:
        return e;
    }
  }
}, $l = /* @__PURE__ */ function(t) {
  no(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var n = e.prototype;
  return n.toString = function(o) {
    var i = this.options.sheet, a = i ? i.options.link : !1, s = a ? M({}, o, {
      allowEmpty: !0
    }) : o;
    return or(this.key, this.style, s);
  }, e;
}(Yi), Al = {
  onCreateRule: function(e, n, r) {
    return r.parent && r.parent.type === "keyframes" ? new $l(e, n, r) : null;
  }
}, Dl = /* @__PURE__ */ function() {
  function t(n, r, o) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = n, this.style = r, this.options = o;
  }
  var e = t.prototype;
  return e.toString = function(r) {
    var o = Vt(r), i = o.linebreak;
    if (Array.isArray(this.style)) {
      for (var a = "", s = 0; s < this.style.length; s++)
        a += or(this.at, this.style[s]), this.style[s + 1] && (a += i);
      return a;
    }
    return or(this.at, this.style, r);
  }, t;
}(), jl = /@font-face/, Vl = {
  onCreateRule: function(e, n, r) {
    return jl.test(e) ? new Dl(e, n, r) : null;
  }
}, Ll = /* @__PURE__ */ function() {
  function t(n, r, o) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = n, this.style = r, this.options = o;
  }
  var e = t.prototype;
  return e.toString = function(r) {
    return or(this.key, this.style, r);
  }, t;
}(), Fl = {
  onCreateRule: function(e, n, r) {
    return e === "@viewport" || e === "@-ms-viewport" ? new Ll(e, n, r) : null;
  }
}, zl = /* @__PURE__ */ function() {
  function t(n, r, o) {
    this.type = "simple", this.isProcessed = !1, this.key = n, this.value = r, this.options = o;
  }
  var e = t.prototype;
  return e.toString = function(r) {
    if (Array.isArray(this.value)) {
      for (var o = "", i = 0; i < this.value.length; i++)
        o += this.key + " " + this.value[i] + ";", this.value[i + 1] && (o += `
`);
      return o;
    }
    return this.key + " " + this.value + ";";
  }, t;
}(), Wl = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, Ul = {
  onCreateRule: function(e, n, r) {
    return e in Wl ? new zl(e, n, r) : null;
  }
}, li = [Rl, _l, Ml, Al, Vl, Fl, Ul], Bl = {
  process: !0
}, ui = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, Ar = /* @__PURE__ */ function() {
  function t(n) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = n, this.classes = n.classes, this.keyframes = n.keyframes;
  }
  var e = t.prototype;
  return e.add = function(r, o, i) {
    var a = this.options, s = a.parent, l = a.sheet, u = a.jss, c = a.Renderer, f = a.generateId, p = a.scoped, h = M({
      classes: this.classes,
      parent: s,
      sheet: l,
      jss: u,
      Renderer: c,
      generateId: f,
      scoped: p,
      name: r,
      keyframes: this.keyframes,
      selector: void 0
    }, i), v = r;
    r in this.raw && (v = r + "-d" + this.counter++), this.raw[v] = o, v in this.classes && (h.selector = "." + io(this.classes[v]));
    var m = oo(v, o, h);
    if (!m)
      return null;
    this.register(m);
    var S = h.index === void 0 ? this.index.length : h.index;
    return this.index.splice(S, 0, m), m;
  }, e.replace = function(r, o, i) {
    var a = this.get(r), s = this.index.indexOf(a);
    a && this.remove(a);
    var l = i;
    return s !== -1 && (l = M({}, i, {
      index: s
    })), this.add(r, o, l);
  }, e.get = function(r) {
    return this.map[r];
  }, e.remove = function(r) {
    this.unregister(r), delete this.raw[r.key], this.index.splice(this.index.indexOf(r), 1);
  }, e.indexOf = function(r) {
    return this.index.indexOf(r);
  }, e.process = function() {
    var r = this.options.jss.plugins;
    this.index.slice(0).forEach(r.onProcessRule, r);
  }, e.register = function(r) {
    this.map[r.key] = r, r instanceof Nn ? (this.map[r.selector] = r, r.id && (this.classes[r.key] = r.id)) : r instanceof In && this.keyframes && (this.keyframes[r.name] = r.id);
  }, e.unregister = function(r) {
    delete this.map[r.key], r instanceof Nn ? (delete this.map[r.selector], delete this.classes[r.key]) : r instanceof In && delete this.keyframes[r.name];
  }, e.update = function() {
    var r, o, i;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (r = arguments.length <= 0 ? void 0 : arguments[0], o = arguments.length <= 1 ? void 0 : arguments[1], i = arguments.length <= 2 ? void 0 : arguments[2]) : (o = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], r = null), r)
      this.updateOne(this.get(r), o, i);
    else
      for (var a = 0; a < this.index.length; a++)
        this.updateOne(this.index[a], o, i);
  }, e.updateOne = function(r, o, i) {
    i === void 0 && (i = Bl);
    var a = this.options, s = a.jss.plugins, l = a.sheet;
    if (r.rules instanceof t) {
      r.rules.update(o, i);
      return;
    }
    var u = r.style;
    if (s.onUpdate(o, r, l, i), i.process && u && u !== r.style) {
      s.onProcessStyle(r.style, r, l);
      for (var c in r.style) {
        var f = r.style[c], p = u[c];
        f !== p && r.prop(c, f, ui);
      }
      for (var h in u) {
        var v = r.style[h], m = u[h];
        v == null && v !== m && r.prop(h, null, ui);
      }
    }
  }, e.toString = function(r) {
    for (var o = "", i = this.options.sheet, a = i ? i.options.link : !1, s = Vt(r), l = s.linebreak, u = 0; u < this.index.length; u++) {
      var c = this.index[u], f = c.toString(r);
      !f && !a || (o && (o += l), o += f);
    }
    return o;
  }, t;
}(), Ki = /* @__PURE__ */ function() {
  function t(n, r) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = M({}, r, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), r.Renderer && (this.renderer = new r.Renderer(this)), this.rules = new Ar(this.options);
    for (var o in n)
      this.rules.add(o, n[o]);
    this.rules.process();
  }
  var e = t.prototype;
  return e.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, e.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, e.addRule = function(r, o, i) {
    var a = this.queue;
    this.attached && !a && (this.queue = []);
    var s = this.rules.add(r, o, i);
    return s ? (this.options.jss.plugins.onProcessRule(s), this.attached ? (this.deployed && (a ? a.push(s) : (this.insertRule(s), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), s) : (this.deployed = !1, s)) : null;
  }, e.replaceRule = function(r, o, i) {
    var a = this.rules.get(r);
    if (!a)
      return this.addRule(r, o, i);
    var s = this.rules.replace(r, o, i);
    return s && this.options.jss.plugins.onProcessRule(s), this.attached ? (this.deployed && this.renderer && (s ? a.renderable && this.renderer.replaceRule(a.renderable, s) : this.renderer.deleteRule(a)), s) : (this.deployed = !1, s);
  }, e.insertRule = function(r) {
    this.renderer && this.renderer.insertRule(r);
  }, e.addRules = function(r, o) {
    var i = [];
    for (var a in r) {
      var s = this.addRule(a, r[a], o);
      s && i.push(s);
    }
    return i;
  }, e.getRule = function(r) {
    return this.rules.get(r);
  }, e.deleteRule = function(r) {
    var o = typeof r == "object" ? r : this.rules.get(r);
    return !o || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !o.renderable ? !1 : (this.rules.remove(o), this.attached && o.renderable && this.renderer ? this.renderer.deleteRule(o.renderable) : !0);
  }, e.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, e.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, e.update = function() {
    var r;
    return (r = this.rules).update.apply(r, arguments), this;
  }, e.updateOne = function(r, o, i) {
    return this.rules.updateOne(r, o, i), this;
  }, e.toString = function(r) {
    return this.rules.toString(r);
  }, t;
}(), Hl = /* @__PURE__ */ function() {
  function t() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var e = t.prototype;
  return e.onCreateRule = function(r, o, i) {
    for (var a = 0; a < this.registry.onCreateRule.length; a++) {
      var s = this.registry.onCreateRule[a](r, o, i);
      if (s)
        return s;
    }
    return null;
  }, e.onProcessRule = function(r) {
    if (!r.isProcessed) {
      for (var o = r.options.sheet, i = 0; i < this.registry.onProcessRule.length; i++)
        this.registry.onProcessRule[i](r, o);
      r.style && this.onProcessStyle(r.style, r, o), r.isProcessed = !0;
    }
  }, e.onProcessStyle = function(r, o, i) {
    for (var a = 0; a < this.registry.onProcessStyle.length; a++)
      o.style = this.registry.onProcessStyle[a](o.style, o, i);
  }, e.onProcessSheet = function(r) {
    for (var o = 0; o < this.registry.onProcessSheet.length; o++)
      this.registry.onProcessSheet[o](r);
  }, e.onUpdate = function(r, o, i, a) {
    for (var s = 0; s < this.registry.onUpdate.length; s++)
      this.registry.onUpdate[s](r, o, i, a);
  }, e.onChangeValue = function(r, o, i) {
    for (var a = r, s = 0; s < this.registry.onChangeValue.length; s++)
      a = this.registry.onChangeValue[s](a, o, i);
    return a;
  }, e.use = function(r, o) {
    o === void 0 && (o = {
      queue: "external"
    });
    var i = this.plugins[o.queue];
    i.indexOf(r) === -1 && (i.push(r), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(a, s) {
      for (var l in s)
        l in a ? a[l].push(s[l]) : process.env.NODE_ENV !== "production" && De(!1, '[JSS] Unknown hook "' + l + '".');
      return a;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, t;
}(), ql = /* @__PURE__ */ function() {
  function t() {
    this.registry = [];
  }
  var e = t.prototype;
  return e.add = function(r) {
    var o = this.registry, i = r.options.index;
    if (o.indexOf(r) === -1) {
      if (o.length === 0 || i >= this.index) {
        o.push(r);
        return;
      }
      for (var a = 0; a < o.length; a++)
        if (o[a].options.index > i) {
          o.splice(a, 0, r);
          return;
        }
    }
  }, e.reset = function() {
    this.registry = [];
  }, e.remove = function(r) {
    var o = this.registry.indexOf(r);
    this.registry.splice(o, 1);
  }, e.toString = function(r) {
    for (var o = r === void 0 ? {} : r, i = o.attached, a = Zn(o, ["attached"]), s = Vt(a), l = s.linebreak, u = "", c = 0; c < this.registry.length; c++) {
      var f = this.registry[c];
      i != null && f.attached !== i || (u && (u += l), u += f.toString(a));
    }
    return u;
  }, qi(t, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), t;
}(), rr = new ql(), Mn = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" && window.Math === Math ? window : typeof self != "undefined" && self.Math === Math ? self : Function("return this")(), $n = "2f1acc6c3a606b082e5eef5e54414ffb";
Mn[$n] == null && (Mn[$n] = 0);
var ci = Mn[$n]++, Yl = 1e10, fi = function(e) {
  e === void 0 && (e = {});
  var n = 0, r = function(i, a) {
    n += 1, n > Yl && process.env.NODE_ENV !== "production" && De(!1, "[JSS] You might have a memory leak. Rule counter is at " + n + ".");
    var s = "", l = "";
    return a && (a.options.classNamePrefix && (l = a.options.classNamePrefix), a.options.jss.id != null && (s = String(a.options.jss.id))), e.minify ? "" + (l || "c") + ci + s + n : l + i.key + "-" + ci + (s ? "-" + s : "") + "-" + n;
  };
  return r;
}, Gi = function(e) {
  var n;
  return function() {
    return n || (n = e()), n;
  };
}, Kl = function(e, n) {
  try {
    return e.attributeStyleMap ? e.attributeStyleMap.get(n) : e.style.getPropertyValue(n);
  } catch (r) {
    return "";
  }
}, Gl = function(e, n, r) {
  try {
    var o = r;
    if (Array.isArray(r) && (o = gt(r)), e.attributeStyleMap)
      e.attributeStyleMap.set(n, o);
    else {
      var i = o ? o.indexOf("!important") : -1, a = i > -1 ? o.substr(0, i - 1) : o;
      e.style.setProperty(n, a, i > -1 ? "important" : "");
    }
  } catch (s) {
    return !1;
  }
  return !0;
}, Jl = function(e, n) {
  try {
    e.attributeStyleMap ? e.attributeStyleMap.delete(n) : e.style.removeProperty(n);
  } catch (r) {
    process.env.NODE_ENV !== "production" && De(!1, '[JSS] DOMException "' + r.message + '" was thrown. Tried to remove property "' + n + '".');
  }
}, Xl = function(e, n) {
  return e.selectorText = n, e.selectorText === n;
}, Ji = Gi(function() {
  return document.querySelector("head");
});
function Zl(t, e) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    if (r.attached && r.options.index > e.index && r.options.insertionPoint === e.insertionPoint)
      return r;
  }
  return null;
}
function Ql(t, e) {
  for (var n = t.length - 1; n >= 0; n--) {
    var r = t[n];
    if (r.attached && r.options.insertionPoint === e.insertionPoint)
      return r;
  }
  return null;
}
function eu(t) {
  for (var e = Ji(), n = 0; n < e.childNodes.length; n++) {
    var r = e.childNodes[n];
    if (r.nodeType === 8 && r.nodeValue.trim() === t)
      return r;
  }
  return null;
}
function tu(t) {
  var e = rr.registry;
  if (e.length > 0) {
    var n = Zl(e, t);
    if (n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element
      };
    if (n = Ql(e, t), n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element.nextSibling
      };
  }
  var r = t.insertionPoint;
  if (r && typeof r == "string") {
    var o = eu(r);
    if (o)
      return {
        parent: o.parentNode,
        node: o.nextSibling
      };
    process.env.NODE_ENV !== "production" && De(!1, '[JSS] Insertion point "' + r + '" not found.');
  }
  return !1;
}
function ru(t, e) {
  var n = e.insertionPoint, r = tu(e);
  if (r !== !1 && r.parent) {
    r.parent.insertBefore(t, r.node);
    return;
  }
  if (n && typeof n.nodeType == "number") {
    var o = n, i = o.parentNode;
    i ? i.insertBefore(t, o.nextSibling) : process.env.NODE_ENV !== "production" && De(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  Ji().appendChild(t);
}
var nu = Gi(function() {
  var t = document.querySelector('meta[property="csp-nonce"]');
  return t ? t.getAttribute("content") : null;
}), di = function(e, n, r) {
  try {
    "insertRule" in e ? e.insertRule(n, r) : "appendRule" in e && e.appendRule(n);
  } catch (o) {
    return process.env.NODE_ENV !== "production" && De(!1, "[JSS] " + o.message), !1;
  }
  return e.cssRules[r];
}, pi = function(e, n) {
  var r = e.cssRules.length;
  return n === void 0 || n > r ? r : n;
}, ou = function() {
  var e = document.createElement("style");
  return e.textContent = `
`, e;
}, iu = /* @__PURE__ */ function() {
  function t(n) {
    this.getPropertyValue = Kl, this.setProperty = Gl, this.removeProperty = Jl, this.setSelector = Xl, this.hasInsertedRules = !1, this.cssRules = [], n && rr.add(n), this.sheet = n;
    var r = this.sheet ? this.sheet.options : {}, o = r.media, i = r.meta, a = r.element;
    this.element = a || ou(), this.element.setAttribute("data-jss", ""), o && this.element.setAttribute("media", o), i && this.element.setAttribute("data-meta", i);
    var s = nu();
    s && this.element.setAttribute("nonce", s);
  }
  var e = t.prototype;
  return e.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      ru(this.element, this.sheet.options);
      var r = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && r && (this.hasInsertedRules = !1, this.deploy());
    }
  }, e.detach = function() {
    if (this.sheet) {
      var r = this.element.parentNode;
      r && r.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, e.deploy = function() {
    var r = this.sheet;
    if (r) {
      if (r.options.link) {
        this.insertRules(r.rules);
        return;
      }
      this.element.textContent = `
` + r.toString() + `
`;
    }
  }, e.insertRules = function(r, o) {
    for (var i = 0; i < r.index.length; i++)
      this.insertRule(r.index[i], i, o);
  }, e.insertRule = function(r, o, i) {
    if (i === void 0 && (i = this.element.sheet), r.rules) {
      var a = r, s = i;
      if (r.type === "conditional" || r.type === "keyframes") {
        var l = pi(i, o);
        if (s = di(i, a.toString({
          children: !1
        }), l), s === !1)
          return !1;
        this.refCssRule(r, l, s);
      }
      return this.insertRules(a.rules, s), s;
    }
    var u = r.toString();
    if (!u)
      return !1;
    var c = pi(i, o), f = di(i, u, c);
    return f === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(r, c, f), f);
  }, e.refCssRule = function(r, o, i) {
    r.renderable = i, r.options.parent instanceof Ki && this.cssRules.splice(o, 0, i);
  }, e.deleteRule = function(r) {
    var o = this.element.sheet, i = this.indexOf(r);
    return i === -1 ? !1 : (o.deleteRule(i), this.cssRules.splice(i, 1), !0);
  }, e.indexOf = function(r) {
    return this.cssRules.indexOf(r);
  }, e.replaceRule = function(r, o) {
    var i = this.indexOf(r);
    return i === -1 ? !1 : (this.element.sheet.deleteRule(i), this.cssRules.splice(i, 1), this.insertRule(o, i));
  }, e.getRules = function() {
    return this.element.sheet.cssRules;
  }, t;
}(), au = 0, su = /* @__PURE__ */ function() {
  function t(n) {
    this.id = au++, this.version = "10.10.0", this.plugins = new Hl(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: fi,
      Renderer: ar ? iu : null,
      plugins: []
    }, this.generateId = fi({
      minify: !1
    });
    for (var r = 0; r < li.length; r++)
      this.plugins.use(li[r], {
        queue: "internal"
      });
    this.setup(n);
  }
  var e = t.prototype;
  return e.setup = function(r) {
    return r === void 0 && (r = {}), r.createGenerateId && (this.options.createGenerateId = r.createGenerateId), r.id && (this.options.id = M({}, this.options.id, r.id)), (r.createGenerateId || r.id) && (this.generateId = this.options.createGenerateId(this.options.id)), r.insertionPoint != null && (this.options.insertionPoint = r.insertionPoint), "Renderer" in r && (this.options.Renderer = r.Renderer), r.plugins && this.use.apply(this, r.plugins), this;
  }, e.createStyleSheet = function(r, o) {
    o === void 0 && (o = {});
    var i = o, a = i.index;
    typeof a != "number" && (a = rr.index === 0 ? 0 : rr.index + 1);
    var s = new Ki(r, M({}, o, {
      jss: this,
      generateId: o.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: a
    }));
    return this.plugins.onProcessSheet(s), s;
  }, e.removeStyleSheet = function(r) {
    return r.detach(), rr.remove(r), this;
  }, e.createRule = function(r, o, i) {
    if (o === void 0 && (o = {}), i === void 0 && (i = {}), typeof r == "object")
      return this.createRule(void 0, r, o);
    var a = M({}, i, {
      name: r,
      jss: this,
      Renderer: this.options.Renderer
    });
    a.generateId || (a.generateId = this.generateId), a.classes || (a.classes = {}), a.keyframes || (a.keyframes = {});
    var s = oo(r, o, a);
    return s && this.plugins.onProcessRule(s), s;
  }, e.use = function() {
    for (var r = this, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return i.forEach(function(s) {
      r.plugins.use(s);
    }), this;
  }, t;
}(), ao = function(e) {
  return new su(e);
}, so = typeof CSS == "object" && CSS != null && "number" in CSS;
function Xi(t) {
  var e = null;
  for (var n in t) {
    var r = t[n], o = typeof r;
    if (o === "function")
      e || (e = {}), e[n] = r;
    else if (o === "object" && r !== null && !Array.isArray(r)) {
      var i = Xi(r);
      i && (e || (e = {}), e[n] = i);
    }
  }
  return e;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
ao();
var Zi = Date.now(), sn = "fnValues" + Zi, ln = "fnStyle" + ++Zi, lu = function() {
  return {
    onCreateRule: function(n, r, o) {
      if (typeof r != "function")
        return null;
      var i = oo(n, {}, o);
      return i[ln] = r, i;
    },
    onProcessStyle: function(n, r) {
      if (sn in r || ln in r)
        return n;
      var o = {};
      for (var i in n) {
        var a = n[i];
        typeof a == "function" && (delete n[i], o[i] = a);
      }
      return r[sn] = o, n;
    },
    onUpdate: function(n, r, o, i) {
      var a = r, s = a[ln];
      if (s && (a.style = s(n) || {}, process.env.NODE_ENV === "development")) {
        for (var l in a.style)
          if (typeof a.style[l] == "function") {
            process.env.NODE_ENV !== "production" && De(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var u = a[sn];
      if (u)
        for (var c in u)
          a.prop(c, u[c](n), i);
    }
  };
};
const uu = lu;
var ot = "@global", An = "@global ", cu = /* @__PURE__ */ function() {
  function t(n, r, o) {
    this.type = "global", this.at = ot, this.isProcessed = !1, this.key = n, this.options = o, this.rules = new Ar(M({}, o, {
      parent: this
    }));
    for (var i in r)
      this.rules.add(i, r[i]);
    this.rules.process();
  }
  var e = t.prototype;
  return e.getRule = function(r) {
    return this.rules.get(r);
  }, e.addRule = function(r, o, i) {
    var a = this.rules.add(r, o, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, e.replaceRule = function(r, o, i) {
    var a = this.rules.replace(r, o, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, e.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, e.toString = function(r) {
    return this.rules.toString(r);
  }, t;
}(), fu = /* @__PURE__ */ function() {
  function t(n, r, o) {
    this.type = "global", this.at = ot, this.isProcessed = !1, this.key = n, this.options = o;
    var i = n.substr(An.length);
    this.rule = o.jss.createRule(i, r, M({}, o, {
      parent: this
    }));
  }
  var e = t.prototype;
  return e.toString = function(r) {
    return this.rule ? this.rule.toString(r) : "";
  }, t;
}(), du = /\s*,\s*/g;
function Qi(t, e) {
  for (var n = t.split(du), r = "", o = 0; o < n.length; o++)
    r += e + " " + n[o].trim(), n[o + 1] && (r += ", ");
  return r;
}
function pu(t, e) {
  var n = t.options, r = t.style, o = r ? r[ot] : null;
  if (o) {
    for (var i in o)
      e.addRule(i, o[i], M({}, n, {
        selector: Qi(i, t.selector)
      }));
    delete r[ot];
  }
}
function hu(t, e) {
  var n = t.options, r = t.style;
  for (var o in r)
    if (!(o[0] !== "@" || o.substr(0, ot.length) !== ot)) {
      var i = Qi(o.substr(ot.length), t.selector);
      e.addRule(i, r[o], M({}, n, {
        selector: i
      })), delete r[o];
    }
}
function vu() {
  function t(n, r, o) {
    if (!n)
      return null;
    if (n === ot)
      return new cu(n, r, o);
    if (n[0] === "@" && n.substr(0, An.length) === An)
      return new fu(n, r, o);
    var i = o.parent;
    return i && (i.type === "global" || i.options.parent && i.options.parent.type === "global") && (o.scoped = !1), !o.selector && o.scoped === !1 && (o.selector = n), null;
  }
  function e(n, r) {
    n.type !== "style" || !r || (pu(n, r), hu(n, r));
  }
  return {
    onCreateRule: t,
    onProcessRule: e
  };
}
var hi = /\s*,\s*/g, gu = /&/g, mu = /\$([\w-]+)/g;
function yu() {
  function t(o, i) {
    return function(a, s) {
      var l = o.getRule(s) || i && i.getRule(s);
      return l ? l.selector : (process.env.NODE_ENV !== "production" && De(!1, '[JSS] Could not find the referenced rule "' + s + '" in "' + (o.options.meta || o.toString()) + '".'), s);
    };
  }
  function e(o, i) {
    for (var a = i.split(hi), s = o.split(hi), l = "", u = 0; u < a.length; u++)
      for (var c = a[u], f = 0; f < s.length; f++) {
        var p = s[f];
        l && (l += ", "), l += p.indexOf("&") !== -1 ? p.replace(gu, c) : c + " " + p;
      }
    return l;
  }
  function n(o, i, a) {
    if (a)
      return M({}, a, {
        index: a.index + 1
      });
    var s = o.options.nestingLevel;
    s = s === void 0 ? 1 : s + 1;
    var l = M({}, o.options, {
      nestingLevel: s,
      index: i.indexOf(o) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete l.name, l;
  }
  function r(o, i, a) {
    if (i.type !== "style")
      return o;
    var s = i, l = s.options.parent, u, c;
    for (var f in o) {
      var p = f.indexOf("&") !== -1, h = f[0] === "@";
      if (!(!p && !h)) {
        if (u = n(s, l, u), p) {
          var v = e(f, s.selector);
          c || (c = t(l, a)), v = v.replace(mu, c);
          var m = s.key + "-" + f;
          "replaceRule" in l ? l.replaceRule(m, o[f], M({}, u, {
            selector: v
          })) : l.addRule(m, o[f], M({}, u, {
            selector: v
          }));
        } else
          h && l.addRule(f, {}, u).addRule(s.key, o[f], {
            selector: s.selector
          });
        delete o[f];
      }
    }
    return o;
  }
  return {
    onProcessStyle: r
  };
}
var bu = /[A-Z]/g, xu = /^ms-/, un = {};
function Eu(t) {
  return "-" + t.toLowerCase();
}
function ea(t) {
  if (un.hasOwnProperty(t))
    return un[t];
  var e = t.replace(bu, Eu);
  return un[t] = xu.test(e) ? "-" + e : e;
}
function Cr(t) {
  var e = {};
  for (var n in t) {
    var r = n.indexOf("--") === 0 ? n : ea(n);
    e[r] = t[n];
  }
  return t.fallbacks && (Array.isArray(t.fallbacks) ? e.fallbacks = t.fallbacks.map(Cr) : e.fallbacks = Cr(t.fallbacks)), e;
}
function Su() {
  function t(n) {
    if (Array.isArray(n)) {
      for (var r = 0; r < n.length; r++)
        n[r] = Cr(n[r]);
      return n;
    }
    return Cr(n);
  }
  function e(n, r, o) {
    if (r.indexOf("--") === 0)
      return n;
    var i = ea(r);
    return r === i ? n : (o.prop(i, n), null);
  }
  return {
    onProcessStyle: t,
    onChangeValue: e
  };
}
var x = so && CSS ? CSS.px : "px", gr = so && CSS ? CSS.ms : "ms", _t = so && CSS ? CSS.percent : "%", wu = {
  // Animation properties
  "animation-delay": gr,
  "animation-duration": gr,
  // Background properties
  "background-position": x,
  "background-position-x": x,
  "background-position-y": x,
  "background-size": x,
  // Border Properties
  border: x,
  "border-bottom": x,
  "border-bottom-left-radius": x,
  "border-bottom-right-radius": x,
  "border-bottom-width": x,
  "border-left": x,
  "border-left-width": x,
  "border-radius": x,
  "border-right": x,
  "border-right-width": x,
  "border-top": x,
  "border-top-left-radius": x,
  "border-top-right-radius": x,
  "border-top-width": x,
  "border-width": x,
  "border-block": x,
  "border-block-end": x,
  "border-block-end-width": x,
  "border-block-start": x,
  "border-block-start-width": x,
  "border-block-width": x,
  "border-inline": x,
  "border-inline-end": x,
  "border-inline-end-width": x,
  "border-inline-start": x,
  "border-inline-start-width": x,
  "border-inline-width": x,
  "border-start-start-radius": x,
  "border-start-end-radius": x,
  "border-end-start-radius": x,
  "border-end-end-radius": x,
  // Margin properties
  margin: x,
  "margin-bottom": x,
  "margin-left": x,
  "margin-right": x,
  "margin-top": x,
  "margin-block": x,
  "margin-block-end": x,
  "margin-block-start": x,
  "margin-inline": x,
  "margin-inline-end": x,
  "margin-inline-start": x,
  // Padding properties
  padding: x,
  "padding-bottom": x,
  "padding-left": x,
  "padding-right": x,
  "padding-top": x,
  "padding-block": x,
  "padding-block-end": x,
  "padding-block-start": x,
  "padding-inline": x,
  "padding-inline-end": x,
  "padding-inline-start": x,
  // Mask properties
  "mask-position-x": x,
  "mask-position-y": x,
  "mask-size": x,
  // Width and height properties
  height: x,
  width: x,
  "min-height": x,
  "max-height": x,
  "min-width": x,
  "max-width": x,
  // Position properties
  bottom: x,
  left: x,
  top: x,
  right: x,
  inset: x,
  "inset-block": x,
  "inset-block-end": x,
  "inset-block-start": x,
  "inset-inline": x,
  "inset-inline-end": x,
  "inset-inline-start": x,
  // Shadow properties
  "box-shadow": x,
  "text-shadow": x,
  // Column properties
  "column-gap": x,
  "column-rule": x,
  "column-rule-width": x,
  "column-width": x,
  // Font and text properties
  "font-size": x,
  "font-size-delta": x,
  "letter-spacing": x,
  "text-decoration-thickness": x,
  "text-indent": x,
  "text-stroke": x,
  "text-stroke-width": x,
  "word-spacing": x,
  // Motion properties
  motion: x,
  "motion-offset": x,
  // Outline properties
  outline: x,
  "outline-offset": x,
  "outline-width": x,
  // Perspective properties
  perspective: x,
  "perspective-origin-x": _t,
  "perspective-origin-y": _t,
  // Transform properties
  "transform-origin": _t,
  "transform-origin-x": _t,
  "transform-origin-y": _t,
  "transform-origin-z": _t,
  // Transition properties
  "transition-delay": gr,
  "transition-duration": gr,
  // Alignment properties
  "vertical-align": x,
  "flex-basis": x,
  // Some random properties
  "shape-margin": x,
  size: x,
  gap: x,
  // Grid properties
  grid: x,
  "grid-gap": x,
  "row-gap": x,
  "grid-row-gap": x,
  "grid-column-gap": x,
  "grid-template-rows": x,
  "grid-template-columns": x,
  "grid-auto-rows": x,
  "grid-auto-columns": x,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": x,
  "box-shadow-y": x,
  "box-shadow-blur": x,
  "box-shadow-spread": x,
  "font-line-height": x,
  "text-shadow-x": x,
  "text-shadow-y": x,
  "text-shadow-blur": x
};
function ta(t) {
  var e = /(-[a-z])/g, n = function(a) {
    return a[1].toUpperCase();
  }, r = {};
  for (var o in t)
    r[o] = t[o], r[o.replace(e, n)] = t[o];
  return r;
}
var Ou = ta(wu);
function nr(t, e, n) {
  if (e == null)
    return e;
  if (Array.isArray(e))
    for (var r = 0; r < e.length; r++)
      e[r] = nr(t, e[r], n);
  else if (typeof e == "object")
    if (t === "fallbacks")
      for (var o in e)
        e[o] = nr(o, e[o], n);
    else
      for (var i in e)
        e[i] = nr(t + "-" + i, e[i], n);
  else if (typeof e == "number" && isNaN(e) === !1) {
    var a = n[t] || Ou[t];
    return a && !(e === 0 && a === x) ? typeof a == "function" ? a(e).toString() : "" + e + a : e.toString();
  }
  return e;
}
function Ru(t) {
  t === void 0 && (t = {});
  var e = ta(t);
  function n(o, i) {
    if (i.type !== "style")
      return o;
    for (var a in o)
      o[a] = nr(a, o[a], e);
    return o;
  }
  function r(o, i) {
    return nr(i, o, e);
  }
  return {
    onProcessStyle: n,
    onChangeValue: r
  };
}
var Qt = "", Dn = "", ra = "", na = "", Tu = ar && "ontouchstart" in document.documentElement;
if (ar) {
  var cn = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, Cu = document.createElement("p"), fn = Cu.style, Pu = "Transform";
  for (var dn in cn)
    if (dn + Pu in fn) {
      Qt = dn, Dn = cn[dn];
      break;
    }
  Qt === "Webkit" && "msHyphens" in fn && (Qt = "ms", Dn = cn.ms, na = "edge"), Qt === "Webkit" && "-apple-trailing-word" in fn && (ra = "apple");
}
var G = {
  js: Qt,
  css: Dn,
  vendor: ra,
  browser: na,
  isTouch: Tu
};
function _u(t) {
  return t[1] === "-" || G.js === "ms" ? t : "@" + G.css + "keyframes" + t.substr(10);
}
var Nu = {
  noPrefill: ["appearance"],
  supportedProperty: function(e) {
    return e !== "appearance" ? !1 : G.js === "ms" ? "-webkit-" + e : G.css + e;
  }
}, Iu = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(e) {
    return e !== "color-adjust" ? !1 : G.js === "Webkit" ? G.css + "print-" + e : e;
  }
}, ku = /[-\s]+(.)?/g;
function Mu(t, e) {
  return e ? e.toUpperCase() : "";
}
function lo(t) {
  return t.replace(ku, Mu);
}
function at(t) {
  return lo("-" + t);
}
var $u = {
  noPrefill: ["mask"],
  supportedProperty: function(e, n) {
    if (!/^mask/.test(e))
      return !1;
    if (G.js === "Webkit") {
      var r = "mask-image";
      if (lo(r) in n)
        return e;
      if (G.js + at(r) in n)
        return G.css + e;
    }
    return e;
  }
}, Au = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(e) {
    return e !== "text-orientation" ? !1 : G.vendor === "apple" && !G.isTouch ? G.css + e : e;
  }
}, Du = {
  noPrefill: ["transform"],
  supportedProperty: function(e, n, r) {
    return e !== "transform" ? !1 : r.transform ? e : G.css + e;
  }
}, ju = {
  noPrefill: ["transition"],
  supportedProperty: function(e, n, r) {
    return e !== "transition" ? !1 : r.transition ? e : G.css + e;
  }
}, Vu = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(e) {
    return e !== "writing-mode" ? !1 : G.js === "Webkit" || G.js === "ms" && G.browser !== "edge" ? G.css + e : e;
  }
}, Lu = {
  noPrefill: ["user-select"],
  supportedProperty: function(e) {
    return e !== "user-select" ? !1 : G.js === "Moz" || G.js === "ms" || G.vendor === "apple" ? G.css + e : e;
  }
}, Fu = {
  supportedProperty: function(e, n) {
    if (!/^break-/.test(e))
      return !1;
    if (G.js === "Webkit") {
      var r = "WebkitColumn" + at(e);
      return r in n ? G.css + "column-" + e : !1;
    }
    if (G.js === "Moz") {
      var o = "page" + at(e);
      return o in n ? "page-" + e : !1;
    }
    return !1;
  }
}, zu = {
  supportedProperty: function(e, n) {
    if (!/^(border|margin|padding)-inline/.test(e))
      return !1;
    if (G.js === "Moz")
      return e;
    var r = e.replace("-inline", "");
    return G.js + at(r) in n ? G.css + r : !1;
  }
}, Wu = {
  supportedProperty: function(e, n) {
    return lo(e) in n ? e : !1;
  }
}, Uu = {
  supportedProperty: function(e, n) {
    var r = at(e);
    return e[0] === "-" || e[0] === "-" && e[1] === "-" ? e : G.js + r in n ? G.css + e : G.js !== "Webkit" && "Webkit" + r in n ? "-webkit-" + e : !1;
  }
}, Bu = {
  supportedProperty: function(e) {
    return e.substring(0, 11) !== "scroll-snap" ? !1 : G.js === "ms" ? "" + G.css + e : e;
  }
}, Hu = {
  supportedProperty: function(e) {
    return e !== "overscroll-behavior" ? !1 : G.js === "ms" ? G.css + "scroll-chaining" : e;
  }
}, qu = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, Yu = {
  supportedProperty: function(e, n) {
    var r = qu[e];
    return r && G.js + at(r) in n ? G.css + r : !1;
  }
}, oa = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, Ku = Object.keys(oa), Gu = function(e) {
  return G.css + e;
}, Ju = {
  supportedProperty: function(e, n, r) {
    var o = r.multiple;
    if (Ku.indexOf(e) > -1) {
      var i = oa[e];
      if (!Array.isArray(i))
        return G.js + at(i) in n ? G.css + i : !1;
      if (!o)
        return !1;
      for (var a = 0; a < i.length; a++)
        if (!(G.js + at(i[0]) in n))
          return !1;
      return i.map(Gu);
    }
    return !1;
  }
}, ia = [Nu, Iu, $u, Au, Du, ju, Vu, Lu, Fu, zu, Wu, Uu, Bu, Hu, Yu, Ju], vi = ia.filter(function(t) {
  return t.supportedProperty;
}).map(function(t) {
  return t.supportedProperty;
}), Xu = ia.filter(function(t) {
  return t.noPrefill;
}).reduce(function(t, e) {
  return t.push.apply(t, Hi(e.noPrefill)), t;
}, []), er, ht = {};
if (ar) {
  er = document.createElement("p");
  var pn = window.getComputedStyle(document.documentElement, "");
  for (var hn in pn)
    isNaN(hn) || (ht[pn[hn]] = pn[hn]);
  Xu.forEach(function(t) {
    return delete ht[t];
  });
}
function jn(t, e) {
  if (e === void 0 && (e = {}), !er)
    return t;
  if (process.env.NODE_ENV !== "benchmark" && ht[t] != null)
    return ht[t];
  (t === "transition" || t === "transform") && (e[t] = t in er.style);
  for (var n = 0; n < vi.length && (ht[t] = vi[n](t, er.style, e), !ht[t]); n++)
    ;
  try {
    er.style[t] = "";
  } catch (r) {
    return !1;
  }
  return ht[t];
}
var Nt = {}, Zu = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, Qu = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, rt;
function ec(t, e, n) {
  if (e === "var")
    return "var";
  if (e === "all")
    return "all";
  if (n === "all")
    return ", all";
  var r = e ? jn(e) : ", " + jn(n);
  return r || e || n;
}
ar && (rt = document.createElement("p"));
function gi(t, e) {
  var n = e;
  if (!rt || t === "content")
    return e;
  if (typeof n != "string" || !isNaN(parseInt(n, 10)))
    return n;
  var r = t + n;
  if (process.env.NODE_ENV !== "benchmark" && Nt[r] != null)
    return Nt[r];
  try {
    rt.style[t] = n;
  } catch (o) {
    return Nt[r] = !1, !1;
  }
  if (Zu[t])
    n = n.replace(Qu, ec);
  else if (rt.style[t] === "" && (n = G.css + n, n === "-ms-flex" && (rt.style[t] = "-ms-flexbox"), rt.style[t] = n, rt.style[t] === ""))
    return Nt[r] = !1, !1;
  return rt.style[t] = "", Nt[r] = n, Nt[r];
}
function tc() {
  function t(o) {
    if (o.type === "keyframes") {
      var i = o;
      i.at = _u(i.at);
    }
  }
  function e(o) {
    for (var i in o) {
      var a = o[i];
      if (i === "fallbacks" && Array.isArray(a)) {
        o[i] = a.map(e);
        continue;
      }
      var s = !1, l = jn(i);
      l && l !== i && (s = !0);
      var u = !1, c = gi(l, gt(a));
      c && c !== a && (u = !0), (s || u) && (s && delete o[i], o[l || i] = c || a);
    }
    return o;
  }
  function n(o, i) {
    return i.type !== "style" ? o : e(o);
  }
  function r(o, i) {
    return gi(i, gt(o)) || o;
  }
  return {
    onProcessRule: t,
    onProcessStyle: n,
    onChangeValue: r
  };
}
function rc() {
  var t = function(n, r) {
    return n.length === r.length ? n > r ? 1 : -1 : n.length - r.length;
  };
  return {
    onProcessStyle: function(n, r) {
      if (r.type !== "style")
        return n;
      for (var o = {}, i = Object.keys(n).sort(t), a = 0; a < i.length; a++)
        o[i[a]] = n[i[a]];
      return o;
    }
  };
}
function aa() {
  return {
    plugins: [
      uu(),
      vu(),
      yu(),
      Su(),
      Ru(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window == "undefined" ? null : tc(),
      rc()
    ]
  };
}
function sa() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.baseClasses, n = t.newClasses, r = t.Component;
  if (!n)
    return e;
  var o = M({}, e);
  return process.env.NODE_ENV !== "production" && typeof n == "string" ? (console.error(["Material-UI: The value `".concat(n, "` ") + "provided to the classes prop of ".concat(tr(r), " is incorrect."), "You might want to use the className prop instead."].join(`
`)), e) : (Object.keys(n).forEach(function(i) {
    process.env.NODE_ENV !== "production" && (!e[i] && n[i] && console.error(["Material-UI: The key `".concat(i, "` ") + "provided to the classes prop is not implemented in ".concat(tr(r), "."), "You can only override one of the following: ".concat(Object.keys(e).join(","), ".")].join(`
`)), n[i] && typeof n[i] != "string" && console.error(["Material-UI: The key `".concat(i, "` ") + "provided to the classes prop is not valid for ".concat(tr(r), "."), "You need to provide a non empty string instead of: ".concat(n[i], ".")].join(`
`))), n[i] && (o[i] = "".concat(e[i], " ").concat(n[i]));
  }), o);
}
var nc = {
  set: function(e, n, r, o) {
    var i = e.get(n);
    i || (i = /* @__PURE__ */ new Map(), e.set(n, i)), i.set(r, o);
  },
  get: function(e, n, r) {
    var o = e.get(n);
    return o ? o.get(r) : void 0;
  },
  delete: function(e, n, r) {
    var o = e.get(n);
    o.delete(r);
  }
};
const It = nc;
var la = he.createContext(null);
process.env.NODE_ENV !== "production" && (la.displayName = "ThemeContext");
const oc = la;
function uo() {
  var t = he.useContext(oc);
  return process.env.NODE_ENV !== "production" && he.useDebugValue(t), t;
}
var ic = ao(aa()), ac = xl(), sc = /* @__PURE__ */ new Map(), lc = {
  disableGeneration: !1,
  generateClassName: ac,
  jss: ic,
  sheetsCache: null,
  sheetsManager: sc,
  sheetsRegistry: null
}, Pr = he.createContext(lc);
process.env.NODE_ENV !== "production" && (Pr.displayName = "StylesContext");
var mr;
function Vn(t) {
  var e = t.children, n = t.injectFirst, r = n === void 0 ? !1 : n, o = t.disableGeneration, i = o === void 0 ? !1 : o, a = Se(t, ["children", "injectFirst", "disableGeneration"]), s = he.useContext(Pr), l = M({}, s, {
    disableGeneration: i
  }, a);
  if (process.env.NODE_ENV !== "production" && typeof window == "undefined" && !l.sheetsManager && console.error("Material-UI: You need to use the ServerStyleSheets API when rendering on the server."), process.env.NODE_ENV !== "production" && l.jss.options.insertionPoint && r && console.error("Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), process.env.NODE_ENV !== "production" && r && a.jss && console.error("Material-UI: You cannot use the jss and injectFirst props at the same time."), !l.jss.options.insertionPoint && r && typeof window != "undefined") {
    if (!mr) {
      var u = document.head;
      mr = document.createComment("mui-inject-first"), u.insertBefore(mr, u.firstChild);
    }
    l.jss = ao({
      plugins: aa().plugins,
      insertionPoint: mr
    });
  }
  return /* @__PURE__ */ he.createElement(Pr.Provider, {
    value: l
  }, e);
}
process.env.NODE_ENV !== "production" && (Vn.propTypes = {
  /**
   * Your component tree.
   */
  children: d.node.isRequired,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: d.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: d.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: d.bool,
  /**
   * JSS's instance.
   */
  jss: d.object,
  /**
   * @ignore
   */
  serverGenerateClassName: d.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: d.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: d.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: d.object
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Vn.propTypes = zi(Vn.propTypes));
var vn = -1e9;
function uc() {
  return vn += 1, process.env.NODE_ENV !== "production" && vn >= 0 && console.warn(["Material-UI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join(`
`)), vn;
}
var cc = {};
const ua = cc;
function fc(t) {
  var e = typeof t == "function";
  return process.env.NODE_ENV !== "production" && Ye(t) !== "object" && !e && console.error(["Material-UI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join(`
`)), {
    create: function(r, o) {
      var i;
      try {
        i = e ? t(r) : t;
      } catch (l) {
        throw process.env.NODE_ENV !== "production" && e === !0 && r === ua && console.error(["Material-UI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`)), l;
      }
      if (!o || !r.overrides || !r.overrides[o])
        return i;
      var a = r.overrides[o], s = M({}, i);
      return Object.keys(a).forEach(function(l) {
        process.env.NODE_ENV !== "production" && (s[l] || console.warn(["Material-UI: You are trying to override a style that does not exist.", "Fix the `".concat(l, "` key of `theme.overrides.").concat(o, "`.")].join(`
`))), s[l] = Mt(s[l], a[l]);
      }), s;
    },
    options: {}
  };
}
function dc(t, e, n) {
  var r = t.state, o = t.stylesOptions;
  if (o.disableGeneration)
    return e || {};
  r.cacheClasses || (r.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  var i = !1;
  return r.classes !== r.cacheClasses.lastJSS && (r.cacheClasses.lastJSS = r.classes, i = !0), e !== r.cacheClasses.lastProp && (r.cacheClasses.lastProp = e, i = !0), i && (r.cacheClasses.value = sa({
    baseClasses: r.cacheClasses.lastJSS,
    newClasses: e,
    Component: n
  })), r.cacheClasses.value;
}
function pc(t, e) {
  var n = t.state, r = t.theme, o = t.stylesOptions, i = t.stylesCreator, a = t.name;
  if (!o.disableGeneration) {
    var s = It.get(o.sheetsManager, i, r);
    s || (s = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    }, It.set(o.sheetsManager, i, r, s));
    var l = M({}, i.options, o, {
      theme: r,
      flip: typeof o.flip == "boolean" ? o.flip : r.direction === "rtl"
    });
    l.generateId = l.serverGenerateClassName || l.generateClassName;
    var u = o.sheetsRegistry;
    if (s.refs === 0) {
      var c;
      o.sheetsCache && (c = It.get(o.sheetsCache, i, r));
      var f = i.create(r, a);
      c || (c = o.jss.createStyleSheet(f, M({
        link: !1
      }, l)), c.attach(), o.sheetsCache && It.set(o.sheetsCache, i, r, c)), u && u.add(c), s.staticSheet = c, s.dynamicStyles = Xi(f);
    }
    if (s.dynamicStyles) {
      var p = o.jss.createStyleSheet(s.dynamicStyles, M({
        link: !0
      }, l));
      p.update(e), p.attach(), n.dynamicSheet = p, n.classes = sa({
        baseClasses: s.staticSheet.classes,
        newClasses: p.classes
      }), u && u.add(p);
    } else
      n.classes = s.staticSheet.classes;
    s.refs += 1;
  }
}
function hc(t, e) {
  var n = t.state;
  n.dynamicSheet && n.dynamicSheet.update(e);
}
function vc(t) {
  var e = t.state, n = t.theme, r = t.stylesOptions, o = t.stylesCreator;
  if (!r.disableGeneration) {
    var i = It.get(r.sheetsManager, o, n);
    i.refs -= 1;
    var a = r.sheetsRegistry;
    i.refs === 0 && (It.delete(r.sheetsManager, o, n), r.jss.removeStyleSheet(i.staticSheet), a && a.remove(i.staticSheet)), e.dynamicSheet && (r.jss.removeStyleSheet(e.dynamicSheet), a && a.remove(e.dynamicSheet));
  }
}
function gc(t, e) {
  var n = he.useRef([]), r, o = he.useMemo(function() {
    return {};
  }, e);
  n.current !== o && (n.current = o, r = t()), he.useEffect(
    function() {
      return function() {
        r && r();
      };
    },
    [o]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function mc(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.name, r = e.classNamePrefix, o = e.Component, i = e.defaultTheme, a = i === void 0 ? ua : i, s = Se(e, ["name", "classNamePrefix", "Component", "defaultTheme"]), l = fc(t), u = n || r || "makeStyles";
  l.options = {
    index: uc(),
    name: n,
    meta: u,
    classNamePrefix: u
  };
  var c = function() {
    var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h = uo() || a, v = M({}, he.useContext(Pr), s), m = he.useRef(), S = he.useRef();
    gc(function() {
      var T = {
        name: n,
        state: {},
        stylesCreator: l,
        stylesOptions: v,
        theme: h
      };
      return pc(T, p), S.current = !1, m.current = T, function() {
        vc(T);
      };
    }, [h, l]), he.useEffect(function() {
      S.current && hc(m.current, p), S.current = !0;
    });
    var b = dc(m.current, p.classes, o);
    return process.env.NODE_ENV !== "production" && he.useDebugValue(b), b;
  };
  return c;
}
var co = Qn(), yc = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, bc = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, xc = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, ca = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, fo = {};
fo[co.ForwardRef] = xc;
fo[co.Memo] = ca;
function mi(t) {
  return co.isMemo(t) ? ca : fo[t.$$typeof] || yc;
}
var Ec = Object.defineProperty, Sc = Object.getOwnPropertyNames, yi = Object.getOwnPropertySymbols, wc = Object.getOwnPropertyDescriptor, Oc = Object.getPrototypeOf, bi = Object.prototype;
function fa(t, e, n) {
  if (typeof e != "string") {
    if (bi) {
      var r = Oc(e);
      r && r !== bi && fa(t, r, n);
    }
    var o = Sc(e);
    yi && (o = o.concat(yi(e)));
    for (var i = mi(t), a = mi(e), s = 0; s < o.length; ++s) {
      var l = o[s];
      if (!bc[l] && !(n && n[l]) && !(a && a[l]) && !(i && i[l])) {
        var u = wc(e, l);
        try {
          Ec(t, l, u);
        } catch (c) {
        }
      }
    }
  }
  return t;
}
var Rc = fa, Tc = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(r) {
    var o = n.defaultTheme, i = n.withTheme, a = i === void 0 ? !1 : i, s = n.name, l = Se(n, ["defaultTheme", "withTheme", "name"]);
    if (process.env.NODE_ENV !== "production" && r === void 0)
      throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join(`
`));
    var u = s;
    if (process.env.NODE_ENV !== "production" && !s) {
      var c = tr(r);
      c !== void 0 && (u = c);
    }
    var f = mc(e, M({
      defaultTheme: o,
      Component: r,
      name: s || r.displayName,
      classNamePrefix: u
    }, l)), p = /* @__PURE__ */ he.forwardRef(function(v, m) {
      v.classes;
      var S = v.innerRef, b = Se(v, ["classes", "innerRef"]), T = f(M({}, r.defaultProps, v)), I, k = b;
      return (typeof s == "string" || a) && (I = uo() || o, s && (k = El({
        theme: I,
        name: s,
        props: b
      })), a && !k.theme && (k.theme = I)), /* @__PURE__ */ he.createElement(r, M({
        ref: S || m,
        classes: T
      }, k));
    });
    return process.env.NODE_ENV !== "production" && (p.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: d.object,
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: jt(d.oneOfType([d.func, d.object]), function(h) {
        return h.innerRef == null, null;
      })
    }), process.env.NODE_ENV !== "production" && (p.displayName = "WithStyles(".concat(tr(r), ")")), Rc(p, r), process.env.NODE_ENV !== "production" && (p.Naked = r, p.options = n, p.useStyles = f), p;
  };
};
const Cc = Tc;
var Pc = gl();
const _c = Pc;
function Ke(t, e) {
  return Cc(t, M({
    defaultTheme: _c
  }, e));
}
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var sr = typeof window != "undefined" && typeof document != "undefined" && typeof navigator != "undefined", Nc = function() {
  for (var t = ["Edge", "Trident", "Firefox"], e = 0; e < t.length; e += 1)
    if (sr && navigator.userAgent.indexOf(t[e]) >= 0)
      return 1;
  return 0;
}();
function Ic(t) {
  var e = !1;
  return function() {
    e || (e = !0, window.Promise.resolve().then(function() {
      e = !1, t();
    }));
  };
}
function kc(t) {
  var e = !1;
  return function() {
    e || (e = !0, setTimeout(function() {
      e = !1, t();
    }, Nc));
  };
}
var Mc = sr && window.Promise, $c = Mc ? Ic : kc;
function da(t) {
  var e = {};
  return t && e.toString.call(t) === "[object Function]";
}
function bt(t, e) {
  if (t.nodeType !== 1)
    return [];
  var n = t.ownerDocument.defaultView, r = n.getComputedStyle(t, null);
  return e ? r[e] : r;
}
function po(t) {
  return t.nodeName === "HTML" ? t : t.parentNode || t.host;
}
function lr(t) {
  if (!t)
    return document.body;
  switch (t.nodeName) {
    case "HTML":
    case "BODY":
      return t.ownerDocument.body;
    case "#document":
      return t.body;
  }
  var e = bt(t), n = e.overflow, r = e.overflowX, o = e.overflowY;
  return /(auto|scroll|overlay)/.test(n + o + r) ? t : lr(po(t));
}
function pa(t) {
  return t && t.referenceNode ? t.referenceNode : t;
}
var xi = sr && !!(window.MSInputMethodContext && document.documentMode), Ei = sr && /MSIE 10/.test(navigator.userAgent);
function Lt(t) {
  return t === 11 ? xi : t === 10 ? Ei : xi || Ei;
}
function $t(t) {
  if (!t)
    return document.documentElement;
  for (var e = Lt(10) ? document.body : null, n = t.offsetParent || null; n === e && t.nextElementSibling; )
    n = (t = t.nextElementSibling).offsetParent;
  var r = n && n.nodeName;
  return !r || r === "BODY" || r === "HTML" ? t ? t.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(n.nodeName) !== -1 && bt(n, "position") === "static" ? $t(n) : n;
}
function Ac(t) {
  var e = t.nodeName;
  return e === "BODY" ? !1 : e === "HTML" || $t(t.firstElementChild) === t;
}
function Ln(t) {
  return t.parentNode !== null ? Ln(t.parentNode) : t;
}
function _r(t, e) {
  if (!t || !t.nodeType || !e || !e.nodeType)
    return document.documentElement;
  var n = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING, r = n ? t : e, o = n ? e : t, i = document.createRange();
  i.setStart(r, 0), i.setEnd(o, 0);
  var a = i.commonAncestorContainer;
  if (t !== a && e !== a || r.contains(o))
    return Ac(a) ? a : $t(a);
  var s = Ln(t);
  return s.host ? _r(s.host, e) : _r(t, Ln(e).host);
}
function At(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", n = e === "top" ? "scrollTop" : "scrollLeft", r = t.nodeName;
  if (r === "BODY" || r === "HTML") {
    var o = t.ownerDocument.documentElement, i = t.ownerDocument.scrollingElement || o;
    return i[n];
  }
  return t[n];
}
function Dc(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = At(e, "top"), o = At(e, "left"), i = n ? -1 : 1;
  return t.top += r * i, t.bottom += r * i, t.left += o * i, t.right += o * i, t;
}
function Si(t, e) {
  var n = e === "x" ? "Left" : "Top", r = n === "Left" ? "Right" : "Bottom";
  return parseFloat(t["border" + n + "Width"]) + parseFloat(t["border" + r + "Width"]);
}
function wi(t, e, n, r) {
  return Math.max(e["offset" + t], e["scroll" + t], n["client" + t], n["offset" + t], n["scroll" + t], Lt(10) ? parseInt(n["offset" + t]) + parseInt(r["margin" + (t === "Height" ? "Top" : "Left")]) + parseInt(r["margin" + (t === "Height" ? "Bottom" : "Right")]) : 0);
}
function ha(t) {
  var e = t.body, n = t.documentElement, r = Lt(10) && getComputedStyle(n);
  return {
    height: wi("Height", e, n, r),
    width: wi("Width", e, n, r)
  };
}
var jc = function(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, Vc = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}(), Dt = function(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}, Ae = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
};
function st(t) {
  return Ae({}, t, {
    right: t.left + t.width,
    bottom: t.top + t.height
  });
}
function Fn(t) {
  var e = {};
  try {
    if (Lt(10)) {
      e = t.getBoundingClientRect();
      var n = At(t, "top"), r = At(t, "left");
      e.top += n, e.left += r, e.bottom += n, e.right += r;
    } else
      e = t.getBoundingClientRect();
  } catch (f) {
  }
  var o = {
    left: e.left,
    top: e.top,
    width: e.right - e.left,
    height: e.bottom - e.top
  }, i = t.nodeName === "HTML" ? ha(t.ownerDocument) : {}, a = i.width || t.clientWidth || o.width, s = i.height || t.clientHeight || o.height, l = t.offsetWidth - a, u = t.offsetHeight - s;
  if (l || u) {
    var c = bt(t);
    l -= Si(c, "x"), u -= Si(c, "y"), o.width -= l, o.height -= u;
  }
  return st(o);
}
function ho(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = Lt(10), o = e.nodeName === "HTML", i = Fn(t), a = Fn(e), s = lr(t), l = bt(e), u = parseFloat(l.borderTopWidth), c = parseFloat(l.borderLeftWidth);
  n && o && (a.top = Math.max(a.top, 0), a.left = Math.max(a.left, 0));
  var f = st({
    top: i.top - a.top - u,
    left: i.left - a.left - c,
    width: i.width,
    height: i.height
  });
  if (f.marginTop = 0, f.marginLeft = 0, !r && o) {
    var p = parseFloat(l.marginTop), h = parseFloat(l.marginLeft);
    f.top -= u - p, f.bottom -= u - p, f.left -= c - h, f.right -= c - h, f.marginTop = p, f.marginLeft = h;
  }
  return (r && !n ? e.contains(s) : e === s && s.nodeName !== "BODY") && (f = Dc(f, e)), f;
}
function Lc(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = t.ownerDocument.documentElement, r = ho(t, n), o = Math.max(n.clientWidth, window.innerWidth || 0), i = Math.max(n.clientHeight, window.innerHeight || 0), a = e ? 0 : At(n), s = e ? 0 : At(n, "left"), l = {
    top: a - r.top + r.marginTop,
    left: s - r.left + r.marginLeft,
    width: o,
    height: i
  };
  return st(l);
}
function va(t) {
  var e = t.nodeName;
  if (e === "BODY" || e === "HTML")
    return !1;
  if (bt(t, "position") === "fixed")
    return !0;
  var n = po(t);
  return n ? va(n) : !1;
}
function ga(t) {
  if (!t || !t.parentElement || Lt())
    return document.documentElement;
  for (var e = t.parentElement; e && bt(e, "transform") === "none"; )
    e = e.parentElement;
  return e || document.documentElement;
}
function vo(t, e, n, r) {
  var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, i = { top: 0, left: 0 }, a = o ? ga(t) : _r(t, pa(e));
  if (r === "viewport")
    i = Lc(a, o);
  else {
    var s = void 0;
    r === "scrollParent" ? (s = lr(po(e)), s.nodeName === "BODY" && (s = t.ownerDocument.documentElement)) : r === "window" ? s = t.ownerDocument.documentElement : s = r;
    var l = ho(s, a, o);
    if (s.nodeName === "HTML" && !va(a)) {
      var u = ha(t.ownerDocument), c = u.height, f = u.width;
      i.top += l.top - l.marginTop, i.bottom = c + l.top, i.left += l.left - l.marginLeft, i.right = f + l.left;
    } else
      i = l;
  }
  n = n || 0;
  var p = typeof n == "number";
  return i.left += p ? n : n.left || 0, i.top += p ? n : n.top || 0, i.right -= p ? n : n.right || 0, i.bottom -= p ? n : n.bottom || 0, i;
}
function Fc(t) {
  var e = t.width, n = t.height;
  return e * n;
}
function ma(t, e, n, r, o) {
  var i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (t.indexOf("auto") === -1)
    return t;
  var a = vo(n, r, i, o), s = {
    top: {
      width: a.width,
      height: e.top - a.top
    },
    right: {
      width: a.right - e.right,
      height: a.height
    },
    bottom: {
      width: a.width,
      height: a.bottom - e.bottom
    },
    left: {
      width: e.left - a.left,
      height: a.height
    }
  }, l = Object.keys(s).map(function(p) {
    return Ae({
      key: p
    }, s[p], {
      area: Fc(s[p])
    });
  }).sort(function(p, h) {
    return h.area - p.area;
  }), u = l.filter(function(p) {
    var h = p.width, v = p.height;
    return h >= n.clientWidth && v >= n.clientHeight;
  }), c = u.length > 0 ? u[0].key : l[0].key, f = t.split("-")[1];
  return c + (f ? "-" + f : "");
}
function ya(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, o = r ? ga(e) : _r(e, pa(n));
  return ho(n, o, r);
}
function ba(t) {
  var e = t.ownerDocument.defaultView, n = e.getComputedStyle(t), r = parseFloat(n.marginTop || 0) + parseFloat(n.marginBottom || 0), o = parseFloat(n.marginLeft || 0) + parseFloat(n.marginRight || 0), i = {
    width: t.offsetWidth + o,
    height: t.offsetHeight + r
  };
  return i;
}
function Nr(t) {
  var e = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return t.replace(/left|right|bottom|top/g, function(n) {
    return e[n];
  });
}
function xa(t, e, n) {
  n = n.split("-")[0];
  var r = ba(t), o = {
    width: r.width,
    height: r.height
  }, i = ["right", "left"].indexOf(n) !== -1, a = i ? "top" : "left", s = i ? "left" : "top", l = i ? "height" : "width", u = i ? "width" : "height";
  return o[a] = e[a] + e[l] / 2 - r[l] / 2, n === s ? o[s] = e[s] - r[u] : o[s] = e[Nr(s)], o;
}
function ur(t, e) {
  return Array.prototype.find ? t.find(e) : t.filter(e)[0];
}
function zc(t, e, n) {
  if (Array.prototype.findIndex)
    return t.findIndex(function(o) {
      return o[e] === n;
    });
  var r = ur(t, function(o) {
    return o[e] === n;
  });
  return t.indexOf(r);
}
function Ea(t, e, n) {
  var r = n === void 0 ? t : t.slice(0, zc(t, "name", n));
  return r.forEach(function(o) {
    o.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var i = o.function || o.fn;
    o.enabled && da(i) && (e.offsets.popper = st(e.offsets.popper), e.offsets.reference = st(e.offsets.reference), e = i(e, o));
  }), e;
}
function Wc() {
  if (!this.state.isDestroyed) {
    var t = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    t.offsets.reference = ya(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = ma(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = xa(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = Ea(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t));
  }
}
function Sa(t, e) {
  return t.some(function(n) {
    var r = n.name, o = n.enabled;
    return o && r === e;
  });
}
function go(t) {
  for (var e = [!1, "ms", "Webkit", "Moz", "O"], n = t.charAt(0).toUpperCase() + t.slice(1), r = 0; r < e.length; r++) {
    var o = e[r], i = o ? "" + o + n : t;
    if (typeof document.body.style[i] != "undefined")
      return i;
  }
  return null;
}
function Uc() {
  return this.state.isDestroyed = !0, Sa(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[go("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function wa(t) {
  var e = t.ownerDocument;
  return e ? e.defaultView : window;
}
function Oa(t, e, n, r) {
  var o = t.nodeName === "BODY", i = o ? t.ownerDocument.defaultView : t;
  i.addEventListener(e, n, { passive: !0 }), o || Oa(lr(i.parentNode), e, n, r), r.push(i);
}
function Bc(t, e, n, r) {
  n.updateBound = r, wa(t).addEventListener("resize", n.updateBound, { passive: !0 });
  var o = lr(t);
  return Oa(o, "scroll", n.updateBound, n.scrollParents), n.scrollElement = o, n.eventsEnabled = !0, n;
}
function Hc() {
  this.state.eventsEnabled || (this.state = Bc(this.reference, this.options, this.state, this.scheduleUpdate));
}
function qc(t, e) {
  return wa(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function(n) {
    n.removeEventListener("scroll", e.updateBound);
  }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e;
}
function Yc() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = qc(this.reference, this.state));
}
function mo(t) {
  return t !== "" && !isNaN(parseFloat(t)) && isFinite(t);
}
function zn(t, e) {
  Object.keys(e).forEach(function(n) {
    var r = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(n) !== -1 && mo(e[n]) && (r = "px"), t.style[n] = e[n] + r;
  });
}
function Kc(t, e) {
  Object.keys(e).forEach(function(n) {
    var r = e[n];
    r !== !1 ? t.setAttribute(n, e[n]) : t.removeAttribute(n);
  });
}
function Gc(t) {
  return zn(t.instance.popper, t.styles), Kc(t.instance.popper, t.attributes), t.arrowElement && Object.keys(t.arrowStyles).length && zn(t.arrowElement, t.arrowStyles), t;
}
function Jc(t, e, n, r, o) {
  var i = ya(o, e, t, n.positionFixed), a = ma(n.placement, i, e, t, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
  return e.setAttribute("x-placement", a), zn(e, { position: n.positionFixed ? "fixed" : "absolute" }), n;
}
function Xc(t, e) {
  var n = t.offsets, r = n.popper, o = n.reference, i = Math.round, a = Math.floor, s = function(b) {
    return b;
  }, l = i(o.width), u = i(r.width), c = ["left", "right"].indexOf(t.placement) !== -1, f = t.placement.indexOf("-") !== -1, p = l % 2 === u % 2, h = l % 2 === 1 && u % 2 === 1, v = e ? c || f || p ? i : a : s, m = e ? i : s;
  return {
    left: v(h && !f && e ? r.left - 1 : r.left),
    top: m(r.top),
    bottom: m(r.bottom),
    right: v(r.right)
  };
}
var Zc = sr && /Firefox/i.test(navigator.userAgent);
function Qc(t, e) {
  var n = e.x, r = e.y, o = t.offsets.popper, i = ur(t.instance.modifiers, function(I) {
    return I.name === "applyStyle";
  }).gpuAcceleration;
  i !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var a = i !== void 0 ? i : e.gpuAcceleration, s = $t(t.instance.popper), l = Fn(s), u = {
    position: o.position
  }, c = Xc(t, window.devicePixelRatio < 2 || !Zc), f = n === "bottom" ? "top" : "bottom", p = r === "right" ? "left" : "right", h = go("transform"), v = void 0, m = void 0;
  if (f === "bottom" ? s.nodeName === "HTML" ? m = -s.clientHeight + c.bottom : m = -l.height + c.bottom : m = c.top, p === "right" ? s.nodeName === "HTML" ? v = -s.clientWidth + c.right : v = -l.width + c.right : v = c.left, a && h)
    u[h] = "translate3d(" + v + "px, " + m + "px, 0)", u[f] = 0, u[p] = 0, u.willChange = "transform";
  else {
    var S = f === "bottom" ? -1 : 1, b = p === "right" ? -1 : 1;
    u[f] = m * S, u[p] = v * b, u.willChange = f + ", " + p;
  }
  var T = {
    "x-placement": t.placement
  };
  return t.attributes = Ae({}, T, t.attributes), t.styles = Ae({}, u, t.styles), t.arrowStyles = Ae({}, t.offsets.arrow, t.arrowStyles), t;
}
function Ra(t, e, n) {
  var r = ur(t, function(s) {
    var l = s.name;
    return l === e;
  }), o = !!r && t.some(function(s) {
    return s.name === n && s.enabled && s.order < r.order;
  });
  if (!o) {
    var i = "`" + e + "`", a = "`" + n + "`";
    console.warn(a + " modifier is required by " + i + " modifier in order to work, be sure to include it before " + i + "!");
  }
  return o;
}
function ef(t, e) {
  var n;
  if (!Ra(t.instance.modifiers, "arrow", "keepTogether"))
    return t;
  var r = e.element;
  if (typeof r == "string") {
    if (r = t.instance.popper.querySelector(r), !r)
      return t;
  } else if (!t.instance.popper.contains(r))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;
  var o = t.placement.split("-")[0], i = t.offsets, a = i.popper, s = i.reference, l = ["left", "right"].indexOf(o) !== -1, u = l ? "height" : "width", c = l ? "Top" : "Left", f = c.toLowerCase(), p = l ? "left" : "top", h = l ? "bottom" : "right", v = ba(r)[u];
  s[h] - v < a[f] && (t.offsets.popper[f] -= a[f] - (s[h] - v)), s[f] + v > a[h] && (t.offsets.popper[f] += s[f] + v - a[h]), t.offsets.popper = st(t.offsets.popper);
  var m = s[f] + s[u] / 2 - v / 2, S = bt(t.instance.popper), b = parseFloat(S["margin" + c]), T = parseFloat(S["border" + c + "Width"]), I = m - t.offsets.popper[f] - b - T;
  return I = Math.max(Math.min(a[u] - v, I), 0), t.arrowElement = r, t.offsets.arrow = (n = {}, Dt(n, f, Math.round(I)), Dt(n, p, ""), n), t;
}
function tf(t) {
  return t === "end" ? "start" : t === "start" ? "end" : t;
}
var Ta = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], gn = Ta.slice(3);
function Oi(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = gn.indexOf(t), r = gn.slice(n + 1).concat(gn.slice(0, n));
  return e ? r.reverse() : r;
}
var mn = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function rf(t, e) {
  if (Sa(t.instance.modifiers, "inner") || t.flipped && t.placement === t.originalPlacement)
    return t;
  var n = vo(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed), r = t.placement.split("-")[0], o = Nr(r), i = t.placement.split("-")[1] || "", a = [];
  switch (e.behavior) {
    case mn.FLIP:
      a = [r, o];
      break;
    case mn.CLOCKWISE:
      a = Oi(r);
      break;
    case mn.COUNTERCLOCKWISE:
      a = Oi(r, !0);
      break;
    default:
      a = e.behavior;
  }
  return a.forEach(function(s, l) {
    if (r !== s || a.length === l + 1)
      return t;
    r = t.placement.split("-")[0], o = Nr(r);
    var u = t.offsets.popper, c = t.offsets.reference, f = Math.floor, p = r === "left" && f(u.right) > f(c.left) || r === "right" && f(u.left) < f(c.right) || r === "top" && f(u.bottom) > f(c.top) || r === "bottom" && f(u.top) < f(c.bottom), h = f(u.left) < f(n.left), v = f(u.right) > f(n.right), m = f(u.top) < f(n.top), S = f(u.bottom) > f(n.bottom), b = r === "left" && h || r === "right" && v || r === "top" && m || r === "bottom" && S, T = ["top", "bottom"].indexOf(r) !== -1, I = !!e.flipVariations && (T && i === "start" && h || T && i === "end" && v || !T && i === "start" && m || !T && i === "end" && S), k = !!e.flipVariationsByContent && (T && i === "start" && v || T && i === "end" && h || !T && i === "start" && S || !T && i === "end" && m), y = I || k;
    (p || b || y) && (t.flipped = !0, (p || b) && (r = a[l + 1]), y && (i = tf(i)), t.placement = r + (i ? "-" + i : ""), t.offsets.popper = Ae({}, t.offsets.popper, xa(t.instance.popper, t.offsets.reference, t.placement)), t = Ea(t.instance.modifiers, t, "flip"));
  }), t;
}
function nf(t) {
  var e = t.offsets, n = e.popper, r = e.reference, o = t.placement.split("-")[0], i = Math.floor, a = ["top", "bottom"].indexOf(o) !== -1, s = a ? "right" : "bottom", l = a ? "left" : "top", u = a ? "width" : "height";
  return n[s] < i(r[l]) && (t.offsets.popper[l] = i(r[l]) - n[u]), n[l] > i(r[s]) && (t.offsets.popper[l] = i(r[s])), t;
}
function of(t, e, n, r) {
  var o = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), i = +o[1], a = o[2];
  if (!i)
    return t;
  if (a.indexOf("%") === 0) {
    var s = void 0;
    switch (a) {
      case "%p":
        s = n;
        break;
      case "%":
      case "%r":
      default:
        s = r;
    }
    var l = st(s);
    return l[e] / 100 * i;
  } else if (a === "vh" || a === "vw") {
    var u = void 0;
    return a === "vh" ? u = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : u = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), u / 100 * i;
  } else
    return i;
}
function af(t, e, n, r) {
  var o = [0, 0], i = ["right", "left"].indexOf(r) !== -1, a = t.split(/(\+|\-)/).map(function(c) {
    return c.trim();
  }), s = a.indexOf(ur(a, function(c) {
    return c.search(/,|\s/) !== -1;
  }));
  a[s] && a[s].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var l = /\s*,\s*|\s+/, u = s !== -1 ? [a.slice(0, s).concat([a[s].split(l)[0]]), [a[s].split(l)[1]].concat(a.slice(s + 1))] : [a];
  return u = u.map(function(c, f) {
    var p = (f === 1 ? !i : i) ? "height" : "width", h = !1;
    return c.reduce(function(v, m) {
      return v[v.length - 1] === "" && ["+", "-"].indexOf(m) !== -1 ? (v[v.length - 1] = m, h = !0, v) : h ? (v[v.length - 1] += m, h = !1, v) : v.concat(m);
    }, []).map(function(v) {
      return of(v, p, e, n);
    });
  }), u.forEach(function(c, f) {
    c.forEach(function(p, h) {
      mo(p) && (o[f] += p * (c[h - 1] === "-" ? -1 : 1));
    });
  }), o;
}
function sf(t, e) {
  var n = e.offset, r = t.placement, o = t.offsets, i = o.popper, a = o.reference, s = r.split("-")[0], l = void 0;
  return mo(+n) ? l = [+n, 0] : l = af(n, i, a, s), s === "left" ? (i.top += l[0], i.left -= l[1]) : s === "right" ? (i.top += l[0], i.left += l[1]) : s === "top" ? (i.left += l[0], i.top -= l[1]) : s === "bottom" && (i.left += l[0], i.top += l[1]), t.popper = i, t;
}
function lf(t, e) {
  var n = e.boundariesElement || $t(t.instance.popper);
  t.instance.reference === n && (n = $t(n));
  var r = go("transform"), o = t.instance.popper.style, i = o.top, a = o.left, s = o[r];
  o.top = "", o.left = "", o[r] = "";
  var l = vo(t.instance.popper, t.instance.reference, e.padding, n, t.positionFixed);
  o.top = i, o.left = a, o[r] = s, e.boundaries = l;
  var u = e.priority, c = t.offsets.popper, f = {
    primary: function(h) {
      var v = c[h];
      return c[h] < l[h] && !e.escapeWithReference && (v = Math.max(c[h], l[h])), Dt({}, h, v);
    },
    secondary: function(h) {
      var v = h === "right" ? "left" : "top", m = c[v];
      return c[h] > l[h] && !e.escapeWithReference && (m = Math.min(c[v], l[h] - (h === "right" ? c.width : c.height))), Dt({}, v, m);
    }
  };
  return u.forEach(function(p) {
    var h = ["left", "top"].indexOf(p) !== -1 ? "primary" : "secondary";
    c = Ae({}, c, f[h](p));
  }), t.offsets.popper = c, t;
}
function uf(t) {
  var e = t.placement, n = e.split("-")[0], r = e.split("-")[1];
  if (r) {
    var o = t.offsets, i = o.reference, a = o.popper, s = ["bottom", "top"].indexOf(n) !== -1, l = s ? "left" : "top", u = s ? "width" : "height", c = {
      start: Dt({}, l, i[l]),
      end: Dt({}, l, i[l] + i[u] - a[u])
    };
    t.offsets.popper = Ae({}, a, c[r]);
  }
  return t;
}
function cf(t) {
  if (!Ra(t.instance.modifiers, "hide", "preventOverflow"))
    return t;
  var e = t.offsets.reference, n = ur(t.instance.modifiers, function(r) {
    return r.name === "preventOverflow";
  }).boundaries;
  if (e.bottom < n.top || e.left > n.right || e.top > n.bottom || e.right < n.left) {
    if (t.hide === !0)
      return t;
    t.hide = !0, t.attributes["x-out-of-boundaries"] = "";
  } else {
    if (t.hide === !1)
      return t;
    t.hide = !1, t.attributes["x-out-of-boundaries"] = !1;
  }
  return t;
}
function ff(t) {
  var e = t.placement, n = e.split("-")[0], r = t.offsets, o = r.popper, i = r.reference, a = ["left", "right"].indexOf(n) !== -1, s = ["top", "left"].indexOf(n) === -1;
  return o[a ? "left" : "top"] = i[n] - (s ? o[a ? "width" : "height"] : 0), t.placement = Nr(e), t.offsets.popper = st(o), t;
}
var df = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: uf
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: sf,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: lf,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: nf
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: ef,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: rf,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: ff
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: cf
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Qc,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Gc,
    /** @prop {Function} */
    onLoad: Jc,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, pf = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: df
}, Dr = function() {
  function t(e, n) {
    var r = this, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    jc(this, t), this.scheduleUpdate = function() {
      return requestAnimationFrame(r.update);
    }, this.update = $c(this.update.bind(this)), this.options = Ae({}, t.Defaults, o), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = e && e.jquery ? e[0] : e, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(Ae({}, t.Defaults.modifiers, o.modifiers)).forEach(function(a) {
      r.options.modifiers[a] = Ae({}, t.Defaults.modifiers[a] || {}, o.modifiers ? o.modifiers[a] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(a) {
      return Ae({
        name: a
      }, r.options.modifiers[a]);
    }).sort(function(a, s) {
      return a.order - s.order;
    }), this.modifiers.forEach(function(a) {
      a.enabled && da(a.onLoad) && a.onLoad(r.reference, r.popper, r.options, a, r.state);
    }), this.update();
    var i = this.options.eventsEnabled;
    i && this.enableEventListeners(), this.state.eventsEnabled = i;
  }
  return Vc(t, [{
    key: "update",
    value: function() {
      return Wc.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return Uc.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return Hc.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return Yc.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), t;
}();
Dr.Utils = (typeof window != "undefined" ? window : global).PopperUtils;
Dr.placements = Ta;
Dr.Defaults = pf;
const hf = Dr;
function yo(t, e) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function(n, r, o, i, a) {
    var s = o || "<<anonymous>>", l = a || r;
    return typeof n[r] != "undefined" ? new Error("The ".concat(i, " `").concat(l, "` of ") + "`".concat(s, "` is deprecated. ").concat(e)) : null;
  };
}
function yt(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function it(t, e) {
  return g.useMemo(function() {
    return t == null && e == null ? null : function(n) {
      yt(t, n), yt(e, n);
    };
  }, [t, e]);
}
function vf(t) {
  return t = typeof t == "function" ? t() : t, Mr.findDOMNode(t);
}
var yn = typeof window != "undefined" ? g.useLayoutEffect : g.useEffect, Ir = /* @__PURE__ */ g.forwardRef(function(e, n) {
  var r = e.children, o = e.container, i = e.disablePortal, a = i === void 0 ? !1 : i, s = e.onRendered, l = g.useState(null), u = l[0], c = l[1], f = it(/* @__PURE__ */ g.isValidElement(r) ? r.ref : null, n);
  return yn(function() {
    a || c(vf(o) || document.body);
  }, [o, a]), yn(function() {
    if (u && !a)
      return yt(n, u), function() {
        yt(n, null);
      };
  }, [n, u, a]), yn(function() {
    s && (u || a) && s();
  }, [s, u, a]), a ? /* @__PURE__ */ g.isValidElement(r) ? /* @__PURE__ */ g.cloneElement(r, {
    ref: f
  }) : r : u && /* @__PURE__ */ Mr.createPortal(r, u);
});
process.env.NODE_ENV !== "production" && (Ir.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The children to render into the `container`.
   */
  children: d.node,
  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: d.oneOfType([wn, d.instanceOf(g.Component), d.func]),
  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: d.bool,
  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be removed in v5, the ref can be used instead.
   * @deprecated Use the ref instead.
   */
  onRendered: yo(d.func, "Use the ref instead.")
});
process.env.NODE_ENV !== "production" && (Ir["propTypes"] = zi(Ir.propTypes));
const gf = Ir;
function Wn() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return e.reduce(function(r, o) {
    return o == null ? r : (process.env.NODE_ENV !== "production" && typeof o != "function" && console.error("Material-UI: Invalid Argument Type, must only provide functions, undefined, or null."), function() {
      for (var a = arguments.length, s = new Array(a), l = 0; l < a; l++)
        s[l] = arguments[l];
      r.apply(this, s), o.apply(this, s);
    });
  }, function() {
  });
}
function mf(t, e) {
  var n = e && e.direction || "ltr";
  if (n === "ltr")
    return t;
  switch (t) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return t;
  }
}
function Un(t) {
  return typeof t == "function" ? t() : t;
}
var yf = typeof window != "undefined" ? g.useLayoutEffect : g.useEffect, bf = {}, Ca = /* @__PURE__ */ g.forwardRef(function(e, n) {
  var r = e.anchorEl, o = e.children, i = e.container, a = e.disablePortal, s = a === void 0 ? !1 : a, l = e.keepMounted, u = l === void 0 ? !1 : l, c = e.modifiers, f = e.open, p = e.placement, h = p === void 0 ? "bottom" : p, v = e.popperOptions, m = v === void 0 ? bf : v, S = e.popperRef, b = e.style, T = e.transition, I = T === void 0 ? !1 : T, k = Se(e, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]), y = g.useRef(null), _ = it(y, n), z = g.useRef(null), W = it(z, S), D = g.useRef(W);
  yf(function() {
    D.current = W;
  }, [W]), g.useImperativeHandle(S, function() {
    return z.current;
  }, []);
  var J = g.useState(!0), ie = J[0], ce = J[1], C = uo(), Z = mf(h, C), fe = g.useState(Z), Q = fe[0], ee = fe[1];
  g.useEffect(function() {
    z.current && z.current.update();
  });
  var ae = g.useCallback(function() {
    if (!(!y.current || !r || !f)) {
      z.current && (z.current.destroy(), D.current(null));
      var j = function(K) {
        ee(K.placement);
      }, q = Un(r);
      if (process.env.NODE_ENV !== "production" && q && q.nodeType === 1) {
        var V = q.getBoundingClientRect();
        process.env.NODE_ENV !== "test" && V.top === 0 && V.left === 0 && V.right === 0 && V.bottom === 0 && console.warn(["Material-UI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      }
      var B = new hf(Un(r), y.current, M({
        placement: Z
      }, m, {
        modifiers: M({}, s ? {} : {
          // It's using scrollParent by default, we can use the viewport when using a portal.
          preventOverflow: {
            boundariesElement: "window"
          }
        }, c, m.modifiers),
        // We could have been using a custom modifier like react-popper is doing.
        // But it seems this is the best public API for this use case.
        onCreate: Wn(j, m.onCreate),
        onUpdate: Wn(j, m.onUpdate)
      }));
      D.current(B);
    }
  }, [r, s, c, f, Z, m]), xe = g.useCallback(function(j) {
    yt(_, j), ae();
  }, [_, ae]), w = function() {
    ce(!1);
  }, O = function() {
    z.current && (z.current.destroy(), D.current(null));
  }, A = function() {
    ce(!0), O();
  };
  if (g.useEffect(function() {
    return function() {
      O();
    };
  }, []), g.useEffect(function() {
    !f && !I && O();
  }, [f, I]), !u && !f && (!I || ie))
    return null;
  var U = {
    placement: Q
  };
  return I && (U.TransitionProps = {
    in: f,
    onEnter: w,
    onExited: A
  }), /* @__PURE__ */ g.createElement(gf, {
    disablePortal: s,
    container: i
  }, /* @__PURE__ */ g.createElement("div", M({
    ref: xe,
    role: "tooltip"
  }, k, {
    style: M({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: "fixed",
      // Fix Popper.js display issue
      top: 0,
      left: 0,
      display: !f && u && !I ? "none" : null
    }, b)
  }), typeof o == "function" ? o(U) : o));
});
process.env.NODE_ENV !== "production" && (Ca.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: jt(d.oneOfType([wn, d.object, d.func]), function(t) {
    if (t.open) {
      var e = Un(t.anchorEl);
      if (e && e.nodeType === 1) {
        var n = e.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["Material-UI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!e || typeof e.clientWidth != "number" || typeof e.clientHeight != "number" || typeof e.getBoundingClientRect != "function")
        return new Error(["Material-UI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a referenceObject ", "(https://popper.js.org/docs/v1/#referenceObject)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: d.oneOfType([d.node, d.func]).isRequired,
  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: d.oneOfType([wn, d.instanceOf(g.Component), d.func]),
  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: d.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: d.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
   */
  modifiers: d.object,
  /**
   * If `true`, the popper is visible.
   */
  open: d.bool.isRequired,
  /**
   * Popper placement.
   */
  placement: d.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
   */
  popperOptions: d.object,
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: On,
  /**
   * @ignore
   */
  style: d.object,
  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: d.bool
});
const xf = Ca;
function Ne(t) {
  if (typeof t != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : Sr(7));
  return t.charAt(0).toUpperCase() + t.slice(1);
}
var Ef = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: "border-box",
      lineHeight: "48px",
      listStyle: "none",
      color: e.palette.text.secondary,
      fontFamily: e.typography.fontFamily,
      fontWeight: e.typography.fontWeightMedium,
      fontSize: e.typography.pxToRem(14)
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },
    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },
    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: "inherit"
    }
  };
}, Pa = /* @__PURE__ */ g.forwardRef(function(e, n) {
  var r = e.classes, o = e.className, i = e.color, a = i === void 0 ? "default" : i, s = e.component, l = s === void 0 ? "li" : s, u = e.disableGutters, c = u === void 0 ? !1 : u, f = e.disableSticky, p = f === void 0 ? !1 : f, h = e.inset, v = h === void 0 ? !1 : h, m = Se(e, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);
  return /* @__PURE__ */ g.createElement(l, M({
    className: be(r.root, o, a !== "default" && r["color".concat(Ne(a))], v && r.inset, !p && r.sticky, !c && r.gutters),
    ref: n
  }, m));
});
process.env.NODE_ENV !== "production" && (Pa.propTypes = {
  /**
   * The content of the component.
   */
  children: d.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: d.object.isRequired,
  /**
   * @ignore
   */
  className: d.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: d.oneOf(["default", "primary", "inherit"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: d.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   */
  disableGutters: d.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: d.bool,
  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: d.bool
});
const Sf = Ke(Ef, {
  name: "MuiListSubheader"
})(Pa);
var wf = function(e) {
  var n = {};
  return e.shadows.forEach(function(r, o) {
    n["elevation".concat(o)] = {
      boxShadow: r
    };
  }), M({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: e.palette.background.paper,
      color: e.palette.text.primary,
      transition: e.transitions.create("box-shadow")
    },
    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: e.shape.borderRadius
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(e.palette.divider)
    }
  }, n);
}, _a = /* @__PURE__ */ g.forwardRef(function(e, n) {
  var r = e.classes, o = e.className, i = e.component, a = i === void 0 ? "div" : i, s = e.square, l = s === void 0 ? !1 : s, u = e.elevation, c = u === void 0 ? 1 : u, f = e.variant, p = f === void 0 ? "elevation" : f, h = Se(e, ["classes", "className", "component", "square", "elevation", "variant"]);
  return /* @__PURE__ */ g.createElement(a, M({
    className: be(r.root, o, p === "outlined" ? r.outlined : r["elevation".concat(c)], !l && r.rounded),
    ref: n
  }, h));
});
process.env.NODE_ENV !== "production" && (_a.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: d.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: d.object,
  /**
   * @ignore
   */
  className: d.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: d.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: jt(d.number, function(t) {
    var e = t.classes, n = t.elevation;
    return e === void 0 ? null : n != null && e["elevation".concat(n)] === void 0 ? new Error("Material-UI: This elevation `".concat(n, "` is not implemented.")) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   */
  square: d.bool,
  /**
   * The variant to use.
   */
  variant: d.oneOf(["elevation", "outlined"])
});
const Na = Ke(wf, {
  name: "MuiPaper"
})(_a);
var Of = typeof window != "undefined" ? g.useLayoutEffect : g.useEffect;
function Ve(t) {
  var e = g.useRef(t);
  return Of(function() {
    e.current = t;
  }), g.useCallback(function() {
    return e.current.apply(void 0, arguments);
  }, []);
}
var jr = !0, Bn = !1, Ri = null, Rf = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function Tf(t) {
  var e = t.type, n = t.tagName;
  return !!(n === "INPUT" && Rf[e] && !t.readOnly || n === "TEXTAREA" && !t.readOnly || t.isContentEditable);
}
function Cf(t) {
  t.metaKey || t.altKey || t.ctrlKey || (jr = !0);
}
function bn() {
  jr = !1;
}
function Pf() {
  this.visibilityState === "hidden" && Bn && (jr = !0);
}
function _f(t) {
  t.addEventListener("keydown", Cf, !0), t.addEventListener("mousedown", bn, !0), t.addEventListener("pointerdown", bn, !0), t.addEventListener("touchstart", bn, !0), t.addEventListener("visibilitychange", Pf, !0);
}
function Ti(t) {
  var e = t.target;
  try {
    return e.matches(":focus-visible");
  } catch (n) {
  }
  return jr || Tf(e);
}
function Nf() {
  Bn = !0, window.clearTimeout(Ri), Ri = window.setTimeout(function() {
    Bn = !1;
  }, 100);
}
function Ia() {
  var t = g.useCallback(function(e) {
    var n = Mr.findDOMNode(e);
    n != null && _f(n.ownerDocument);
  }, []);
  return process.env.NODE_ENV !== "production" && g.useDebugValue(Ti), {
    isFocusVisible: Ti,
    onBlurVisible: Nf,
    ref: t
  };
}
const Ci = he.createContext(null);
function bo(t, e) {
  var n = function(i) {
    return e && yr(i) ? e(i) : i;
  }, r = /* @__PURE__ */ Object.create(null);
  return t && ds.map(t, function(o) {
    return o;
  }).forEach(function(o) {
    r[o.key] = n(o);
  }), r;
}
function If(t, e) {
  t = t || {}, e = e || {};
  function n(c) {
    return c in e ? e[c] : t[c];
  }
  var r = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in t)
    i in e ? o.length && (r[i] = o, o = []) : o.push(i);
  var a, s = {};
  for (var l in e) {
    if (r[l])
      for (a = 0; a < r[l].length; a++) {
        var u = r[l][a];
        s[r[l][a]] = n(u);
      }
    s[l] = n(l);
  }
  for (a = 0; a < o.length; a++)
    s[o[a]] = n(o[a]);
  return s;
}
function vt(t, e, n) {
  return n[e] != null ? n[e] : t.props[e];
}
function kf(t, e) {
  return bo(t.children, function(n) {
    return br(n, {
      onExited: e.bind(null, n),
      in: !0,
      appear: vt(n, "appear", t),
      enter: vt(n, "enter", t),
      exit: vt(n, "exit", t)
    });
  });
}
function Mf(t, e, n) {
  var r = bo(t.children), o = If(e, r);
  return Object.keys(o).forEach(function(i) {
    var a = o[i];
    if (yr(a)) {
      var s = i in e, l = i in r, u = e[i], c = yr(u) && !u.props.in;
      l && (!s || c) ? o[i] = br(a, {
        onExited: n.bind(null, a),
        in: !0,
        exit: vt(a, "exit", t),
        enter: vt(a, "enter", t)
      }) : !l && s && !c ? o[i] = br(a, {
        in: !1
      }) : l && s && yr(u) && (o[i] = br(a, {
        onExited: n.bind(null, a),
        in: u.props.in,
        exit: vt(a, "exit", t),
        enter: vt(a, "enter", t)
      }));
    }
  }), o;
}
var $f = Object.values || function(t) {
  return Object.keys(t).map(function(e) {
    return t[e];
  });
}, Af = {
  component: "div",
  childFactory: function(e) {
    return e;
  }
}, xo = /* @__PURE__ */ function(t) {
  no(e, t);
  function e(r, o) {
    var i;
    i = t.call(this, r, o) || this;
    var a = i.handleExited.bind(Pn(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, i;
  }
  var n = e.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, e.getDerivedStateFromProps = function(o, i) {
    var a = i.children, s = i.handleExited, l = i.firstRender;
    return {
      children: l ? kf(o, s) : Mf(o, a, s),
      firstRender: !1
    };
  }, n.handleExited = function(o, i) {
    var a = bo(this.props.children);
    o.key in a || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(s) {
      var l = M({}, s.children);
      return delete l[o.key], {
        children: l
      };
    }));
  }, n.render = function() {
    var o = this.props, i = o.component, a = o.childFactory, s = Zn(o, ["component", "childFactory"]), l = this.state.contextValue, u = $f(this.state.children).map(a);
    return delete s.appear, delete s.enter, delete s.exit, i === null ? /* @__PURE__ */ he.createElement(Ci.Provider, {
      value: l
    }, u) : /* @__PURE__ */ he.createElement(Ci.Provider, {
      value: l
    }, /* @__PURE__ */ he.createElement(i, s, u));
  }, e;
}(he.Component);
xo.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: d.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: d.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: d.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: d.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: d.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: d.func
} : {};
xo.defaultProps = Af;
const Df = xo;
var jf = typeof window == "undefined" ? g.useEffect : g.useLayoutEffect;
function ka(t) {
  var e = t.classes, n = t.pulsate, r = n === void 0 ? !1 : n, o = t.rippleX, i = t.rippleY, a = t.rippleSize, s = t.in, l = t.onExited, u = l === void 0 ? function() {
  } : l, c = t.timeout, f = g.useState(!1), p = f[0], h = f[1], v = be(e.ripple, e.rippleVisible, r && e.ripplePulsate), m = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + o
  }, S = be(e.child, p && e.childLeaving, r && e.childPulsate), b = Ve(u);
  return jf(function() {
    if (!s) {
      h(!0);
      var T = setTimeout(b, c);
      return function() {
        clearTimeout(T);
      };
    }
  }, [b, s, c]), /* @__PURE__ */ g.createElement("span", {
    className: v,
    style: m
  }, /* @__PURE__ */ g.createElement("span", {
    className: S
  }));
}
process.env.NODE_ENV !== "production" && (ka.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: d.object.isRequired,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: d.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: d.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: d.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: d.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: d.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: d.number,
  /**
   * exit delay
   */
  timeout: d.number.isRequired
});
var Hn = 550, Vf = 80, Lf = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: "hidden",
      pointerEvents: "none",
      position: "absolute",
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: "inherit"
    },
    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: "absolute"
    },
    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: "scale(1)",
      animation: "$enter ".concat(Hn, "ms ").concat(e.transitions.easing.easeInOut)
    },
    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(e.transitions.duration.shorter, "ms")
    },
    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: "block",
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      backgroundColor: "currentColor"
    },
    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(Hn, "ms ").concat(e.transitions.easing.easeInOut)
    },
    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: "absolute",
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(e.transitions.easing.easeInOut, " 200ms infinite")
    },
    "@keyframes enter": {
      "0%": {
        transform: "scale(0)",
        opacity: 0.1
      },
      "100%": {
        transform: "scale(1)",
        opacity: 0.3
      }
    },
    "@keyframes exit": {
      "0%": {
        opacity: 1
      },
      "100%": {
        opacity: 0
      }
    },
    "@keyframes pulsate": {
      "0%": {
        transform: "scale(1)"
      },
      "50%": {
        transform: "scale(0.92)"
      },
      "100%": {
        transform: "scale(1)"
      }
    }
  };
}, Ma = /* @__PURE__ */ g.forwardRef(function(e, n) {
  var r = e.center, o = r === void 0 ? !1 : r, i = e.classes, a = e.className, s = Se(e, ["center", "classes", "className"]), l = g.useState([]), u = l[0], c = l[1], f = g.useRef(0), p = g.useRef(null);
  g.useEffect(function() {
    p.current && (p.current(), p.current = null);
  }, [u]);
  var h = g.useRef(!1), v = g.useRef(null), m = g.useRef(null), S = g.useRef(null);
  g.useEffect(function() {
    return function() {
      clearTimeout(v.current);
    };
  }, []);
  var b = g.useCallback(function(y) {
    var _ = y.pulsate, z = y.rippleX, W = y.rippleY, D = y.rippleSize, J = y.cb;
    c(function(ie) {
      return [].concat(Hi(ie), [/* @__PURE__ */ g.createElement(ka, {
        key: f.current,
        classes: i,
        timeout: Hn,
        pulsate: _,
        rippleX: z,
        rippleY: W,
        rippleSize: D
      })]);
    }), f.current += 1, p.current = J;
  }, [i]), T = g.useCallback(function() {
    var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, z = arguments.length > 2 ? arguments[2] : void 0, W = _.pulsate, D = W === void 0 ? !1 : W, J = _.center, ie = J === void 0 ? o || _.pulsate : J, ce = _.fakeElement, C = ce === void 0 ? !1 : ce;
    if (y.type === "mousedown" && h.current) {
      h.current = !1;
      return;
    }
    y.type === "touchstart" && (h.current = !0);
    var Z = C ? null : S.current, fe = Z ? Z.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }, Q, ee, ae;
    if (ie || y.clientX === 0 && y.clientY === 0 || !y.clientX && !y.touches)
      Q = Math.round(fe.width / 2), ee = Math.round(fe.height / 2);
    else {
      var xe = y.touches ? y.touches[0] : y, w = xe.clientX, O = xe.clientY;
      Q = Math.round(w - fe.left), ee = Math.round(O - fe.top);
    }
    if (ie)
      ae = Math.sqrt((2 * Math.pow(fe.width, 2) + Math.pow(fe.height, 2)) / 3), ae % 2 === 0 && (ae += 1);
    else {
      var A = Math.max(Math.abs((Z ? Z.clientWidth : 0) - Q), Q) * 2 + 2, U = Math.max(Math.abs((Z ? Z.clientHeight : 0) - ee), ee) * 2 + 2;
      ae = Math.sqrt(Math.pow(A, 2) + Math.pow(U, 2));
    }
    y.touches ? m.current === null && (m.current = function() {
      b({
        pulsate: D,
        rippleX: Q,
        rippleY: ee,
        rippleSize: ae,
        cb: z
      });
    }, v.current = setTimeout(function() {
      m.current && (m.current(), m.current = null);
    }, Vf)) : b({
      pulsate: D,
      rippleX: Q,
      rippleY: ee,
      rippleSize: ae,
      cb: z
    });
  }, [o, b]), I = g.useCallback(function() {
    T({}, {
      pulsate: !0
    });
  }, [T]), k = g.useCallback(function(y, _) {
    if (clearTimeout(v.current), y.type === "touchend" && m.current) {
      y.persist(), m.current(), m.current = null, v.current = setTimeout(function() {
        k(y, _);
      });
      return;
    }
    m.current = null, c(function(z) {
      return z.length > 0 ? z.slice(1) : z;
    }), p.current = _;
  }, []);
  return g.useImperativeHandle(n, function() {
    return {
      pulsate: I,
      start: T,
      stop: k
    };
  }, [I, T, k]), /* @__PURE__ */ g.createElement("span", M({
    className: be(i.root, a),
    ref: S
  }, s), /* @__PURE__ */ g.createElement(Df, {
    component: null,
    exit: !0
  }, u));
});
process.env.NODE_ENV !== "production" && (Ma.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: d.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: d.object.isRequired,
  /**
   * @ignore
   */
  className: d.string
});
const Ff = Ke(Lf, {
  flip: !1,
  name: "MuiTouchRipple"
})(/* @__PURE__ */ g.memo(Ma));
var zf = {
  /* Styles applied to the root element. */
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    "-moz-appearance": "none",
    // Reset
    "-webkit-appearance": "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
      borderStyle: "none"
      // Remove Firefox dotted outline.
    },
    "&$disabled": {
      pointerEvents: "none",
      // Disable link interactions
      cursor: "default"
    },
    "@media print": {
      colorAdjust: "exact"
    }
  },
  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},
  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
}, $a = /* @__PURE__ */ g.forwardRef(function(e, n) {
  var r = e.action, o = e.buttonRef, i = e.centerRipple, a = i === void 0 ? !1 : i, s = e.children, l = e.classes, u = e.className, c = e.component, f = c === void 0 ? "button" : c, p = e.disabled, h = p === void 0 ? !1 : p, v = e.disableRipple, m = v === void 0 ? !1 : v, S = e.disableTouchRipple, b = S === void 0 ? !1 : S, T = e.focusRipple, I = T === void 0 ? !1 : T, k = e.focusVisibleClassName, y = e.onBlur, _ = e.onClick, z = e.onFocus, W = e.onFocusVisible, D = e.onKeyDown, J = e.onKeyUp, ie = e.onMouseDown, ce = e.onMouseLeave, C = e.onMouseUp, Z = e.onTouchEnd, fe = e.onTouchMove, Q = e.onTouchStart, ee = e.onDragLeave, ae = e.tabIndex, xe = ae === void 0 ? 0 : ae, w = e.TouchRippleProps, O = e.type, A = O === void 0 ? "button" : O, U = Se(e, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]), j = g.useRef(null);
  function q() {
    return Mr.findDOMNode(j.current);
  }
  var V = g.useRef(null), B = g.useState(!1), H = B[0], K = B[1];
  h && H && K(!1);
  var L = Ia(), N = L.isFocusVisible, P = L.onBlurVisible, me = L.ref;
  g.useImperativeHandle(r, function() {
    return {
      focusVisible: function() {
        K(!0), j.current.focus();
      }
    };
  }, []), g.useEffect(function() {
    H && I && !m && V.current.pulsate();
  }, [m, I, H]);
  function pe(Y, Ie) {
    var X = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : b;
    return Ve(function(Ot) {
      Ie && Ie(Ot);
      var Je = X;
      return !Je && V.current && V.current[Y](Ot), !0;
    });
  }
  var Le = pe("start", ie), Ft = pe("stop", ee), xt = pe("stop", C), zt = pe("stop", function(Y) {
    H && Y.preventDefault(), ce && ce(Y);
  }), ut = pe("start", Q), ct = pe("stop", Z), Et = pe("stop", fe), St = pe("stop", function(Y) {
    H && (P(Y), K(!1)), y && y(Y);
  }, !1), Oe = Ve(function(Y) {
    j.current || (j.current = Y.currentTarget), N(Y) && (K(!0), W && W(Y)), z && z(Y);
  }), je = function() {
    var Ie = q();
    return f && f !== "button" && !(Ie.tagName === "A" && Ie.href);
  }, We = g.useRef(!1), ve = Ve(function(Y) {
    I && !We.current && H && V.current && Y.key === " " && (We.current = !0, Y.persist(), V.current.stop(Y, function() {
      V.current.start(Y);
    })), Y.target === Y.currentTarget && je() && Y.key === " " && Y.preventDefault(), D && D(Y), Y.target === Y.currentTarget && je() && Y.key === "Enter" && !h && (Y.preventDefault(), _ && _(Y));
  }), Ee = Ve(function(Y) {
    I && Y.key === " " && V.current && H && !Y.defaultPrevented && (We.current = !1, Y.persist(), V.current.stop(Y, function() {
      V.current.pulsate(Y);
    })), J && J(Y), _ && Y.target === Y.currentTarget && je() && Y.key === " " && !Y.defaultPrevented && _(Y);
  }), we = f;
  we === "button" && U.href && (we = "a");
  var Fe = {};
  we === "button" ? (Fe.type = A, Fe.disabled = h) : ((we !== "a" || !U.href) && (Fe.role = "button"), Fe["aria-disabled"] = h);
  var ft = it(o, n), Wt = it(me, j), wt = it(ft, Wt), Ce = g.useState(!1), dt = Ce[0], Ge = Ce[1];
  g.useEffect(function() {
    Ge(!0);
  }, []);
  var Re = dt && !m && !h;
  return process.env.NODE_ENV !== "production" && g.useEffect(function() {
    Re && !V.current && console.error(["Material-UI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [Re]), /* @__PURE__ */ g.createElement(we, M({
    className: be(l.root, u, H && [l.focusVisible, k], h && l.disabled),
    onBlur: St,
    onClick: _,
    onFocus: Oe,
    onKeyDown: ve,
    onKeyUp: Ee,
    onMouseDown: Le,
    onMouseLeave: zt,
    onMouseUp: xt,
    onDragLeave: Ft,
    onTouchEnd: ct,
    onTouchMove: Et,
    onTouchStart: ut,
    ref: wt,
    tabIndex: h ? -1 : xe
  }, Fe, U), s, Re ? (
    /* TouchRipple is only needed client-side, x2 boost on the server. */
    /* @__PURE__ */ g.createElement(Ff, M({
      ref: V,
      center: a
    }, w))
  ) : null);
});
process.env.NODE_ENV !== "production" && ($a.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: On,
  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: yo(On, "Use `ref` instead."),
  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: d.bool,
  /**
   * The content of the component.
   */
  children: d.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: d.object,
  /**
   * @ignore
   */
  className: d.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Ts,
  /**
   * If `true`, the base button will be disabled.
   */
  disabled: d.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: d.bool,
  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: d.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   */
  focusRipple: d.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: d.string,
  /**
   * @ignore
   */
  href: d.string,
  /**
   * @ignore
   */
  onBlur: d.func,
  /**
   * @ignore
   */
  onClick: d.func,
  /**
   * @ignore
   */
  onDragLeave: d.func,
  /**
   * @ignore
   */
  onFocus: d.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: d.func,
  /**
   * @ignore
   */
  onKeyDown: d.func,
  /**
   * @ignore
   */
  onKeyUp: d.func,
  /**
   * @ignore
   */
  onMouseDown: d.func,
  /**
   * @ignore
   */
  onMouseLeave: d.func,
  /**
   * @ignore
   */
  onMouseUp: d.func,
  /**
   * @ignore
   */
  onTouchEnd: d.func,
  /**
   * @ignore
   */
  onTouchMove: d.func,
  /**
   * @ignore
   */
  onTouchStart: d.func,
  /**
   * @ignore
   */
  tabIndex: d.oneOfType([d.number, d.string]),
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: d.object,
  /**
   * @ignore
   */
  type: d.oneOfType([d.oneOf(["button", "reset", "submit"]), d.string])
});
const qn = Ke(zf, {
  name: "MuiButtonBase"
})($a);
var Wf = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: "center",
      flex: "0 0 auto",
      fontSize: e.typography.pxToRem(24),
      padding: 12,
      borderRadius: "50%",
      overflow: "visible",
      // Explicitly set the default value to solve a bug on IE 11.
      color: e.palette.action.active,
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        backgroundColor: $e(e.palette.action.active, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        backgroundColor: "transparent",
        color: e.palette.action.disabled
      }
    },
    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      "$sizeSmall&": {
        marginLeft: -3
      }
    },
    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      "$sizeSmall&": {
        marginRight: -3
      }
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main,
      "&:hover": {
        backgroundColor: $e(e.palette.primary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main,
      "&:hover": {
        backgroundColor: $e(e.palette.secondary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: e.typography.pxToRem(18)
    },
    /* Styles applied to the children container element. */
    label: {
      width: "100%",
      display: "flex",
      alignItems: "inherit",
      justifyContent: "inherit"
    }
  };
}, Aa = /* @__PURE__ */ g.forwardRef(function(e, n) {
  var r = e.edge, o = r === void 0 ? !1 : r, i = e.children, a = e.classes, s = e.className, l = e.color, u = l === void 0 ? "default" : l, c = e.disabled, f = c === void 0 ? !1 : c, p = e.disableFocusRipple, h = p === void 0 ? !1 : p, v = e.size, m = v === void 0 ? "medium" : v, S = Se(e, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
  return /* @__PURE__ */ g.createElement(qn, M({
    className: be(a.root, s, u !== "default" && a["color".concat(Ne(u))], f && a.disabled, m === "small" && a["size".concat(Ne(m))], {
      start: a.edgeStart,
      end: a.edgeEnd
    }[o]),
    centerRipple: !0,
    focusRipple: !h,
    disabled: f,
    ref: n
  }, S), /* @__PURE__ */ g.createElement("span", {
    className: a.label
  }, i));
});
process.env.NODE_ENV !== "production" && (Aa.propTypes = {
  /**
   * The icon element.
   */
  children: jt(d.node, function(t) {
    var e = g.Children.toArray(t.children).some(function(n) {
      return /* @__PURE__ */ g.isValidElement(n) && n.props.onClick;
    });
    return e ? new Error(["Material-UI: You are providing an onClick event listener to a child of a button element.", "Firefox will never trigger the event.", "You should move the onClick listener to the parent button element.", "https://github.com/mui-org/material-ui/issues/13957"].join(`
`)) : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: d.object.isRequired,
  /**
   * @ignore
   */
  className: d.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: d.oneOf(["default", "inherit", "primary", "secondary"]),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: d.bool,
  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: d.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: d.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: d.oneOf(["start", "end", !1]),
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: d.oneOf(["small", "medium"])
});
const Yn = Ke(Wf, {
  name: "MuiIconButton"
})(Aa);
var Uf = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0,
      fontSize: e.typography.pxToRem(24),
      transition: e.transitions.create("fill", {
        duration: e.transitions.duration.shorter
      })
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: e.palette.action.active
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: e.palette.error.main
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: e.palette.action.disabled
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: "inherit"
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: e.typography.pxToRem(20)
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: e.typography.pxToRem(35)
    }
  };
}, Eo = /* @__PURE__ */ g.forwardRef(function(e, n) {
  var r = e.children, o = e.classes, i = e.className, a = e.color, s = a === void 0 ? "inherit" : a, l = e.component, u = l === void 0 ? "svg" : l, c = e.fontSize, f = c === void 0 ? "medium" : c, p = e.htmlColor, h = e.titleAccess, v = e.viewBox, m = v === void 0 ? "0 0 24 24" : v, S = Se(e, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
  return /* @__PURE__ */ g.createElement(u, M({
    className: be(o.root, i, s !== "inherit" && o["color".concat(Ne(s))], f !== "default" && f !== "medium" && o["fontSize".concat(Ne(f))]),
    focusable: "false",
    viewBox: m,
    color: p,
    "aria-hidden": h ? void 0 : !0,
    role: h ? "img" : void 0,
    ref: n
  }, S), r, h ? /* @__PURE__ */ g.createElement("title", null, h) : null);
});
process.env.NODE_ENV !== "production" && (Eo.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: d.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: d.object,
  /**
   * @ignore
   */
  className: d.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: d.oneOf(["action", "disabled", "error", "inherit", "primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: d.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: jt(d.oneOf(["default", "inherit", "large", "medium", "small"]), function(t) {
    var e = t.fontSize;
    if (e === "default")
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    return null;
  }),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: d.string,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: d.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: d.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: d.string
});
Eo.muiName = "SvgIcon";
const Pi = Ke(Uf, {
  name: "MuiSvgIcon"
})(Eo);
function lt(t, e) {
  var n = function(o, i) {
    return /* @__PURE__ */ he.createElement(Pi, M({
      ref: i
    }, o), t);
  };
  return process.env.NODE_ENV !== "production" && (n.displayName = "".concat(e, "Icon")), n.muiName = Pi.muiName, /* @__PURE__ */ he.memo(/* @__PURE__ */ he.forwardRef(n));
}
const Bf = lt(/* @__PURE__ */ g.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function Da(t, e, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  var i = o || e;
  return typeof t[e] != "undefined" ? new Error("The prop `".concat(i, "` is not supported. Please remove it.")) : null;
}
var Hf = function(e) {
  var n = e.palette.type === "light" ? e.palette.grey[300] : e.palette.grey[700], r = $e(e.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: e.typography.fontFamily,
      fontSize: e.typography.pxToRem(13),
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      height: 32,
      color: e.palette.getContrastText(n),
      backgroundColor: n,
      borderRadius: 32 / 2,
      whiteSpace: "nowrap",
      transition: e.transitions.create(["background-color", "box-shadow"]),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: "default",
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: "none",
      border: "none",
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: "middle",
      boxSizing: "border-box",
      "&$disabled": {
        opacity: 0.5,
        pointerEvents: "none"
      },
      "& $avatar": {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: e.palette.type === "light" ? e.palette.grey[700] : e.palette.grey[300],
        fontSize: e.typography.pxToRem(12)
      },
      "& $avatarColorPrimary": {
        color: e.palette.primary.contrastText,
        backgroundColor: e.palette.primary.dark
      },
      "& $avatarColorSecondary": {
        color: e.palette.secondary.contrastText,
        backgroundColor: e.palette.secondary.dark
      },
      "& $avatarSmall": {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: e.typography.pxToRem(10)
      }
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 24
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: e.palette.primary.main,
      color: e.palette.primary.contrastText
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: e.palette.secondary.main,
      color: e.palette.secondary.contrastText
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      userSelect: "none",
      WebkitTapHighlightColor: "transparent",
      cursor: "pointer",
      "&:hover, &:focus": {
        backgroundColor: Pt(n, 0.08)
      },
      "&:active": {
        boxShadow: e.shadows[1]
      }
    },
    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
    clickableColorPrimary: {
      "&:hover, &:focus": {
        backgroundColor: Pt(e.palette.primary.main, 0.08)
      }
    },
    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
    clickableColorSecondary: {
      "&:hover, &:focus": {
        backgroundColor: Pt(e.palette.secondary.main, 0.08)
      }
    },
    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      "&:focus": {
        backgroundColor: Pt(n, 0.08)
      }
    },
    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      "&:focus": {
        backgroundColor: Pt(e.palette.primary.main, 0.2)
      }
    },
    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      "&:focus": {
        backgroundColor: Pt(e.palette.secondary.main, 0.2)
      }
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: "transparent",
      border: "1px solid ".concat(e.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
      "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
        backgroundColor: $e(e.palette.text.primary, e.palette.action.hoverOpacity)
      },
      "& $avatar": {
        marginLeft: 4
      },
      "& $avatarSmall": {
        marginLeft: 2
      },
      "& $icon": {
        marginLeft: 4
      },
      "& $iconSmall": {
        marginLeft: 2
      },
      "& $deleteIcon": {
        marginRight: 5
      },
      "& $deleteIconSmall": {
        marginRight: 3
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: e.palette.primary.main,
      border: "1px solid ".concat(e.palette.primary.main),
      "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
        backgroundColor: $e(e.palette.primary.main, e.palette.action.hoverOpacity)
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: e.palette.secondary.main,
      border: "1px solid ".concat(e.palette.secondary.main),
      "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
        backgroundColor: $e(e.palette.secondary.main, e.palette.action.hoverOpacity)
      }
    },
    // TODO v5: remove
    /* Styles applied to the `avatar` element. */
    avatar: {},
    /* Styles applied to the `avatar` element if `size="small"`. */
    avatarSmall: {},
    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {},
    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {},
    /* Styles applied to the `icon` element. */
    icon: {
      color: e.palette.type === "light" ? e.palette.grey[700] : e.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    },
    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      width: 18,
      height: 18,
      marginLeft: 4,
      marginRight: -4
    },
    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: "inherit"
    },
    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: "inherit"
    },
    /* Styles applied to the label `span` element. */
    label: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: "nowrap"
    },
    /* Styles applied to the label `span` element if `size="small"`. */
    labelSmall: {
      paddingLeft: 8,
      paddingRight: 8
    },
    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      WebkitTapHighlightColor: "transparent",
      color: r,
      height: 22,
      width: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: $e(r, 0.4)
      }
    },
    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      height: 16,
      width: 16,
      marginRight: 4,
      marginLeft: -4
    },
    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: $e(e.palette.primary.contrastText, 0.7),
      "&:hover, &:active": {
        color: e.palette.primary.contrastText
      }
    },
    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: $e(e.palette.secondary.contrastText, 0.7),
      "&:hover, &:active": {
        color: e.palette.secondary.contrastText
      }
    },
    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: $e(e.palette.primary.main, 0.7),
      "&:hover, &:active": {
        color: e.palette.primary.main
      }
    },
    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: $e(e.palette.secondary.main, 0.7),
      "&:hover, &:active": {
        color: e.palette.secondary.main
      }
    }
  };
};
function _i(t) {
  return t.key === "Backspace" || t.key === "Delete";
}
var ja = /* @__PURE__ */ g.forwardRef(function(e, n) {
  var r = e.avatar, o = e.classes, i = e.className, a = e.clickable, s = e.color, l = s === void 0 ? "default" : s, u = e.component, c = e.deleteIcon, f = e.disabled, p = f === void 0 ? !1 : f, h = e.icon, v = e.label, m = e.onClick, S = e.onDelete, b = e.onKeyDown, T = e.onKeyUp, I = e.size, k = I === void 0 ? "medium" : I, y = e.variant, _ = y === void 0 ? "default" : y, z = Se(e, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]), W = g.useRef(null), D = it(W, n), J = function(A) {
    A.stopPropagation(), S && S(A);
  }, ie = function(A) {
    A.currentTarget === A.target && _i(A) && A.preventDefault(), b && b(A);
  }, ce = function(A) {
    A.currentTarget === A.target && (S && _i(A) ? S(A) : A.key === "Escape" && W.current && W.current.blur()), T && T(A);
  }, C = a !== !1 && m ? !0 : a, Z = k === "small", fe = u || (C ? qn : "div"), Q = fe === qn ? {
    component: "div"
  } : {}, ee = null;
  if (S) {
    var ae = be(l !== "default" && (_ === "default" ? o["deleteIconColor".concat(Ne(l))] : o["deleteIconOutlinedColor".concat(Ne(l))]), Z && o.deleteIconSmall);
    ee = c && /* @__PURE__ */ g.isValidElement(c) ? /* @__PURE__ */ g.cloneElement(c, {
      className: be(c.props.className, o.deleteIcon, ae),
      onClick: J
    }) : /* @__PURE__ */ g.createElement(Bf, {
      className: be(o.deleteIcon, ae),
      onClick: J
    });
  }
  var xe = null;
  r && /* @__PURE__ */ g.isValidElement(r) && (xe = /* @__PURE__ */ g.cloneElement(r, {
    className: be(o.avatar, r.props.className, Z && o.avatarSmall, l !== "default" && o["avatarColor".concat(Ne(l))])
  }));
  var w = null;
  return h && /* @__PURE__ */ g.isValidElement(h) && (w = /* @__PURE__ */ g.cloneElement(h, {
    className: be(o.icon, h.props.className, Z && o.iconSmall, l !== "default" && o["iconColor".concat(Ne(l))])
  })), process.env.NODE_ENV !== "production" && xe && w && console.error("Material-UI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ g.createElement(fe, M({
    role: C || S ? "button" : void 0,
    className: be(o.root, i, l !== "default" && [o["color".concat(Ne(l))], C && o["clickableColor".concat(Ne(l))], S && o["deletableColor".concat(Ne(l))]], _ !== "default" && [o.outlined, {
      primary: o.outlinedPrimary,
      secondary: o.outlinedSecondary
    }[l]], p && o.disabled, Z && o.sizeSmall, C && o.clickable, S && o.deletable),
    "aria-disabled": p ? !0 : void 0,
    tabIndex: C || S ? 0 : void 0,
    onClick: m,
    onKeyDown: ie,
    onKeyUp: ce,
    ref: D
  }, Q, z), xe || w, /* @__PURE__ */ g.createElement("span", {
    className: be(o.label, Z && o.labelSmall)
  }, v), ee);
});
process.env.NODE_ENV !== "production" && (ja.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Avatar element.
   */
  avatar: d.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: Da,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: d.object,
  /**
   * @ignore
   */
  className: d.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If false, the chip will not be clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   */
  clickable: d.bool,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: d.oneOf(["default", "primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: d.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: d.element,
  /**
   * If `true`, the chip should be displayed in a disabled state.
   */
  disabled: d.bool,
  /**
   * Icon element.
   */
  icon: d.element,
  /**
   * The content of the label.
   */
  label: d.node,
  /**
   * @ignore
   */
  onClick: d.func,
  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: d.func,
  /**
   * @ignore
   */
  onKeyDown: d.func,
  /**
   * @ignore
   */
  onKeyUp: d.func,
  /**
   * The size of the chip.
   */
  size: d.oneOf(["medium", "small"]),
  /**
   * The variant to use.
   */
  variant: d.oneOf(["default", "outlined"])
});
const qf = Ke(Hf, {
  name: "MuiChip"
})(ja);
function Yf(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 166, n;
  function r() {
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    var s = this, l = function() {
      t.apply(s, i);
    };
    clearTimeout(n), n = setTimeout(l, e);
  }
  return r.clear = function() {
    clearTimeout(n);
  }, r;
}
function Kf(t, e) {
  return /* @__PURE__ */ g.isValidElement(t) && e.indexOf(t.type.muiName) !== -1;
}
function Va(t) {
  return t && t.ownerDocument || document;
}
function Gf(t) {
  var e = Va(t);
  return e.defaultView || window;
}
function Jf(t) {
  if (process.env.NODE_ENV === "production")
    return function() {
      return null;
    };
  var e = function(r) {
    return function(o, i, a, s, l) {
      var u = l || i;
      return typeof o[i] != "undefined" && !o[r] ? new Error("The prop `".concat(u, "` of ") + "`".concat(t, "` must be used on `").concat(r, "`.")) : null;
    };
  };
  return e;
}
function xr(t) {
  var e = t.controlled, n = t.default, r = t.name, o = t.state, i = o === void 0 ? "value" : o, a = g.useRef(e !== void 0), s = a.current, l = g.useState(n), u = l[0], c = l[1], f = s ? e : u;
  if (process.env.NODE_ENV !== "production") {
    g.useEffect(function() {
      s !== (e !== void 0) && console.error(["Material-UI: A component is changing the ".concat(s ? "" : "un", "controlled ").concat(i, " state of ").concat(r, " to be ").concat(s ? "un" : "", "controlled."), "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled ".concat(r, " ") + "element for the lifetime of the component.", "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [e]);
    var p = g.useRef(n), h = p.current;
    g.useEffect(function() {
      !s && h !== n && console.error(["Material-UI: A component is changing the default ".concat(i, " state of an uncontrolled ").concat(r, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(r, ".")].join(`
`));
    }, [JSON.stringify(n)]);
  }
  var v = g.useCallback(function(m) {
    s || c(m);
  }, []);
  return [f, v];
}
function La(t) {
  var e = g.useState(t), n = e[0], r = e[1], o = t || n;
  return g.useEffect(function() {
    n == null && r("mui-".concat(Math.round(Math.random() * 1e5)));
  }, [n]), o;
}
const Xf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: Ne,
  createChainedFunction: Wn,
  createSvgIcon: lt,
  debounce: Yf,
  deprecatedPropType: yo,
  isMuiElement: Kf,
  ownerDocument: Va,
  ownerWindow: Gf,
  requirePropFactory: Jf,
  setRef: yt,
  unstable_useId: La,
  unsupportedProp: Da,
  useControlled: xr,
  useEventCallback: Ve,
  useForkRef: it,
  useIsFocusVisible: Ia
}, Symbol.toStringTag, { value: "Module" })), Fa = lt(/* @__PURE__ */ g.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), Zf = lt(/* @__PURE__ */ g.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function Ni(t) {
  return typeof t.normalize != "undefined" ? t.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : t;
}
function Qf() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.ignoreAccents, n = e === void 0 ? !0 : e, r = t.ignoreCase, o = r === void 0 ? !0 : r, i = t.limit, a = t.matchFrom, s = a === void 0 ? "any" : a, l = t.stringify, u = t.trim, c = u === void 0 ? !1 : u;
  return function(f, p) {
    var h = p.inputValue, v = p.getOptionLabel, m = c ? h.trim() : h;
    o && (m = m.toLowerCase()), n && (m = Ni(m));
    var S = f.filter(function(b) {
      var T = (l || v)(b);
      return o && (T = T.toLowerCase()), n && (T = Ni(T)), s === "start" ? T.indexOf(m) === 0 : T.indexOf(m) > -1;
    });
    return typeof i == "number" ? S.slice(0, i) : S;
  };
}
function xn(t, e) {
  for (var n = 0; n < t.length; n += 1)
    if (e(t[n]))
      return n;
  return -1;
}
var ed = Qf(), Ii = 5;
function td(t) {
  var e = t.autoComplete, n = e === void 0 ? !1 : e, r = t.autoHighlight, o = r === void 0 ? !1 : r, i = t.autoSelect, a = i === void 0 ? !1 : i, s = t.blurOnSelect, l = s === void 0 ? !1 : s, u = t.clearOnBlur, c = u === void 0 ? !t.freeSolo : u, f = t.clearOnEscape, p = f === void 0 ? !1 : f, h = t.componentName, v = h === void 0 ? "useAutocomplete" : h, m = t.debug, S = m === void 0 ? !1 : m, b = t.defaultValue, T = b === void 0 ? t.multiple ? [] : null : b, I = t.disableClearable, k = I === void 0 ? !1 : I, y = t.disableCloseOnSelect, _ = y === void 0 ? !1 : y, z = t.disabledItemsFocusable, W = z === void 0 ? !1 : z, D = t.disableListWrap, J = D === void 0 ? !1 : D, ie = t.filterOptions, ce = ie === void 0 ? ed : ie, C = t.filterSelectedOptions, Z = C === void 0 ? !1 : C, fe = t.freeSolo, Q = fe === void 0 ? !1 : fe, ee = t.getOptionDisabled, ae = t.getOptionLabel, xe = ae === void 0 ? function($) {
    return $;
  } : ae, w = t.getOptionSelected, O = w === void 0 ? function($, R) {
    return $ === R;
  } : w, A = t.groupBy, U = t.handleHomeEndKeys, j = U === void 0 ? !t.freeSolo : U, q = t.id, V = t.includeInputInList, B = V === void 0 ? !1 : V, H = t.inputValue, K = t.multiple, L = K === void 0 ? !1 : K, N = t.onChange, P = t.onClose, me = t.onHighlightChange, pe = t.onInputChange, Le = t.onOpen, Ft = t.open, xt = t.openOnFocus, zt = xt === void 0 ? !1 : xt, ut = t.options, ct = t.selectOnFocus, Et = ct === void 0 ? !t.freeSolo : ct, St = t.value, Oe = La(q), je = xe;
  process.env.NODE_ENV !== "production" && (je = function(R) {
    var E = xe(R);
    if (typeof E != "string") {
      var F = E === void 0 ? "undefined" : "".concat(Ye(E), " (").concat(E, ")");
      console.error("Material-UI: The `getOptionLabel` method of ".concat(v, " returned ").concat(F, " instead of a string for ").concat(JSON.stringify(R), "."));
    }
    return E;
  });
  var We = g.useRef(!1), ve = g.useRef(!0), Ee = g.useRef(null), we = g.useRef(null), Fe = g.useState(null), ft = Fe[0], Wt = Fe[1], wt = g.useState(-1), Ce = wt[0], dt = wt[1], Ge = o ? 0 : -1, Re = g.useRef(Ge), Y = xr({
    controlled: St,
    default: T,
    name: v
  }), Ie = nn(Y, 2), X = Ie[0], Ot = Ie[1], Je = xr({
    controlled: H,
    default: "",
    name: v,
    state: "inputValue"
  }), cr = nn(Je, 2), ye = cr[0], Xe = cr[1], Me = g.useState(!1), fr = Me[0], Ut = Me[1], Rt = Ve(function($, R) {
    var E;
    if (L)
      E = "";
    else if (R == null)
      E = "";
    else {
      var F = je(R);
      E = typeof F == "string" ? F : "";
    }
    ye !== E && (Xe(E), pe && pe($, E, "reset"));
  });
  g.useEffect(function() {
    Rt(null, X);
  }, [X, Rt]);
  var Lr = xr({
    controlled: Ft,
    default: !1,
    name: v,
    state: "open"
  }), dr = nn(Lr, 2), Ze = dr[0], Bt = dr[1], Ht = !L && X != null && ye === je(X), oe = Ze, se = oe ? ce(
    ut.filter(function($) {
      return !(Z && (L ? X : [X]).some(function(R) {
        return R !== null && O($, R);
      }));
    }),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Ht ? "" : ye,
      getOptionLabel: je
    }
  ) : [];
  if (process.env.NODE_ENV !== "production" && X !== null && !Q && ut.length > 0) {
    var Qe = (L ? X : [X]).filter(function($) {
      return !ut.some(function(R) {
        return O(R, $);
      });
    });
    Qe.length > 0 && console.warn(["Material-UI: The value provided to ".concat(v, " is invalid."), "None of the options match with `".concat(Qe.length > 1 ? JSON.stringify(Qe) : JSON.stringify(Qe[0]), "`."), "You can use the `getOptionSelected` prop to customize the equality test."].join(`
`));
  }
  var Ue = Ve(function($) {
    $ === -1 ? Ee.current.focus() : ft.querySelector('[data-tag-index="'.concat($, '"]')).focus();
  });
  g.useEffect(function() {
    L && Ce > X.length - 1 && (dt(-1), Ue(-1));
  }, [X, L, Ce, Ue]);
  function Ba($, R) {
    if (!we.current || $ === -1)
      return -1;
    for (var E = $; ; ) {
      if (R === "next" && E === se.length || R === "previous" && E === -1)
        return -1;
      var F = we.current.querySelector('[data-option-index="'.concat(E, '"]')), Pe = W ? !1 : F && (F.disabled || F.getAttribute("aria-disabled") === "true");
      if (F && !F.hasAttribute("tabindex") || Pe)
        E += R === "next" ? 1 : -1;
      else
        return E;
    }
  }
  var Tt = Ve(function($) {
    var R = $.event, E = $.index, F = $.reason, Pe = F === void 0 ? "auto" : F;
    if (Re.current = E, E === -1 ? Ee.current.removeAttribute("aria-activedescendant") : Ee.current.setAttribute("aria-activedescendant", "".concat(Oe, "-option-").concat(E)), me && me(R, E === -1 ? null : se[E], Pe), !!we.current) {
      var _e = we.current.querySelector("[data-focus]");
      _e && _e.removeAttribute("data-focus");
      var de = we.current.parentElement.querySelector('[role="listbox"]');
      if (de) {
        if (E === -1) {
          de.scrollTop = 0;
          return;
        }
        var et = we.current.querySelector('[data-option-index="'.concat(E, '"]'));
        if (et && (et.setAttribute("data-focus", "true"), de.scrollHeight > de.clientHeight && Pe !== "mouse")) {
          var ke = et, He = de.clientHeight + de.scrollTop, hr = ke.offsetTop + ke.offsetHeight;
          hr > He ? de.scrollTop = hr - de.clientHeight : ke.offsetTop - ke.offsetHeight * (A ? 1.3 : 0) < de.scrollTop && (de.scrollTop = ke.offsetTop - ke.offsetHeight * (A ? 1.3 : 0));
        }
      }
    }
  }), Be = Ve(function($) {
    var R = $.event, E = $.diff, F = $.direction, Pe = F === void 0 ? "next" : F, _e = $.reason, de = _e === void 0 ? "auto" : _e;
    if (oe) {
      var et = function() {
        var Gt = se.length - 1;
        if (E === "reset")
          return Ge;
        if (E === "start")
          return 0;
        if (E === "end")
          return Gt;
        var Jt = Re.current + E;
        return Jt < 0 ? Jt === -1 && B ? -1 : J && Re.current !== -1 || Math.abs(E) > 1 ? 0 : Gt : Jt > Gt ? Jt === Gt + 1 && B ? -1 : J || Math.abs(E) > 1 ? Gt : 0 : Jt;
      }, ke = Ba(et(), Pe);
      if (Tt({
        index: ke,
        reason: de,
        event: R
      }), n && E !== "reset")
        if (ke === -1)
          Ee.current.value = ye;
        else {
          var He = je(se[ke]);
          Ee.current.value = He;
          var hr = He.toLowerCase().indexOf(ye.toLowerCase());
          hr === 0 && ye.length > 0 && Ee.current.setSelectionRange(ye.length, He.length);
        }
    }
  }), Fr = g.useCallback(function() {
    if (oe) {
      var $ = L ? X[0] : X;
      if (se.length === 0 || $ == null) {
        Be({
          diff: "reset"
        });
        return;
      }
      if (we.current) {
        if (!Z && $ != null) {
          var R = se[Re.current];
          if (L && R && xn(X, function(F) {
            return O(R, F);
          }) !== -1)
            return;
          var E = xn(se, function(F) {
            return O(F, $);
          });
          E === -1 ? Be({
            diff: "reset"
          }) : Tt({
            index: E
          });
          return;
        }
        if (Re.current >= se.length - 1) {
          Tt({
            index: se.length - 1
          });
          return;
        }
        Tt({
          index: Re.current
        });
      }
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    // eslint-disable-next-line react-hooks/exhaustive-deps
    se.length === 0,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    L ? !1 : X,
    Z,
    Be,
    Tt,
    oe,
    ye,
    L
  ]), Ha = Ve(function($) {
    yt(we, $), $ && Fr();
  });
  g.useEffect(function() {
    Fr();
  }, [Fr]);
  var pt = function(R) {
    Ze || (Bt(!0), Le && Le(R));
  }, qt = function(R, E) {
    Ze && (Bt(!1), P && P(R, E));
  }, Yt = function(R, E, F, Pe) {
    X !== E && (N && N(R, E, F, Pe), Ot(E));
  }, pr = g.useRef(!1), Kt = function(R, E) {
    var F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "select-option", Pe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "options", _e = F, de = E;
    if (L) {
      if (de = Array.isArray(X) ? X.slice() : [], process.env.NODE_ENV !== "production") {
        var et = de.filter(function(He) {
          return O(E, He);
        });
        et.length > 1 && console.error(["Material-UI: The `getOptionSelected` method of ".concat(v, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(et.length, " matches.")].join(`
`));
      }
      var ke = xn(de, function(He) {
        return O(E, He);
      });
      ke === -1 ? de.push(E) : Pe !== "freeSolo" && (de.splice(ke, 1), _e = "remove-option");
    }
    Rt(R, de), Yt(R, de, _e, {
      option: E
    }), _ || qt(R, _e), (l === !0 || l === "touch" && pr.current || l === "mouse" && !pr.current) && Ee.current.blur();
  };
  function qa($, R) {
    if ($ === -1)
      return -1;
    for (var E = $; ; ) {
      if (R === "next" && E === X.length || R === "previous" && E === -1)
        return -1;
      var F = ft.querySelector('[data-tag-index="'.concat(E, '"]'));
      if (F && (!F.hasAttribute("tabindex") || F.disabled || F.getAttribute("aria-disabled") === "true"))
        E += R === "next" ? 1 : -1;
      else
        return E;
    }
  }
  var Oo = function(R, E) {
    if (L) {
      qt(R, "toggleInput");
      var F = Ce;
      Ce === -1 ? ye === "" && E === "previous" && (F = X.length - 1) : (F += E === "next" ? 1 : -1, F < 0 && (F = 0), F === X.length && (F = -1)), F = qa(F, E), dt(F), Ue(F);
    }
  }, Ro = function(R) {
    We.current = !0, Xe(""), pe && pe(R, "", "clear"), Yt(R, L ? [] : null, "clear");
  }, Ya = function(R) {
    return function(E) {
      switch (Ce !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(E.key) === -1 && (dt(-1), Ue(-1)), E.key) {
        case "Home":
          oe && j && (E.preventDefault(), Be({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: E
          }));
          break;
        case "End":
          oe && j && (E.preventDefault(), Be({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: E
          }));
          break;
        case "PageUp":
          E.preventDefault(), Be({
            diff: -Ii,
            direction: "previous",
            reason: "keyboard",
            event: E
          }), pt(E);
          break;
        case "PageDown":
          E.preventDefault(), Be({
            diff: Ii,
            direction: "next",
            reason: "keyboard",
            event: E
          }), pt(E);
          break;
        case "ArrowDown":
          E.preventDefault(), Be({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: E
          }), pt(E);
          break;
        case "ArrowUp":
          E.preventDefault(), Be({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: E
          }), pt(E);
          break;
        case "ArrowLeft":
          Oo(E, "previous");
          break;
        case "ArrowRight":
          Oo(E, "next");
          break;
        case "Enter":
          if (E.which === 229)
            break;
          if (Re.current !== -1 && oe) {
            var F = se[Re.current], Pe = ee ? ee(F) : !1;
            if (E.preventDefault(), Pe)
              return;
            Kt(E, F, "select-option"), n && Ee.current.setSelectionRange(Ee.current.value.length, Ee.current.value.length);
          } else
            Q && ye !== "" && Ht === !1 && (L && E.preventDefault(), Kt(E, ye, "create-option", "freeSolo"));
          break;
        case "Escape":
          oe ? (E.preventDefault(), E.stopPropagation(), qt(E, "escape")) : p && (ye !== "" || L && X.length > 0) && (E.preventDefault(), E.stopPropagation(), Ro(E));
          break;
        case "Backspace":
          if (L && ye === "" && X.length > 0) {
            var _e = Ce === -1 ? X.length - 1 : Ce, de = X.slice();
            de.splice(_e, 1), Yt(E, de, "remove-option", {
              option: X[_e]
            });
          }
          break;
      }
      R.onKeyDown && R.onKeyDown(E);
    };
  }, Ka = function(R) {
    Ut(!0), zt && !We.current && pt(R);
  }, Ga = function(R) {
    if (we.current !== null && document.activeElement === we.current.parentElement) {
      Ee.current.focus();
      return;
    }
    Ut(!1), ve.current = !0, We.current = !1, !(S && ye !== "") && (a && Re.current !== -1 && oe ? Kt(R, se[Re.current], "blur") : a && Q && ye !== "" ? Kt(R, ye, "blur", "freeSolo") : c && Rt(R, X), qt(R, "blur"));
  }, Ja = function(R) {
    var E = R.target.value;
    ye !== E && (Xe(E), pe && pe(R, E, "input")), E === "" ? !k && !L && Yt(R, null, "clear") : pt(R);
  }, Xa = function(R) {
    Tt({
      event: R,
      index: Number(R.currentTarget.getAttribute("data-option-index")),
      reason: "mouse"
    });
  }, Za = function() {
    pr.current = !0;
  }, Qa = function(R) {
    var E = Number(R.currentTarget.getAttribute("data-option-index"));
    Kt(R, se[E], "select-option"), pr.current = !1;
  }, es = function(R) {
    return function(E) {
      var F = X.slice();
      F.splice(R, 1), Yt(E, F, "remove-option", {
        option: X[R]
      });
    };
  }, To = function(R) {
    Ze ? qt(R, "toggleInput") : pt(R);
  }, ts = function(R) {
    R.target.getAttribute("id") !== Oe && R.preventDefault();
  }, rs = function() {
    Ee.current.focus(), Et && ve.current && Ee.current.selectionEnd - Ee.current.selectionStart === 0 && Ee.current.select(), ve.current = !1;
  }, ns = function(R) {
    (ye === "" || !Ze) && To(R);
  }, zr = Q && ye.length > 0;
  zr = zr || (L ? X.length > 0 : X !== null);
  var Co = se;
  if (A) {
    var Po = /* @__PURE__ */ new Map(), _o = !1;
    Co = se.reduce(function($, R, E) {
      var F = A(R);
      return $.length > 0 && $[$.length - 1].group === F ? $[$.length - 1].options.push(R) : (process.env.NODE_ENV !== "production" && (Po.get(F) && !_o && (console.warn("Material-UI: The options provided combined with the `groupBy` method of ".concat(v, " returns duplicated headers."), "You can solve the issue by sorting the options with the output of `groupBy`."), _o = !0), Po.set(F, !0)), $.push({
        key: E,
        index: E,
        group: F,
        options: [R]
      })), $;
    }, []);
  }
  return {
    getRootProps: function() {
      var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return M({
        "aria-owns": oe ? "".concat(Oe, "-popup") : null,
        role: "combobox",
        "aria-expanded": oe
      }, R, {
        onKeyDown: Ya(R),
        onMouseDown: ts,
        onClick: rs
      });
    },
    getInputLabelProps: function() {
      return {
        id: "".concat(Oe, "-label"),
        htmlFor: Oe
      };
    },
    getInputProps: function() {
      return {
        id: Oe,
        value: ye,
        onBlur: Ga,
        onFocus: Ka,
        onChange: Ja,
        onMouseDown: ns,
        // if open then this is handled imperativeley so don't let react override
        // only have an opinion about this when closed
        "aria-activedescendant": oe ? "" : null,
        "aria-autocomplete": n ? "both" : "list",
        "aria-controls": oe ? "".concat(Oe, "-popup") : null,
        // Disable browser's suggestion that might overlap with the popup.
        // Handle autocomplete but not autofill.
        autoComplete: "off",
        ref: Ee,
        autoCapitalize: "none",
        spellCheck: "false"
      };
    },
    getClearProps: function() {
      return {
        tabIndex: -1,
        onClick: Ro
      };
    },
    getPopupIndicatorProps: function() {
      return {
        tabIndex: -1,
        onClick: To
      };
    },
    getTagProps: function(R) {
      var E = R.index;
      return {
        key: E,
        "data-tag-index": E,
        tabIndex: -1,
        onDelete: es(E)
      };
    },
    getListboxProps: function() {
      return {
        role: "listbox",
        id: "".concat(Oe, "-popup"),
        "aria-labelledby": "".concat(Oe, "-label"),
        ref: Ha,
        onMouseDown: function(E) {
          E.preventDefault();
        }
      };
    },
    getOptionProps: function(R) {
      var E = R.index, F = R.option, Pe = (L ? X : [X]).some(function(de) {
        return de != null && O(F, de);
      }), _e = ee ? ee(F) : !1;
      return {
        key: E,
        tabIndex: -1,
        role: "option",
        id: "".concat(Oe, "-option-").concat(E),
        onMouseOver: Xa,
        onClick: Qa,
        onTouchStart: Za,
        "data-option-index": E,
        "aria-disabled": _e,
        "aria-selected": Pe
      };
    },
    id: Oe,
    inputValue: ye,
    value: X,
    dirty: zr,
    popupOpen: oe,
    focused: fr || Ce !== -1,
    anchorEl: ft,
    setAnchorEl: Wt,
    focusedTag: Ce,
    groupedOptions: Co
  };
}
var rd = function(e) {
  var n;
  return {
    /* Styles applied to the root element. */
    root: {
      "&$focused $clearIndicatorDirty": {
        visibility: "visible"
      },
      /* Avoid double tap issue on iOS */
      "@media (pointer: fine)": {
        "&:hover $clearIndicatorDirty": {
          visibility: "visible"
        }
      }
    },
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: "100%"
    },
    /* Pseudo-class applied to the root element if focused. */
    focused: {},
    /* Styles applied to the tag elements, e.g. the chips. */
    tag: {
      margin: 3,
      maxWidth: "calc(100% - 6px)"
    },
    /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */
    tagSizeSmall: {
      margin: 2,
      maxWidth: "calc(100% - 4px)"
    },
    /* Styles applied when the popup icon is rendered. */
    hasPopupIcon: {},
    /* Styles applied when the clear icon is rendered. */
    hasClearIcon: {},
    /* Styles applied to the Input element. */
    inputRoot: {
      flexWrap: "wrap",
      "$hasPopupIcon &, $hasClearIcon &": {
        paddingRight: 26 + 4
      },
      "$hasPopupIcon$hasClearIcon &": {
        paddingRight: 52 + 4
      },
      "& $input": {
        width: 0,
        minWidth: 30
      },
      '&[class*="MuiInput-root"]': {
        paddingBottom: 1,
        "& $input": {
          padding: 4
        },
        "& $input:first-child": {
          padding: "6px 0"
        }
      },
      '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
        "& $input": {
          padding: "4px 4px 5px"
        },
        "& $input:first-child": {
          padding: "3px 0 6px"
        }
      },
      '&[class*="MuiOutlinedInput-root"]': {
        padding: 9,
        "$hasPopupIcon &, $hasClearIcon &": {
          paddingRight: 26 + 4 + 9
        },
        "$hasPopupIcon$hasClearIcon &": {
          paddingRight: 52 + 4 + 9
        },
        "& $input": {
          padding: "9.5px 4px"
        },
        "& $input:first-child": {
          paddingLeft: 6
        },
        "& $endAdornment": {
          right: 9
        }
      },
      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
        padding: 6,
        "& $input": {
          padding: "4.5px 4px"
        }
      },
      '&[class*="MuiFilledInput-root"]': {
        paddingTop: 19,
        paddingLeft: 8,
        "$hasPopupIcon &, $hasClearIcon &": {
          paddingRight: 26 + 4 + 9
        },
        "$hasPopupIcon$hasClearIcon &": {
          paddingRight: 52 + 4 + 9
        },
        "& $input": {
          padding: "9px 4px"
        },
        "& $endAdornment": {
          right: 9
        }
      },
      '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
        paddingBottom: 1,
        "& $input": {
          padding: "4.5px 4px"
        }
      }
    },
    /* Styles applied to the input element. */
    input: {
      flexGrow: 1,
      textOverflow: "ellipsis",
      opacity: 0
    },
    /* Styles applied to the input element if tag focused. */
    inputFocused: {
      opacity: 1
    },
    /* Styles applied to the endAdornment element. */
    endAdornment: {
      // We use a position absolute to support wrapping tags.
      position: "absolute",
      right: 0,
      top: "calc(50% - 14px)"
      // Center vertically
    },
    /* Styles applied to the clear indicator. */
    clearIndicator: {
      marginRight: -2,
      padding: 4,
      visibility: "hidden"
    },
    /* Styles applied to the clear indicator if the input is dirty. */
    clearIndicatorDirty: {},
    /* Styles applied to the popup indicator. */
    popupIndicator: {
      padding: 2,
      marginRight: -2
    },
    /* Styles applied to the popup indicator if the popup is open. */
    popupIndicatorOpen: {
      transform: "rotate(180deg)"
    },
    /* Styles applied to the popper element. */
    popper: {
      zIndex: e.zIndex.modal
    },
    /* Styles applied to the popper element if `disablePortal={true}`. */
    popperDisablePortal: {
      position: "absolute"
    },
    /* Styles applied to the `Paper` component. */
    paper: M({}, e.typography.body1, {
      overflow: "hidden",
      margin: "4px 0"
    }),
    /* Styles applied to the `listbox` component. */
    listbox: {
      listStyle: "none",
      margin: 0,
      padding: "8px 0",
      maxHeight: "40vh",
      overflow: "auto"
    },
    /* Styles applied to the loading wrapper. */
    loading: {
      color: e.palette.text.secondary,
      padding: "14px 16px"
    },
    /* Styles applied to the no option wrapper. */
    noOptions: {
      color: e.palette.text.secondary,
      padding: "14px 16px"
    },
    /* Styles applied to the option elements. */
    option: (n = {
      minHeight: 48,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      cursor: "pointer",
      paddingTop: 6,
      boxSizing: "border-box",
      outline: "0",
      WebkitTapHighlightColor: "transparent",
      paddingBottom: 6,
      paddingLeft: 16,
      paddingRight: 16
    }, ze(n, e.breakpoints.up("sm"), {
      minHeight: "auto"
    }), ze(n, '&[aria-selected="true"]', {
      backgroundColor: e.palette.action.selected
    }), ze(n, '&[data-focus="true"]', {
      backgroundColor: e.palette.action.hover
    }), ze(n, "&:active", {
      backgroundColor: e.palette.action.selected
    }), ze(n, '&[aria-disabled="true"]', {
      opacity: e.palette.action.disabledOpacity,
      pointerEvents: "none"
    }), n),
    /* Styles applied to the group's label elements. */
    groupLabel: {
      backgroundColor: e.palette.background.paper,
      top: -8
    },
    /* Styles applied to the group's ul elements. */
    groupUl: {
      padding: 0,
      "& $option": {
        paddingLeft: 24
      }
    }
  };
};
function nd(t) {
  t.anchorEl, t.open;
  var e = Se(t, ["anchorEl", "open"]);
  return /* @__PURE__ */ g.createElement("div", e);
}
var od = /* @__PURE__ */ g.createElement(Fa, {
  fontSize: "small"
}), id = /* @__PURE__ */ g.createElement(Zf, null), za = /* @__PURE__ */ g.forwardRef(function(e, n) {
  e.autoComplete, e.autoHighlight, e.autoSelect, e.blurOnSelect;
  var r = e.ChipProps, o = e.classes, i = e.className, a = e.clearOnBlur;
  a === void 0 && e.freeSolo, e.clearOnEscape;
  var s = e.clearText, l = s === void 0 ? "Clear" : s, u = e.closeIcon, c = u === void 0 ? od : u, f = e.closeText, p = f === void 0 ? "Close" : f;
  e.debug;
  var h = e.defaultValue;
  h === void 0 && e.multiple;
  var v = e.disableClearable, m = v === void 0 ? !1 : v;
  e.disableCloseOnSelect;
  var S = e.disabled, b = S === void 0 ? !1 : S;
  e.disabledItemsFocusable, e.disableListWrap;
  var T = e.disablePortal, I = T === void 0 ? !1 : T;
  e.filterOptions, e.filterSelectedOptions;
  var k = e.forcePopupIcon, y = k === void 0 ? "auto" : k, _ = e.freeSolo, z = _ === void 0 ? !1 : _, W = e.fullWidth, D = W === void 0 ? !1 : W, J = e.getLimitTagsText, ie = J === void 0 ? function(oe) {
    return "+".concat(oe);
  } : J;
  e.getOptionDisabled;
  var ce = e.getOptionLabel, C = ce === void 0 ? function(oe) {
    return oe;
  } : ce;
  e.getOptionSelected;
  var Z = e.groupBy, fe = e.handleHomeEndKeys;
  fe === void 0 && e.freeSolo, e.id, e.includeInputInList, e.inputValue;
  var Q = e.limitTags, ee = Q === void 0 ? -1 : Q, ae = e.ListboxComponent, xe = ae === void 0 ? "ul" : ae, w = e.ListboxProps, O = e.loading, A = O === void 0 ? !1 : O, U = e.loadingText, j = U === void 0 ? "Loading…" : U, q = e.multiple, V = q === void 0 ? !1 : q, B = e.noOptionsText, H = B === void 0 ? "No options" : B;
  e.onChange, e.onClose, e.onHighlightChange, e.onInputChange, e.onOpen, e.open, e.openOnFocus;
  var K = e.openText, L = K === void 0 ? "Open" : K;
  e.options;
  var N = e.PaperComponent, P = N === void 0 ? Na : N, me = e.PopperComponent, pe = me === void 0 ? xf : me, Le = e.popupIcon, Ft = Le === void 0 ? id : Le, xt = e.renderGroup, zt = e.renderInput, ut = e.renderOption, ct = e.renderTags, Et = e.selectOnFocus;
  Et === void 0 && e.freeSolo;
  var St = e.size, Oe = St === void 0 ? "medium" : St;
  e.value;
  var je = Se(e, ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "classes", "className", "clearOnBlur", "clearOnEscape", "clearText", "closeIcon", "closeText", "debug", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "getOptionSelected", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"]), We = I ? nd : pe, ve = td(M({}, e, {
    componentName: "Autocomplete"
  })), Ee = ve.getRootProps, we = ve.getInputProps, Fe = ve.getInputLabelProps, ft = ve.getPopupIndicatorProps, Wt = ve.getClearProps, wt = ve.getTagProps, Ce = ve.getListboxProps, dt = ve.getOptionProps, Ge = ve.value, Re = ve.dirty, Y = ve.id, Ie = ve.popupOpen, X = ve.focused, Ot = ve.focusedTag, Je = ve.anchorEl, cr = ve.setAnchorEl, ye = ve.inputValue, Xe = ve.groupedOptions, Me;
  if (V && Ge.length > 0) {
    var fr = function(se) {
      return M({
        className: be(o.tag, Oe === "small" && o.tagSizeSmall),
        disabled: b
      }, wt(se));
    };
    ct ? Me = ct(Ge, fr) : Me = Ge.map(function(oe, se) {
      return /* @__PURE__ */ g.createElement(qf, M({
        label: C(oe),
        size: Oe
      }, fr({
        index: se
      }), r));
    });
  }
  if (ee > -1 && Array.isArray(Me)) {
    var Ut = Me.length - ee;
    !X && Ut > 0 && (Me = Me.splice(0, ee), Me.push(/* @__PURE__ */ g.createElement("span", {
      className: o.tag,
      key: Me.length
    }, ie(Ut))));
  }
  var Rt = function(se) {
    return /* @__PURE__ */ g.createElement("li", {
      key: se.key
    }, /* @__PURE__ */ g.createElement(Sf, {
      className: o.groupLabel,
      component: "div"
    }, se.group), /* @__PURE__ */ g.createElement("ul", {
      className: o.groupUl
    }, se.children));
  }, Lr = xt || Rt, dr = ut || C, Ze = function(se, Qe) {
    var Ue = dt({
      option: se,
      index: Qe
    });
    return /* @__PURE__ */ g.createElement("li", M({}, Ue, {
      className: o.option
    }), dr(se, {
      selected: Ue["aria-selected"],
      inputValue: ye
    }));
  }, Bt = !m && !b, Ht = (!z || y === !0) && y !== !1;
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement("div", M({
    ref: n,
    className: be(o.root, i, X && o.focused, D && o.fullWidth, Bt && o.hasClearIcon, Ht && o.hasPopupIcon)
  }, Ee(je)), zt({
    id: Y,
    disabled: b,
    fullWidth: !0,
    size: Oe === "small" ? "small" : void 0,
    InputLabelProps: Fe(),
    InputProps: {
      ref: cr,
      className: o.inputRoot,
      startAdornment: Me,
      endAdornment: /* @__PURE__ */ g.createElement("div", {
        className: o.endAdornment
      }, Bt ? /* @__PURE__ */ g.createElement(Yn, M({}, Wt(), {
        "aria-label": l,
        title: l,
        className: be(o.clearIndicator, Re && o.clearIndicatorDirty)
      }), c) : null, Ht ? /* @__PURE__ */ g.createElement(Yn, M({}, ft(), {
        disabled: b,
        "aria-label": Ie ? p : L,
        title: Ie ? p : L,
        className: be(o.popupIndicator, Ie && o.popupIndicatorOpen)
      }), Ft) : null)
    },
    inputProps: M({
      className: be(o.input, Ot === -1 && o.inputFocused),
      disabled: b
    }, we())
  })), Ie && Je ? /* @__PURE__ */ g.createElement(We, {
    className: be(o.popper, I && o.popperDisablePortal),
    style: {
      width: Je ? Je.clientWidth : null
    },
    role: "presentation",
    anchorEl: Je,
    open: !0
  }, /* @__PURE__ */ g.createElement(P, {
    className: o.paper
  }, A && Xe.length === 0 ? /* @__PURE__ */ g.createElement("div", {
    className: o.loading
  }, j) : null, Xe.length === 0 && !z && !A ? /* @__PURE__ */ g.createElement("div", {
    className: o.noOptions
  }, H) : null, Xe.length > 0 ? /* @__PURE__ */ g.createElement(xe, M({
    className: o.listbox
  }, Ce(), w), Xe.map(function(oe, se) {
    return Z ? Lr({
      key: oe.key,
      group: oe.group,
      children: oe.options.map(function(Qe, Ue) {
        return Ze(Qe, oe.index + Ue);
      })
    }) : Ze(oe, se);
  })) : null)) : null);
});
process.env.NODE_ENV !== "production" && (za.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */
  autoComplete: d.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   */
  autoHighlight: d.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */
  autoSelect: d.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   */
  blurOnSelect: d.oneOfType([d.oneOf(["mouse", "touch"]), d.bool]),
  /**
   * Props applied to the [`Chip`](/api/chip/) element.
   */
  ChipProps: d.object,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: d.object,
  /**
   * @ignore
   */
  className: d.string,
  /**
   * If `true`, the input's text will be cleared on blur if no value is selected.
   *
   * Set to `true` if you want to help the user enter a new value.
   * Set to `false` if you want to help the user resume his search.
   */
  clearOnBlur: d.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */
  clearOnEscape: d.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  clearText: d.string,
  /**
   * The icon to display in place of the default close icon.
   */
  closeIcon: d.node,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: d.string,
  /**
   * If `true`, the popup will ignore the blur event if the input is filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */
  debug: d.bool,
  /**
   * The default input value. Use when the component is not controlled.
   */
  defaultValue: d.any,
  /**
   * If `true`, the input can't be cleared.
   */
  disableClearable: d.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   */
  disableCloseOnSelect: d.bool,
  /**
   * If `true`, the input will be disabled.
   */
  disabled: d.bool,
  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: d.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   */
  disableListWrap: d.bool,
  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: d.bool,
  /**
   * A filter function that determines the options that are eligible.
   *
   * @param {T[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {T[]}
   */
  filterOptions: d.func,
  /**
   * If `true`, hide the selected options from the list box.
   */
  filterSelectedOptions: d.bool,
  /**
   * Force the visibility display of the popup icon.
   */
  forcePopupIcon: d.oneOfType([d.oneOf(["auto"]), d.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */
  freeSolo: d.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: d.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   */
  getLimitTagsText: d.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {T} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: d.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * @param {T} option
   * @returns {string}
   */
  getOptionLabel: d.func,
  /**
   * Used to determine if an option is selected, considering the current value.
   * Uses strict equality by default.
   *
   * @param {T} option The option to test.
   * @param {T} value The value to test against.
   * @returns {boolean}
   */
  getOptionSelected: d.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {T} options The options to group.
   * @returns {string}
   */
  groupBy: d.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   */
  handleHomeEndKeys: d.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: d.string,
  /**
   * If `true`, the highlight can move to the input.
   */
  includeInputInList: d.bool,
  /**
   * The input value.
   */
  inputValue: d.string,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   */
  limitTags: d.number,
  /**
   * The component used to render the listbox.
   */
  ListboxComponent: d.elementType,
  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: d.object,
  /**
   * If `true`, the component is in a loading state.
   */
  loading: d.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  loadingText: d.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: d.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  noOptionsText: d.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T|T[]} value The new value of the component.
   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
   */
  onChange: d.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"select-option"`, `"blur"`.
   */
  onClose: d.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`.
   */
  onHighlightChange: d.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: d.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: d.func,
  /**
   * Control the popup` open state.
   */
  open: d.bool,
  /**
   * If `true`, the popup will open on input focus.
   */
  openOnFocus: d.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  openText: d.string,
  /**
   * Array of options.
   */
  options: d.array.isRequired,
  /**
   * The component used to render the body of the popup.
   */
  PaperComponent: d.elementType,
  /**
   * The component used to position the popup.
   */
  PopperComponent: d.elementType,
  /**
   * The icon to display in place of the default popup icon.
   */
  popupIcon: d.node,
  /**
   * Render the group.
   *
   * @param {any} option The group to render.
   * @returns {ReactNode}
   */
  renderGroup: d.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: d.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {T} option The option to render.
   * @param {object} state The state of the component.
   * @returns {ReactNode}
   */
  renderOption: d.func,
  /**
   * Render the selected value.
   *
   * @param {T[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @returns {ReactNode}
   */
  renderTags: d.func,
  /**
   * If `true`, the input's text will be selected on focus.
   * It helps the user clear the selected value.
   */
  selectOnFocus: d.bool,
  /**
   * The size of the autocomplete.
   */
  size: d.oneOf(["medium", "small"]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `getOptionSelected` prop.
   */
  value: d.any
});
const ad = Ke(rd, {
  name: "MuiAutocomplete"
})(za), $d = (t) => {
  const e = t.controllerName || t.name || t.id || ji, [n, r] = Zt(
    t.defaultValue || []
  ), { control: o } = Ai() || {};
  return /* @__PURE__ */ te(
    Di,
    {
      name: e,
      control: t.control || o,
      render: ({ field: i }) => /* @__PURE__ */ te(
        ad,
        {
          fullWidth: !0,
          multiple: !0,
          placeholder: t.placeholder,
          freeSolo: t.freeSolo,
          value: n,
          options: t.options,
          disableCloseOnSelect: !0,
          getOptionLabel: (a) => a.label,
          getOptionSelected: (a, s) => s.value === a.value,
          onChange: (a, s) => {
            const l = t.freeSolo ? s.map(
              (c) => typeof c == "object" ? c : {
                label: c,
                value: c
              }
            ) : s;
            r(l);
            const u = l.map(
              (c) => c.value
            );
            ((t == null ? void 0 : t.control) || o).setValues(
              e,
              u,
              {
                shouldValidate: !0,
                shouldDirty: !0,
                shouldTouch: !0
              }
            ), i.onChange(u);
          },
          renderOption: (a, { selected: s }) => /* @__PURE__ */ nt(ss, { children: [
            /* @__PURE__ */ te(ls, { style: { marginRight: 8 }, checked: s }),
            a.label
          ] }),
          renderInput: (a) => /* @__PURE__ */ te(
            Sn,
            qe(Te({}, a), {
              variant: "outlined",
              label: t.label,
              error: !!t.errorMessage,
              helperText: t.errorMessage ? t.errorMessage : t.helperText
            })
          )
        }
      )
    }
  );
};
function Vr({
  error: t,
  errorMessage: e,
  success: n,
  successMessage: r
}) {
  const o = t || e, i = (n || r) && !o, a = Xn(() => o ? "error" : i ? "success" : "default", [o, i]);
  return (n || r) && o && console.warn(
    'Component received both "success" and "error" props, falling back to error state.'
  ), { isError: o, isSuccess: i, color: a };
}
function ir(t, e) {
  Object.entries(e).forEach(
    ([n, r]) => t[n] = r
  );
}
function sd(t) {
  const {
    color: e,
    fontSize: n,
    className: r,
    children: o,
    // deprecated props:
    errorMessage: i,
    helperText: a
  } = t, s = o || i || a, l = i ? "error" : e;
  i && console.error(
    'HelperText: errorMessage prop is deprecated, please use color="error" instead'
  ), a && console.error(
    "HelperText: helperText prop is deprecated, please use children instead"
  );
  const u = Xn(
    () => kt(
      {
        "text-red-600 dark:text-red-400": l == "error",
        "text-green-600 dark:text-green-400": l == "success",
        "text-gray-500 dark:text-gray-400": l == "default",
        "text-xs": n !== "large",
        "text-sm": n == "large"
      },
      r
    ),
    [l, n, r]
  );
  return /* @__PURE__ */ te("div", { className: u, children: s });
}
function So(t) {
  const {
    fontSize: e = "medium",
    label: n,
    labelFor: r,
    error: o,
    errorMessage: i,
    success: a,
    successMessage: s,
    helperText: l,
    required: u,
    children: c
  } = t, { color: f } = Vr({
    error: o,
    errorMessage: i,
    success: a,
    successMessage: s
  }), p = i || s || l, h = Xn(
    () => kt(
      "rounded-t absolute text-sm duration-300 scale-75 z-10 origin-[0] bg-white dark:bg-stone-900 px-2 peer-focus:px-2  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-[1.5rem] peer-focus:scale-75  left-1",
      {
        "peer-focus:text-red-700 peer-focus:dark:text-red-600 text-red-600 dark:text-red-500": f == "error",
        "peer-focus:text-green-700 peer-focus:dark:text-green-600 text-green-600 dark:text-green-500": f == "success",
        "peer-focus:text-gray-600 peer-focus:dark:text-gray-500 text-gray-500 dark:text-gray-400": f == "default",
        "-translate-y-3 top-1 peer-focus:top-1 peer-focus:-translate-y-3": e == "small",
        "-translate-y-4 top-2 peer-focus:top-2 peer-focus:-translate-y-4": !e || e == "medium",
        "-translate-y-5 top-3 peer-focus:top-3 peer-focus:-translate-y-5": e == "large"
      }
    ),
    [f, e]
  );
  return /* @__PURE__ */ nt("div", { className: "w-full pt-1.5", children: [
    /* @__PURE__ */ nt("div", { className: "relative", children: [
      c,
      n ? /* @__PURE__ */ nt("label", { htmlFor: r, className: h, children: [
        n,
        u ? " *" : null
      ] }) : null
    ] }),
    p ? /* @__PURE__ */ te(sd, { className: "mt-2", color: f, children: p }) : null
  ] });
}
const Ad = (t) => {
  const v = t, {
    fontSize: e,
    label: n,
    error: r,
    errorMessage: o,
    success: i,
    successMessage: a,
    helperText: s,
    control: l
  } = v, u = Ct(v, [
    "fontSize",
    "label",
    "error",
    "errorMessage",
    "success",
    "successMessage",
    "helperText",
    // deprecated props
    "control"
  ]);
  u.id || (u.id = Math.random().toString(36).substr(2, 6));
  const { color: c } = Vr({
    error: r,
    errorMessage: o,
    success: i,
    successMessage: a
  });
  if (l) {
    console.warn(
      'Deprecated use of `control`: please do not use control, inject the proper fields like this: `<TextField {...register("foo")} />`.'
    );
    const m = l.register(u.name || u.id);
    ir(u, m);
  }
  const f = {
    fontSize: e,
    error: r,
    errorMessage: o,
    success: i,
    successMessage: a,
    helperText: s
  }, p = kt(
    "bg-gray-100 border-gray-300 rounded dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600",
    {
      "w-3 h-3": e == "small",
      "w-4 h-4": !e || e == "medium",
      "w-5 h-5": e == "large",
      "text-green-600 focus:ring-green-500 dark:focus:ring-green-600": c == "success",
      "text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600": !c || c == "default",
      "text-red-600 focus:ring-red-500 dark:focus:ring-red-600": c == "error"
    }
  ), h = kt("text-gray-900 dark:text-gray-300", {
    "ml-1 text-xs": e == "small",
    "ml-2 text-sm": !e || e == "medium",
    "ml-3": e == "large"
  });
  return /* @__PURE__ */ te(So, qe(Te({}, f), { children: /* @__PURE__ */ nt("div", { className: "flex items-center", children: [
    /* @__PURE__ */ te("input", qe(Te({}, u), { type: "checkbox", className: p })),
    /* @__PURE__ */ te(
      "label",
      {
        htmlFor: u.id || u.name,
        className: h,
        children: n
      }
    )
  ] }) }));
};
var kr = /* @__PURE__ */ ((t) => (t.IMAGES = "IMAGES", t.DOCS = "DOCS", t))(kr || {});
const ld = lt(/* @__PURE__ */ g.createElement("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), ud = lt(/* @__PURE__ */ g.createElement("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), cd = lt(/* @__PURE__ */ g.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), fd = lt(/* @__PURE__ */ g.createElement("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");
var dd = function(e) {
  var n = e.palette.type === "light" ? Or : Rr, r = e.palette.type === "light" ? Rr : Or;
  return {
    /* Styles applied to the root element. */
    root: M({}, e.typography.body2, {
      borderRadius: e.shape.borderRadius,
      backgroundColor: "transparent",
      display: "flex",
      padding: "6px 16px"
    }),
    /* Styles applied to the root element if `variant="standard"` and `color="success"`. */
    standardSuccess: {
      color: n(e.palette.success.main, 0.6),
      backgroundColor: r(e.palette.success.main, 0.9),
      "& $icon": {
        color: e.palette.success.main
      }
    },
    /* Styles applied to the root element if `variant="standard"` and `color="info"`. */
    standardInfo: {
      color: n(e.palette.info.main, 0.6),
      backgroundColor: r(e.palette.info.main, 0.9),
      "& $icon": {
        color: e.palette.info.main
      }
    },
    /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */
    standardWarning: {
      color: n(e.palette.warning.main, 0.6),
      backgroundColor: r(e.palette.warning.main, 0.9),
      "& $icon": {
        color: e.palette.warning.main
      }
    },
    /* Styles applied to the root element if `variant="standard"` and `color="error"`. */
    standardError: {
      color: n(e.palette.error.main, 0.6),
      backgroundColor: r(e.palette.error.main, 0.9),
      "& $icon": {
        color: e.palette.error.main
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */
    outlinedSuccess: {
      color: n(e.palette.success.main, 0.6),
      border: "1px solid ".concat(e.palette.success.main),
      "& $icon": {
        color: e.palette.success.main
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */
    outlinedInfo: {
      color: n(e.palette.info.main, 0.6),
      border: "1px solid ".concat(e.palette.info.main),
      "& $icon": {
        color: e.palette.info.main
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
    outlinedWarning: {
      color: n(e.palette.warning.main, 0.6),
      border: "1px solid ".concat(e.palette.warning.main),
      "& $icon": {
        color: e.palette.warning.main
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */
    outlinedError: {
      color: n(e.palette.error.main, 0.6),
      border: "1px solid ".concat(e.palette.error.main),
      "& $icon": {
        color: e.palette.error.main
      }
    },
    /* Styles applied to the root element if `variant="filled"` and `color="success"`. */
    filledSuccess: {
      color: "#fff",
      fontWeight: e.typography.fontWeightMedium,
      backgroundColor: e.palette.success.main
    },
    /* Styles applied to the root element if `variant="filled"` and `color="info"`. */
    filledInfo: {
      color: "#fff",
      fontWeight: e.typography.fontWeightMedium,
      backgroundColor: e.palette.info.main
    },
    /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */
    filledWarning: {
      color: "#fff",
      fontWeight: e.typography.fontWeightMedium,
      backgroundColor: e.palette.warning.main
    },
    /* Styles applied to the root element if `variant="filled"` and `color="error"`. */
    filledError: {
      color: "#fff",
      fontWeight: e.typography.fontWeightMedium,
      backgroundColor: e.palette.error.main
    },
    /* Styles applied to the icon wrapper element. */
    icon: {
      marginRight: 12,
      padding: "7px 0",
      display: "flex",
      fontSize: 22,
      opacity: 0.9
    },
    /* Styles applied to the message wrapper element. */
    message: {
      padding: "8px 0"
    },
    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: "flex",
      alignItems: "center",
      marginLeft: "auto",
      paddingLeft: 16,
      marginRight: -8
    }
  };
}, ki = {
  success: /* @__PURE__ */ g.createElement(ld, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ g.createElement(ud, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ g.createElement(cd, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ g.createElement(fd, {
    fontSize: "inherit"
  })
}, pd = /* @__PURE__ */ g.createElement(Fa, {
  fontSize: "small"
}), Wa = /* @__PURE__ */ g.forwardRef(function(e, n) {
  var r = e.action, o = e.children, i = e.classes, a = e.className, s = e.closeText, l = s === void 0 ? "Close" : s, u = e.color, c = e.icon, f = e.iconMapping, p = f === void 0 ? ki : f, h = e.onClose, v = e.role, m = v === void 0 ? "alert" : v, S = e.severity, b = S === void 0 ? "success" : S, T = e.variant, I = T === void 0 ? "standard" : T, k = Se(e, ["action", "children", "classes", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant"]);
  return /* @__PURE__ */ g.createElement(Na, M({
    role: m,
    square: !0,
    elevation: 0,
    className: be(i.root, i["".concat(I).concat(Ne(u || b))], a),
    ref: n
  }, k), c !== !1 ? /* @__PURE__ */ g.createElement("div", {
    className: i.icon
  }, c || p[b] || ki[b]) : null, /* @__PURE__ */ g.createElement("div", {
    className: i.message
  }, o), r != null ? /* @__PURE__ */ g.createElement("div", {
    className: i.action
  }, r) : null, r == null && h ? /* @__PURE__ */ g.createElement("div", {
    className: i.action
  }, /* @__PURE__ */ g.createElement(Yn, {
    size: "small",
    "aria-label": l,
    title: l,
    color: "inherit",
    onClick: h
  }, pd)) : null);
});
process.env.NODE_ENV !== "production" && (Wa.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: d.node,
  /**
   * The content of the component.
   */
  children: d.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: d.object,
  /**
   * @ignore
   */
  className: d.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: d.string,
  /**
   * The main color for the alert. Unless provided, the value is taken from the `severity` prop.
   */
  color: d.oneOf(["error", "info", "success", "warning"]),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   */
  icon: d.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: d.shape({
    error: d.node,
    info: d.node,
    success: d.node,
    warning: d.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: d.func,
  /**
   * The ARIA role attribute of the element.
   */
  role: d.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   */
  severity: d.oneOf(["error", "info", "success", "warning"]),
  /**
   * The variant to use.
   */
  variant: d.oneOf(["filled", "outlined", "standard"])
});
const Mi = Ke(dd, {
  name: "MuiAlert"
})(Wa);
var wo = {}, Kn = {}, hd = {
  get exports() {
    return Kn;
  },
  set exports(t) {
    Kn = t;
  }
};
(function(t) {
  function e(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(hd);
var Gn = {}, vd = {
  get exports() {
    return Gn;
  },
  set exports(t) {
    Gn = t;
  }
}, Jn = {}, gd = {
  get exports() {
    return Jn;
  },
  set exports(t) {
    Jn = t;
  }
};
(function(t) {
  function e(n) {
    "@babel/helpers - typeof";
    return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(gd);
(function(t) {
  var e = Jn.default;
  function n(o) {
    if (typeof WeakMap != "function")
      return null;
    var i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
    return (n = function(l) {
      return l ? a : i;
    })(o);
  }
  function r(o, i) {
    if (!i && o && o.__esModule)
      return o;
    if (o === null || e(o) !== "object" && typeof o != "function")
      return {
        default: o
      };
    var a = n(i);
    if (a && a.has(o))
      return a.get(o);
    var s = {}, l = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var u in o)
      if (u !== "default" && Object.prototype.hasOwnProperty.call(o, u)) {
        var c = l ? Object.getOwnPropertyDescriptor(o, u) : null;
        c && (c.get || c.set) ? Object.defineProperty(s, u, c) : s[u] = o[u];
      }
    return s.default = o, a && a.set(o, s), s;
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(vd);
var En = {};
const md = /* @__PURE__ */ hs(Xf);
var $i;
function yd() {
  return $i || ($i = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return e.createSvgIcon;
      }
    });
    var e = md;
  }(En)), En;
}
var bd = Kn, xd = Gn;
Object.defineProperty(wo, "__esModule", {
  value: !0
});
var Ua = wo.default = void 0, Ed = xd(he), Sd = bd(yd()), wd = (0, Sd.default)(/* @__PURE__ */ Ed.createElement("path", {
  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
}), "PictureAsPdf");
Ua = wo.default = wd;
const Od = (t) => {
  const e = "https://via.placeholder.com/200", n = t.filesType || kr.IMAGES, r = (o) => {
    let i = o;
    return o === t.defaultValue && (i = e), i;
  };
  return n === kr.DOCS ? t.inputValue === t.defaultValue ? /* @__PURE__ */ te(
    "img",
    {
      src: e,
      className: "object-cover w-full h-64 mx-auto mb-2 rounded large",
      alt: t.fileName
    }
  ) : /* @__PURE__ */ te(
    "a",
    {
      href: t.inputValue,
      download: t.fileName,
      target: "_blank",
      rel: "noreferrer",
      children: /* @__PURE__ */ nt("figure", { className: "relative p-20 mb-2 border rounded", children: [
        /* @__PURE__ */ te(
          Ua,
          {
            style: {
              fontSize: 86
            },
            color: "secondary",
            className: "object-cover w-full h-64 mx-auto mb-2 rounded large"
          }
        ),
        /* @__PURE__ */ te("figcaption", { className: "absolute bottom-0 left-0 right-0 p-2 text-sm text-white break-words bg-black bg-opacity-75 rounded-b", children: t.fileName })
      ] })
    }
  ) : /* @__PURE__ */ te(
    "img",
    {
      src: r(t.inputValue),
      className: "object-cover w-full h-64 mx-auto mb-2 rounded large",
      alt: t.fileName
    }
  );
}, Dd = (t) => {
  const { control: e } = Ai() || {}, n = {
    id: t.id || t.name || t.controllerName || ji(),
    label: t.label,
    InputLabelProps: {
      shrink: !0
    }
  }, r = "__DEFAULT_IMAGE__", o = t.controllerName || t.name || t.id, i = t.filesType || kr.IMAGES, [a, s] = Zt(
    t.defaultValue || r
  ), [l, u] = Zt(
    (t == null ? void 0 : t.defaultValue).split("/").pop() || ""
  ), [c, f] = Zt(null), [p, h] = Zt(null), v = (_) => {
    s(_), t.setValue(o, _);
  }, m = (_) => {
    const D = t.maxFileSize * 1048576;
    return _ > D ? (f(`Tamanho máximo permitido de ${t.maxFileSize}Mb`), !1) : (f(null), !0);
  }, S = (_) => {
    const z = t.accept;
    return z.includes(_) ? (h(null), !0) : (h(`Só são permitidos arquivos dos tipos ${z}`), !1);
  }, b = () => {
    v(r);
  }, T = () => {
    const _ = document.createElement("input");
    _.type = "file", _.accept = (t == null ? void 0 : t.accept) || "", _.onchange = (z) => {
      const W = z == null ? void 0 : z.target.files[0];
      if (t.maxFileSize && !m(W.size) || t.accept && !S(W == null ? void 0 : W.type.split("/").pop()))
        return;
      const D = new FileReader();
      D.readAsDataURL(W), D.onload = () => {
        u(W.name), v(D.result);
      }, D.onerror = function(J) {
        console.log("Error: ", J);
      };
    }, _.click();
  }, y = t, { errorMessage: I } = y, k = Ct(y, ["errorMessage"]);
  return I && (n.error = !0, n.helperText = I), e || t.control ? /* @__PURE__ */ te(
    Di,
    {
      name: o,
      control: e || t.control,
      defaultValue: t.defaultValue || null,
      render: ({ field: _ }) => /* @__PURE__ */ nt(us, { className: "text-center", children: [
        /* @__PURE__ */ te(cs, { className: "mb-2", children: n.label }),
        /* @__PURE__ */ te(
          Od,
          {
            inputValue: a,
            defaultValue: r,
            filesType: i,
            fileName: l
          }
        ),
        /* @__PURE__ */ te(
          Sn,
          Te(Te(Te({
            style: { display: "none" }
          }, _), k), n)
        ),
        /* @__PURE__ */ nt(Wr, { container: !0, spacing: 1, children: [
          /* @__PURE__ */ te(Wr, { item: !0, xs: 6, children: /* @__PURE__ */ te(
            Mo,
            {
              fullWidth: !0,
              onClick: b,
              disabled: a === r,
              children: "Remover"
            }
          ) }),
          /* @__PURE__ */ te(Wr, { item: !0, xs: 6, children: /* @__PURE__ */ te(Mo, { color: "secondary", fullWidth: !0, onClick: T, children: "Enviar" }) })
        ] }),
        c ? /* @__PURE__ */ te(Mi, { severity: "error", className: "mt-3", children: c }) : null,
        p ? /* @__PURE__ */ te(Mi, { severity: "error", className: "mt-3", children: p }) : null
      ] })
    }
  ) : /* @__PURE__ */ te(Sn, qe(Te(Te({}, t), n), { variant: "outlined", fullWidth: !0 }));
}, jd = (t) => /* @__PURE__ */ te(fs, Te({ variant: "contained", size: "medium" }, t)), Vd = (n) => {
  var r = n, {
    children: t
  } = r, e = Ct(r, [
    "children"
  ]);
  return /* @__PURE__ */ te("option", qe(Te({}, e), { children: t }));
}, Ld = (t) => {
  const m = t, {
    fontSize: e,
    label: n,
    error: r,
    errorMessage: o,
    success: i,
    successMessage: a,
    helperText: s,
    children: l,
    control: u,
    size: c,
    inputProps: f
  } = m, p = Ct(m, [
    "fontSize",
    "label",
    "error",
    "errorMessage",
    "success",
    "successMessage",
    "helperText",
    "children",
    // deprecated props
    "control",
    "size",
    "inputProps"
  ]), { color: h } = Vr({
    error: r,
    errorMessage: o,
    success: i,
    successMessage: a
  });
  if (u) {
    console.warn(
      'Deprecated use of `control`: please do not use control, inject the proper fields like this: `<TextField {...register("foo")} />`.'
    );
    const S = u.register(
      p.name || p.id
    );
    ir(p, S);
  }
  f && (console.warn(
    'Deprecated use of `inputProps`: please inject the input props directly in the component: `<SelectField multiple placeholder="Enter a number" />`.'
  ), ir(p, f));
  const v = {
    fontSize: e,
    label: n,
    error: r,
    errorMessage: o,
    success: i,
    successMessage: a,
    helperText: s,
    labelFor: p.id || p.name,
    required: p.required
  };
  return c && (typeof c == "string" ? (console.warn(
    'Deprecated use of `size` with a string with the font size: please use the `fontSize` attribute: `<SelectField fontSize="small" />`.'
  ), v.fontSize = c) : p.size = c), p.className = kt(
    "appearance-none block w-full bg-white dark:bg-stone-900 dark:text-stone-300 rounded-md border px-2.5 text-gray-900 shadow-sm focus:ring-0 text-sm",
    {
      "border-gray-300 dark:border-gray-600 dark:focus:border-gray-500 focus:border-gray-600": h == "default",
      "border-red-600 dark:border-red-500 dark:focus:border-red-500 focus:border-red-600": h == "error",
      "border-green-600 dark:border-green-500 dark:focus:border-green-500 focus:border-green-600": h == "success",
      "py-1.5": !n && e == "small",
      "py-2.5": !n && (!e || e == "medium"),
      "py-3.5": !n && e == "large",
      "pt-3 pb-1.5": n && e == "small",
      "pt-4 pb-2.5": n && (!e || e == "medium"),
      "pt-5 pb-3.5": n && e == "large"
    },
    p.className
  ), /* @__PURE__ */ te(So, qe(Te({}, v), { children: /* @__PURE__ */ te("select", qe(Te({}, p), { children: l })) }));
};
function Fd(t) {
  const k = t, {
    fontSize: e,
    label: n,
    error: r,
    errorMessage: o,
    success: i,
    successMessage: a,
    helperText: s,
    multiline: l,
    children: u,
    className: c,
    control: f,
    transform: p,
    size: h,
    rowsMax: v,
    InputProps: m,
    inputProps: S
  } = k, b = Ct(k, [
    "fontSize",
    "label",
    "error",
    "errorMessage",
    "success",
    "successMessage",
    "helperText",
    "multiline",
    "children",
    "className",
    // deprecated props
    "control",
    "transform",
    "size",
    "rowsMax",
    "InputProps",
    "inputProps"
  ]), { color: T } = Vr({
    error: r,
    errorMessage: o,
    success: i,
    successMessage: a
  });
  if (v && console.warn(
    "Deprecated use of `rowsMax`. This attribute is no longer supported, please remove it."
  ), m && console.warn(
    "Deprecated use of `InputProps`. This attribute is no longer supported, please remove it."
  ), f) {
    console.warn(
      'Deprecated use of `control`: please do not use control, inject the proper fields like this: `<TextField {...register("foo")} />`.'
    );
    const y = f.register(
      b.name || b.id
    );
    ir(b, y);
  }
  const I = {
    fontSize: e,
    label: n,
    error: r,
    errorMessage: o,
    success: i,
    successMessage: a,
    helperText: s,
    labelFor: b.id || b.name,
    required: b.required
  };
  if (b.className = kt(
    c,
    "block px-2.5 w-full text-sm text-gray-900 disabled:text-gray-400 read-only:text-gray-400 bg-transparent rounded-lg border appearance-none dark:text-white focus:outline-none focus:ring-0 peer bg-white dark:bg-stone-900 dark:text-stone-300",
    {
      "border-gray-300 dark:border-gray-600 dark:focus:border-gray-500 focus:border-gray-600": T == "default",
      "border-red-600 dark:border-red-500 dark:focus:border-red-500 focus:border-red-600": T == "error",
      "border-green-600 dark:border-green-500 dark:focus:border-green-500 focus:border-green-600": T == "success",
      "pb-1.5 pt-3": n && e == "small",
      "pb-2.5 pt-4": n && (!e || e == "medium"),
      "pb-3.5 pt-5": n && e == "large",
      "py-1.5": !n && e == "small",
      "py-2.5": !n && (!e || e == "medium"),
      "py-3.5": !n && e == "large"
    }
  ), h && (typeof h == "string" ? (console.warn(
    'Deprecated use of `size` with a string with the font size: please use the `fontSize` attribute: `<TextField fontSize="small" />`.'
  ), I.fontSize = h) : b.size = h), S && (console.warn(
    'Deprecated use of `inputProps`: please inject the input props directly in the component: `<TextField type="number" placeholder="Enter a number" />`.'
  ), ir(b, S)), p) {
    console.warn(
      'Deprecated use of `transform`: please deal with this behavior inside the form library. For example, using react-hook-form: `<TextField {...register("foo", { setValueAs: (v) => v?.toUpperCase() })} />`'
    );
    const y = b.onKeyUp;
    b.onKeyUp = (_) => {
      const z = _.currentTarget.value;
      _.currentTarget.value = p.input(z) || "", y && y(_);
    };
  }
  return u && console.error("TextField does not support children.", u), b.placeholder === void 0 && (b.placeholder = ""), /* @__PURE__ */ te(So, qe(Te({}, I), { children: l ? /* @__PURE__ */ te(
    "textarea",
    Te({}, b)
  ) : /* @__PURE__ */ te(
    "input",
    Te({}, b)
  ) }));
}
export {
  $d as A,
  Ad as C,
  Dd as F,
  sd as H,
  jd as I,
  Vd as S,
  Fd as T,
  kr as a,
  Od as b,
  Ld as c
};
